// Components bundle — 16 component(s) materialized from a .fig as one
// self-contained file: no imports/exports; every component is assigned to window below.
// Design tokens / typography still ship separately (fig-tokens.css / fig-typography.css).

// figma node: 271:23164 トップ
function Component22__(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: "fit-content",
      display: "flex",
      flexDirection: "column",
      gap: 9,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 46,
      lineHeight: "100%",
      letterSpacing: "0.100em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch",
      whiteSpace: "pre-wrap"
    }
  }, props.text1 ?? "BRAND\nCONCEPT"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 13,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, props.text2 ?? "ブランドコンセプト"));
}

// figma node: 271:23213 BASE
function BASE14(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 390,
      height: 290,
      position: "relative",
      color: "rgb(249,249,249)",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 290
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 125,
      top: 24,
      width: 140,
      height: 237
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 39,
      top: 32,
      width: 60,
      height: 30,
      fontFamily: "Selna, \"Marcellus\", serif",
      fontWeight: 400,
      fontSize: 28,
      textAlign: "center",
      whiteSpace: "pre-wrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(249,249,249)",
      display: "inline-block"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "rgb(249,249,249)",
      fontSize: 24
    }
  }, "Q"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 22
    }
  }, "&"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 24
    }
  }, "A")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 2,
      top: 187,
      width: 135,
      height: 26,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 18,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(249,249,249)"
    }
  }, props.text1 ?? "よくあるご質問")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 173,
      top: 126.875,
      width: 44,
      height: 49,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 43.999,
    height: 49.000,
    viewBox: "0 0 43.999 49.000",
    fill: "none",
    style: {
      position: "absolute",
      left: -0.001,
      top: 0,
      width: 43.999,
      height: 49
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.536 1.327 C 24.018 -0.667 18.051 -0.406 12.733 2.059 C 7.413 4.526 3.38 8.9 1.373 14.382 C -0.64 19.878 -0.434 25.783 1.951 31.01 C 4.235 36.012 8.285 39.868 13.408 41.94 L 9.592 48.28 L 10.803 49 L 15.488 41.216 L 14.687 40.928 C 9.547 39.071 5.48 35.342 3.239 30.432 C 1.006 25.542 0.814 20.013 2.699 14.862 C 4.576 9.733 8.353 5.639 13.329 3.332 C 18.305 1.024 23.891 0.78 29.053 2.645 C 39.708 6.494 45.226 18.238 41.351 28.826 C 39.011 35.213 33.648 40.014 27.001 41.668 L 27.343 43.028 C 34.444 41.261 40.177 36.133 42.675 29.305 C 46.815 17.994 40.922 5.443 29.533 1.327 L 29.536 1.327 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 1.925,
    height: 2.417,
    viewBox: "0 0 1.925 2.417",
    fill: "none",
    style: {
      position: "absolute",
      left: 20.977,
      top: 28.789,
      width: 1.925,
      height: 2.417
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.925 0 L 0 0 L 0 2.417 L 1.925 2.417 L 1.925 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 10.517,
    height: 13.277,
    viewBox: "0 0 10.517 13.277",
    fill: "none",
    style: {
      position: "absolute",
      left: 16.969,
      top: 13.083,
      width: 10.517,
      height: 13.277
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.517 4.739 C 10.517 4.13 10.424 3.555 10.237 3.017 C 10.051 2.479 9.76 1.999 9.362 1.579 C 8.865 1.012 8.253 0.606 7.525 0.365 C 6.797 0.123 6.026 0 5.216 0 C 4.553 0 3.898 0.101 3.249 0.303 C 2.6 0.505 2.029 0.827 1.541 1.27 C 1.053 1.691 0.683 2.21 0.429 2.832 C 0.175 3.455 0.034 4.088 0 4.739 L 1.888 4.739 C 1.888 4.327 1.953 3.937 2.08 3.567 C 2.21 3.197 2.413 2.88 2.695 2.616 C 2.986 2.319 3.35 2.1 3.793 1.957 C 4.237 1.814 4.714 1.741 5.227 1.741 C 5.741 1.741 6.249 1.814 6.729 1.963 C 7.209 2.111 7.615 2.386 7.945 2.79 C 8.16 3.028 8.321 3.312 8.422 3.642 C 8.527 3.97 8.578 4.346 8.578 4.764 C 8.578 5.182 8.524 5.583 8.417 5.961 C 8.309 6.34 8.095 6.713 7.77 7.083 C 7.415 7.461 7.037 7.79 6.641 8.064 C 6.243 8.339 5.862 8.631 5.498 8.939 C 5.134 9.248 4.826 9.637 4.578 10.106 C 4.313 10.599 4.149 11.09 4.087 11.581 C 4.025 12.071 3.994 12.635 3.994 13.277 L 5.93 13.277 C 5.93 12.733 5.941 12.287 5.961 11.931 C 5.981 11.578 6.099 11.202 6.314 10.809 C 6.489 10.49 6.737 10.19 7.065 9.915 C 7.392 9.64 7.734 9.371 8.089 9.113 C 8.445 8.855 8.764 8.572 9.046 8.269 C 9.509 7.801 9.87 7.265 10.127 6.665 C 10.384 6.065 10.511 5.423 10.511 4.742 L 10.517 4.739 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

// figma node: 271:23191 BASEBG
function BASEBG14(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 480,
      height: 400,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 480,
      height: 400,
      clipPath: "inset(0px 0px 0px 0px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: -1087.706,
      width: 1440,
      height: 1524.706,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 1524.7059326171875,
      clipPath: "inset(0px 0px 0px 0px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fig-asset-2c93637f5cfae14f",
    style: {
      position: "absolute",
      left: -640,
      top: -400.234,
      width: 1759.765,
      height: 3129.883
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "fig-asset-2c93637f5cfae14f",
    style: {
      position: "absolute",
      left: -493,
      top: -122.294,
      width: 1458,
      height: 2592
    }
  })))));
}

// figma node: 271:23236 Component 32 (2 variants)
const __venc_Component32_ = v => String(v).replace(/[%|=]/g, encodeURIComponent);
const __vkey_Component32_ = p => "prop=" + __venc_Component32_(p.prop);
function Component32_(_p = {}) {
  const props = {
    ..._p,
    prop: _p.prop ?? "デフォルト"
  };
  const __body0 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 480,
      height: 400,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement(BASEBG14, {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 480,
      height: 400
    }
  }), /*#__PURE__*/React.createElement(BASE14, {
    style: {
      position: "absolute",
      left: 45,
      top: 55,
      width: 390,
      height: 290
    }
  }));
  const __impls = {
    // figma: プロパティ1=デフォルト
    "prop=デフォルト": __body0,
    // figma: プロパティ1=バリアント2
    "prop=バリアント2": __body0
  };
  return (__impls[__vkey_Component32_(props)] ?? __body0)();
}

// figma node: 271:23202 BASE
function BASE13(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 390,
      height: 290,
      position: "relative",
      color: "rgb(249,249,249)",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: -20,
      width: 390,
      height: 290
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 125,
      top: 24,
      width: 140,
      height: 237
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 1,
      top: 32,
      width: 137,
      height: 30,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 24,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.160em",
      color: "rgb(249,249,249)"
    }
  }, props.text1 ?? "CONTACT"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 11,
      top: 187,
      width: 116,
      height: 26,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 18,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(249,249,249)"
    }
  }, props.text2 ?? "お問い合わせ")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 170,
      top: 130,
      width: 50,
      height: 42,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 5.335,
    height: 3.495,
    viewBox: "0 0 5.335 3.495",
    fill: "none",
    style: {
      position: "absolute",
      left: 30.022,
      top: 35.407,
      width: 5.335,
      height: 3.495
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.864 C 1.44 2.124 3.187 3.034 5.053 3.495 L 5.335 2.377 C 3.648 1.961 2.071 1.138 0.771 0 L 0 0.864 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 11.473,
    height: 26.454,
    viewBox: "0 0 11.473 26.454",
    fill: "none",
    style: {
      position: "absolute",
      left: 38.528,
      top: 15.541,
      width: 11.473,
      height: 26.454
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.724 7.796 C 9.072 3.306 4.888 0.247 0.061 0 L 0 1.15 C 4.357 1.371 8.136 4.133 9.627 8.188 C 11.703 13.832 8.93 19.833 3.315 21.851 L 2.654 22.089 L 5.296 26.454 L 6.295 25.862 L 4.368 22.676 C 7.064 21.529 9.191 19.474 10.407 16.824 C 11.71 13.984 11.821 10.777 10.724 7.791 L 10.724 7.796 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.319,
    height: 40.249,
    viewBox: "0 0 36.319 40.249",
    fill: "none",
    style: {
      position: "absolute",
      left: -0.001,
      top: 0,
      width: 36.319,
      height: 40.249
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.38 1.081 C 14.979 -2.299 4.551 2.514 1.133 11.807 C -0.528 16.323 -0.358 21.174 1.611 25.468 C 3.496 29.578 6.837 32.746 11.068 34.449 L 7.918 39.657 L 8.917 40.249 L 12.785 33.854 L 12.123 33.617 C 7.88 32.092 4.523 29.028 2.673 24.994 C 0.83 20.976 0.672 16.433 2.228 12.201 C 5.427 3.504 15.187 -1 23.982 2.164 C 32.777 5.327 37.331 14.975 34.133 23.674 C 32.201 28.922 27.775 32.866 22.288 34.225 L 22.57 35.342 C 28.432 33.891 33.163 29.677 35.225 24.068 C 38.643 14.774 33.778 4.463 24.378 1.081 L 24.38 1.081 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 18.182,
    height: 1.152,
    viewBox: "0 0 18.182 1.152",
    fill: "none",
    style: {
      position: "absolute",
      left: 9.58,
      top: 14.302,
      width: 18.182,
      height: 1.152
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.182 0 L 0 0 L 0 1.152 L 18.182 1.152 L 18.182 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 10.330,
    height: 1.152,
    viewBox: "0 0 10.330 1.152",
    fill: "none",
    style: {
      position: "absolute",
      left: 9.58,
      top: 21.144,
      width: 10.33,
      height: 1.152
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.33 0 L 0 0 L 0 1.152 L 10.33 1.152 L 10.33 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

// figma node: 271:23197 BASEBG
function BASEBG15(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 480,
      height: 400,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 480,
      height: 400,
      clipPath: "inset(0px 0px 0px 0px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: -1087.706,
      width: 1440,
      height: 1524.706,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 1524.7059326171875,
      clipPath: "inset(0px 0px 0px 0px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fig-asset-2c93637f5cfae14f",
    style: {
      position: "absolute",
      left: -973,
      top: -122.294,
      width: 1458,
      height: 2592
    }
  })))));
}

// figma node: 271:23243 Component 33 (2 variants)
const __venc_Component33_ = v => String(v).replace(/[%|=]/g, encodeURIComponent);
const __vkey_Component33_ = p => "prop=" + __venc_Component33_(p.prop);
function Component33_(_p = {}) {
  const props = {
    ..._p,
    prop: _p.prop ?? "デフォルト"
  };
  const __body0 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 480,
      height: 400,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement(BASEBG15, {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 480,
      height: 400
    }
  }), /*#__PURE__*/React.createElement(BASE13, {
    style: {
      position: "absolute",
      left: 45,
      top: 55,
      width: 390,
      height: 290
    }
  }));
  const __impls = {
    // figma: プロパティ1=デフォルト
    "prop=デフォルト": __body0,
    // figma: プロパティ1=バリアント2
    "prop=バリアント2": __body0
  };
  return (__impls[__vkey_Component33_(props)] ?? __body0)();
}

// figma node: 271:23721 footer
function Footer8(p) {
  /* 共通パーツへ委譲 → KEIKAFooterPC */
  var C = window.KEIKAFooterPC;
  if (!C) { console.error("[KEIKA] KEIKAFooterPC 未読込"); return null; }
  return React.createElement(C, p);
}
function Footer8Figma(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 1440,
      height: 616,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 616,
      backgroundColor: "rgb(227,226,222)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 51,
      top: 474,
      width: 249,
      height: 59,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 248.876,
    height: 27.434,
    viewBox: "0 0 248.876 27.434",
    fill: "none",
    style: {
      position: "absolute",
      left: 0.124,
      top: -0.005,
      width: 248.876,
      height: 27.434,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 248.876 26.515 C 248.876 26.755 248.785 26.967 248.608 27.15 C 248.441 27.318 248.236 27.405 247.992 27.405 C 247.749 27.405 247.543 27.318 247.362 27.15 C 247.195 26.972 247.109 26.76 247.109 26.515 C 247.109 26.269 247.195 26.053 247.362 25.88 C 247.529 25.711 247.739 25.625 247.992 25.625 C 248.245 25.625 248.436 25.716 248.608 25.894 C 248.785 26.062 248.876 26.269 248.876 26.515 Z M 240.69 18.388 L 237.801 18.388 L 237.801 17.46 L 244.888 17.46 L 244.888 18.388 L 241.96 18.388 L 241.96 27.265 L 240.69 27.265 L 240.69 18.388 Z M 232.853 27.429 C 232.084 27.429 231.42 27.294 230.861 27.025 C 230.307 26.755 229.849 26.39 229.486 25.932 C 229.118 25.466 228.851 24.941 228.669 24.354 C 228.502 23.772 228.416 23.171 228.416 22.55 C 228.416 21.877 228.516 21.232 228.712 20.611 C 228.908 19.981 229.194 19.423 229.567 18.927 C 229.949 18.432 230.427 18.042 231 17.753 C 231.568 17.465 232.232 17.32 232.977 17.32 C 233.287 17.32 233.626 17.359 233.994 17.441 C 234.367 17.513 234.725 17.624 235.064 17.777 C 235.403 17.931 235.68 18.133 235.895 18.384 L 235.198 19.163 C 235.031 18.966 234.816 18.802 234.558 18.677 C 234.3 18.542 234.028 18.441 233.741 18.369 C 233.464 18.297 233.201 18.263 232.953 18.263 C 232.437 18.263 231.984 18.384 231.587 18.629 C 231.196 18.865 230.866 19.182 230.599 19.586 C 230.331 19.991 230.126 20.443 229.982 20.948 C 229.849 21.453 229.782 21.963 229.782 22.483 C 229.782 23.291 229.911 23.994 230.169 24.585 C 230.427 25.167 230.794 25.625 231.267 25.947 C 231.74 26.26 232.299 26.418 232.939 26.418 C 233.311 26.418 233.717 26.365 234.157 26.255 C 234.596 26.144 235.045 25.976 235.508 25.745 L 235.924 26.515 C 235.728 26.659 235.499 26.789 235.241 26.904 C 234.992 27.01 234.725 27.106 234.438 27.188 C 234.161 27.27 233.884 27.328 233.607 27.361 C 233.34 27.405 233.092 27.429 232.858 27.429 L 232.853 27.429 Z M 220.412 17.46 L 226.257 17.46 L 226.257 18.388 L 221.844 18.388 L 221.844 21.771 L 225.269 21.771 L 225.269 22.685 L 221.844 22.685 L 221.844 26.337 L 226.257 26.337 L 226.257 27.265 L 220.603 27.265 L 220.603 18.345 L 220.416 17.455 L 220.412 17.46 Z M 211.199 17.46 L 215.449 24.046 C 215.531 24.172 215.617 24.306 215.703 24.451 C 215.793 24.585 215.879 24.715 215.97 24.84 C 215.96 24.686 215.951 24.537 215.941 24.383 C 215.932 24.22 215.927 24.071 215.927 23.926 L 215.927 17.46 L 216.944 17.46 L 216.944 27.333 L 216.156 27.333 L 211.194 19.683 C 211.123 19.567 211.041 19.447 210.955 19.317 C 210.874 19.182 210.788 19.057 210.702 18.942 C 210.721 19.086 210.731 19.235 210.731 19.384 C 210.74 19.529 210.745 19.673 210.745 19.817 L 210.745 27.265 L 209.728 27.265 L 209.728 18.345 L 209.542 17.455 L 211.199 17.455 L 211.199 17.46 Z M 200.315 17.46 L 204.565 24.046 C 204.646 24.172 204.732 24.306 204.818 24.451 C 204.909 24.585 204.995 24.715 205.086 24.84 L 205.057 24.383 C 205.048 24.22 205.043 24.071 205.043 23.926 L 205.043 17.46 L 206.06 17.46 L 206.06 27.333 L 205.272 27.333 L 200.31 19.683 C 200.238 19.567 200.157 19.447 200.071 19.317 C 199.99 19.182 199.904 19.057 199.818 18.942 C 199.837 19.086 199.847 19.235 199.847 19.384 C 199.856 19.529 199.861 19.673 199.861 19.817 L 199.861 27.265 L 198.844 27.265 L 198.844 18.345 L 198.657 17.455 L 200.315 17.455 L 200.315 17.46 Z M 191.417 26.5 C 191.986 26.5 192.463 26.38 192.85 26.135 C 193.232 25.894 193.542 25.567 193.772 25.163 C 194.006 24.759 194.168 24.316 194.268 23.83 C 194.374 23.344 194.431 22.858 194.431 22.377 C 194.431 21.896 194.378 21.405 194.268 20.924 C 194.168 20.438 194.006 20 193.772 19.606 C 193.538 19.202 193.227 18.879 192.836 18.634 C 192.454 18.393 191.981 18.268 191.417 18.268 C 190.854 18.268 190.381 18.388 189.984 18.634 C 189.602 18.874 189.292 19.202 189.063 19.606 C 188.838 20.01 188.676 20.452 188.566 20.938 C 188.466 21.424 188.418 21.91 188.418 22.391 C 188.418 22.873 188.466 23.363 188.566 23.844 C 188.671 24.321 188.838 24.759 189.063 25.163 C 189.297 25.567 189.602 25.889 189.984 26.135 C 190.376 26.375 190.854 26.5 191.417 26.5 Z M 191.403 27.414 C 190.682 27.414 190.047 27.28 189.502 27.01 C 188.967 26.741 188.523 26.37 188.165 25.904 C 187.807 25.427 187.539 24.888 187.363 24.287 C 187.186 23.686 187.095 23.046 187.095 22.372 C 187.095 21.699 187.181 21.059 187.348 20.457 C 187.525 19.846 187.792 19.307 188.151 18.841 C 188.509 18.364 188.958 17.994 189.502 17.725 C 190.047 17.455 190.682 17.32 191.412 17.32 C 192.143 17.32 192.778 17.455 193.313 17.725 C 193.858 17.994 194.307 18.364 194.665 18.841 C 195.023 19.307 195.286 19.846 195.453 20.457 C 195.63 21.059 195.72 21.699 195.72 22.372 C 195.72 23.046 195.63 23.686 195.453 24.297 C 195.276 24.898 195.009 25.432 194.65 25.899 C 194.292 26.365 193.843 26.736 193.299 27.005 C 192.764 27.275 192.129 27.41 191.398 27.41 L 191.403 27.414 Z M 182.052 27.429 C 181.283 27.429 180.619 27.294 180.06 27.025 C 179.506 26.755 179.048 26.39 178.685 25.932 C 178.317 25.466 178.05 24.941 177.868 24.354 C 177.701 23.772 177.615 23.171 177.615 22.55 C 177.615 21.877 177.715 21.232 177.911 20.611 C 178.107 19.981 178.393 19.423 178.766 18.927 C 179.148 18.432 179.626 18.042 180.199 17.753 C 180.767 17.465 181.431 17.32 182.176 17.32 C 182.486 17.32 182.825 17.359 183.193 17.441 C 183.566 17.513 183.924 17.624 184.263 17.777 C 184.602 17.931 184.879 18.133 185.094 18.384 L 184.397 19.163 C 184.23 18.966 184.015 18.802 183.757 18.677 C 183.499 18.542 183.227 18.441 182.94 18.369 C 182.663 18.297 182.4 18.263 182.152 18.263 C 181.636 18.263 181.183 18.384 180.786 18.629 C 180.395 18.865 180.065 19.182 179.798 19.586 C 179.53 19.991 179.325 20.443 179.181 20.948 C 179.048 21.453 178.981 21.963 178.981 22.483 C 178.981 23.291 179.11 23.994 179.368 24.585 C 179.626 25.167 179.993 25.625 180.466 25.947 C 180.939 26.26 181.498 26.418 182.138 26.418 C 182.51 26.418 182.916 26.365 183.356 26.255 C 183.795 26.144 184.244 25.976 184.707 25.745 L 185.123 26.515 C 184.927 26.659 184.698 26.789 184.44 26.904 C 184.191 27.01 183.924 27.106 183.637 27.188 C 183.36 27.27 183.083 27.328 182.806 27.361 C 182.539 27.405 182.291 27.429 182.057 27.429 L 182.052 27.429 Z M 166.315 26.5 C 166.884 26.5 167.361 26.38 167.748 26.135 C 168.13 25.894 168.44 25.567 168.67 25.163 C 168.904 24.759 169.066 24.316 169.166 23.83 C 169.271 23.344 169.329 22.858 169.329 22.377 C 169.329 21.896 169.276 21.405 169.166 20.924 C 169.066 20.438 168.904 20 168.67 19.606 C 168.436 19.202 168.125 18.879 167.734 18.634 C 167.352 18.393 166.879 18.268 166.315 18.268 C 165.752 18.268 165.279 18.388 164.882 18.634 C 164.5 18.874 164.19 19.202 163.961 19.606 C 163.736 20.01 163.574 20.452 163.464 20.938 C 163.364 21.424 163.316 21.91 163.316 22.391 C 163.316 22.873 163.364 23.363 163.464 23.844 C 163.569 24.321 163.736 24.759 163.961 25.163 C 164.195 25.567 164.5 25.889 164.882 26.135 C 165.274 26.375 165.752 26.5 166.315 26.5 Z M 166.301 27.414 C 165.58 27.414 164.945 27.28 164.4 27.01 C 163.865 26.741 163.421 26.37 163.063 25.904 C 162.705 25.427 162.437 24.888 162.26 24.287 C 162.084 23.686 161.993 23.046 161.993 22.372 C 161.993 21.699 162.079 21.059 162.246 20.457 C 162.423 19.846 162.69 19.307 163.049 18.841 C 163.407 18.364 163.856 17.994 164.4 17.725 C 164.945 17.455 165.58 17.32 166.31 17.32 C 167.041 17.32 167.676 17.455 168.211 17.725 C 168.756 17.994 169.205 18.364 169.563 18.841 C 169.921 19.307 170.184 19.846 170.351 20.457 C 170.528 21.059 170.618 21.699 170.618 22.372 C 170.618 23.046 170.528 23.686 170.351 24.297 C 170.174 24.898 169.907 25.432 169.548 25.899 C 169.19 26.365 168.741 26.736 168.197 27.005 C 167.662 27.275 167.027 27.41 166.296 27.41 L 166.301 27.414 Z M 156.123 18.388 L 153.234 18.388 L 153.234 17.46 L 160.322 17.46 L 160.322 18.388 L 157.394 18.388 L 157.394 27.265 L 156.123 27.265 L 156.123 18.388 Z M 144.007 17.325 C 144.451 17.325 144.886 17.388 145.306 17.513 C 145.736 17.638 146.142 17.816 146.524 18.052 L 145.908 18.956 C 145.631 18.749 145.33 18.586 145 18.47 C 144.68 18.345 144.346 18.283 143.998 18.283 C 143.525 18.283 143.124 18.403 142.794 18.648 C 142.464 18.884 142.297 19.259 142.297 19.779 C 142.297 20.068 142.374 20.313 142.527 20.52 C 142.689 20.717 142.894 20.89 143.157 21.044 C 143.42 21.198 143.697 21.347 143.998 21.487 C 144.308 21.631 144.628 21.79 144.948 21.958 C 145.277 22.127 145.578 22.329 145.846 22.565 C 146.123 22.791 146.342 23.07 146.5 23.402 C 146.667 23.724 146.753 24.123 146.753 24.6 C 146.753 25.244 146.596 25.779 146.285 26.202 C 145.975 26.616 145.564 26.924 145.053 27.13 C 144.547 27.328 143.998 27.429 143.41 27.429 C 142.928 27.429 142.46 27.366 142.006 27.241 C 141.562 27.106 141.122 26.928 140.697 26.702 L 141.18 25.596 C 141.476 25.846 141.829 26.053 142.25 26.216 C 142.67 26.38 143.071 26.457 143.453 26.457 C 143.749 26.457 144.045 26.404 144.351 26.293 C 144.652 26.178 144.91 25.99 145.115 25.74 C 145.32 25.49 145.421 25.167 145.421 24.768 C 145.421 24.369 145.325 24.051 145.139 23.796 C 144.953 23.536 144.704 23.32 144.403 23.152 C 144.103 22.974 143.778 22.8 143.439 22.642 C 143.143 22.497 142.851 22.348 142.555 22.199 C 142.259 22.045 141.992 21.867 141.753 21.66 C 141.514 21.453 141.318 21.208 141.18 20.919 C 141.036 20.631 140.965 20.284 140.965 19.88 C 140.965 19.312 141.113 18.841 141.404 18.465 C 141.705 18.09 142.092 17.806 142.555 17.619 C 143.028 17.421 143.515 17.32 144.012 17.32 L 144.007 17.325 Z M 132.015 17.46 L 136.265 24.046 C 136.347 24.172 136.433 24.306 136.518 24.451 C 136.609 24.585 136.695 24.715 136.786 24.84 C 136.776 24.686 136.767 24.537 136.757 24.383 C 136.748 24.22 136.743 24.071 136.743 23.926 L 136.743 17.46 L 137.76 17.46 L 137.76 27.333 L 136.972 27.333 L 132.01 19.683 C 131.938 19.567 131.857 19.447 131.771 19.317 C 131.69 19.182 131.604 19.057 131.518 18.942 C 131.537 19.086 131.547 19.235 131.547 19.384 C 131.556 19.529 131.561 19.673 131.561 19.817 L 131.561 27.265 L 130.544 27.265 L 130.544 18.345 L 130.358 17.455 L 132.015 17.455 L 132.015 17.46 Z M 125.438 17.46 L 126.871 17.46 L 126.871 27.265 L 125.63 27.265 L 125.63 18.345 C 125.63 18.345 125.61 18.263 125.577 18.129 C 125.548 17.994 125.524 17.854 125.496 17.71 C 125.467 17.566 125.453 17.479 125.443 17.455 L 125.438 17.46 Z M 118.819 17.325 C 119.168 17.325 119.535 17.364 119.927 17.445 C 120.328 17.518 120.71 17.638 121.078 17.811 C 121.451 17.975 121.766 18.182 122.014 18.446 L 121.307 19.283 C 121.03 19.057 120.772 18.874 120.534 18.73 C 120.295 18.586 120.037 18.48 119.77 18.408 C 119.512 18.336 119.196 18.302 118.819 18.302 C 118.232 18.302 117.73 18.413 117.319 18.639 C 116.918 18.865 116.589 19.168 116.331 19.553 C 116.083 19.938 115.896 20.376 115.782 20.861 C 115.667 21.347 115.61 21.848 115.61 22.372 C 115.61 22.868 115.662 23.354 115.772 23.84 C 115.877 24.316 116.054 24.749 116.293 25.148 C 116.531 25.543 116.851 25.856 117.243 26.091 C 117.635 26.327 118.117 26.442 118.685 26.442 C 119.158 26.442 119.564 26.341 119.903 26.135 C 120.252 25.918 120.519 25.629 120.706 25.273 C 120.901 24.903 121.002 24.494 121.002 24.032 L 121.002 23.142 L 118.609 23.142 L 118.771 22.228 L 122.263 22.228 L 122.263 25.042 C 122.263 25.413 122.277 25.783 122.301 26.159 C 122.334 26.534 122.363 26.909 122.382 27.275 L 121.713 27.275 L 121.283 26.25 C 120.892 26.673 120.467 26.977 120.013 27.164 C 119.569 27.342 119.053 27.434 118.475 27.434 C 117.773 27.434 117.157 27.304 116.632 27.044 C 116.116 26.774 115.681 26.409 115.333 25.952 C 114.984 25.485 114.726 24.956 114.559 24.364 C 114.392 23.772 114.306 23.147 114.306 22.492 C 114.306 21.776 114.401 21.107 114.588 20.486 C 114.774 19.856 115.056 19.307 115.428 18.841 C 115.801 18.364 116.269 17.999 116.832 17.734 C 117.401 17.465 118.069 17.33 118.824 17.33 L 118.819 17.325 Z M 106.287 17.46 L 112.133 17.46 L 112.133 18.388 L 107.72 18.388 L 107.72 21.771 L 111.144 21.771 L 111.144 22.685 L 107.72 22.685 L 107.72 26.337 L 112.133 26.337 L 112.133 27.265 L 106.478 27.265 L 106.478 18.345 L 106.292 17.455 L 106.287 17.46 Z M 102.041 24.316 C 102.041 23.859 101.922 23.493 101.678 23.224 C 101.444 22.945 101.144 22.747 100.771 22.632 C 100.403 22.507 100.026 22.444 99.634 22.444 L 98.149 22.444 L 98.149 26.337 L 99.634 26.337 C 100.107 26.337 100.523 26.284 100.876 26.173 C 101.244 26.058 101.526 25.851 101.731 25.552 C 101.936 25.254 102.037 24.845 102.037 24.311 L 102.041 24.316 Z M 101.626 19.764 C 101.626 19.404 101.545 19.125 101.387 18.927 C 101.234 18.73 101.029 18.591 100.771 18.509 C 100.513 18.427 100.231 18.388 99.931 18.388 L 98.154 18.388 L 98.154 21.516 L 99.587 21.516 C 100.007 21.516 100.365 21.463 100.671 21.352 C 100.976 21.242 101.21 21.064 101.378 20.813 C 101.545 20.554 101.631 20.202 101.631 19.764 L 101.626 19.764 Z M 102.925 19.736 C 102.925 20.068 102.858 20.39 102.724 20.707 C 102.6 21.011 102.414 21.28 102.161 21.501 C 101.922 21.718 101.626 21.857 101.277 21.92 C 101.721 21.982 102.099 22.141 102.4 22.391 C 102.71 22.632 102.949 22.94 103.106 23.306 C 103.274 23.676 103.36 24.08 103.36 24.518 C 103.36 25.1 103.255 25.576 103.04 25.947 C 102.825 26.308 102.538 26.587 102.17 26.784 C 101.803 26.972 101.397 27.102 100.938 27.174 C 100.485 27.236 100.021 27.27 99.548 27.27 L 96.903 27.27 L 96.903 18.35 C 96.903 18.35 96.883 18.268 96.85 18.133 C 96.821 17.999 96.798 17.859 96.769 17.715 C 96.74 17.571 96.726 17.484 96.716 17.46 L 99.964 17.46 C 100.346 17.46 100.714 17.494 101.062 17.566 C 101.421 17.628 101.736 17.744 102.013 17.917 C 102.299 18.085 102.519 18.321 102.681 18.619 C 102.844 18.908 102.92 19.279 102.92 19.736 L 102.925 19.736 Z M 85.708 17.325 C 86.057 17.325 86.424 17.364 86.816 17.445 C 87.217 17.518 87.599 17.638 87.967 17.811 C 88.339 17.975 88.655 18.182 88.903 18.446 L 88.196 19.283 C 87.919 19.057 87.661 18.874 87.422 18.73 C 87.184 18.586 86.926 18.48 86.658 18.408 C 86.4 18.336 86.085 18.302 85.708 18.302 C 85.12 18.302 84.619 18.413 84.208 18.639 C 83.807 18.865 83.478 19.168 83.22 19.553 C 82.971 19.938 82.785 20.376 82.67 20.861 C 82.556 21.347 82.499 21.848 82.499 22.372 C 82.499 22.868 82.551 23.354 82.661 23.84 C 82.766 24.316 82.943 24.749 83.181 25.148 C 83.42 25.543 83.74 25.856 84.132 26.091 C 84.524 26.327 85.006 26.442 85.574 26.442 C 86.047 26.442 86.453 26.341 86.792 26.135 C 87.141 25.918 87.408 25.629 87.594 25.273 C 87.79 24.903 87.891 24.494 87.891 24.032 L 87.891 23.142 L 85.498 23.142 L 85.66 22.228 L 89.151 22.228 L 89.151 25.042 C 89.151 25.413 89.166 25.783 89.19 26.159 C 89.223 26.534 89.252 26.909 89.271 27.275 L 88.602 27.275 L 88.172 26.25 C 87.781 26.673 87.356 26.977 86.902 27.164 C 86.458 27.342 85.942 27.434 85.364 27.434 C 84.662 27.434 84.046 27.304 83.521 27.044 C 83.005 26.774 82.57 26.409 82.222 25.952 C 81.873 25.485 81.615 24.956 81.448 24.364 C 81.281 23.772 81.195 23.147 81.195 22.492 C 81.195 21.776 81.29 21.107 81.477 20.486 C 81.663 19.856 81.945 19.307 82.317 18.841 C 82.69 18.364 83.158 17.999 83.721 17.734 C 84.289 17.465 84.958 17.33 85.713 17.33 L 85.708 17.325 Z M 72.312 17.46 L 76.562 24.046 C 76.643 24.172 76.729 24.306 76.815 24.451 C 76.906 24.585 76.992 24.715 77.083 24.84 L 77.054 24.383 C 77.044 24.22 77.04 24.071 77.04 23.926 L 77.04 17.46 L 78.057 17.46 L 78.057 27.333 L 77.269 27.333 L 72.307 19.683 C 72.235 19.567 72.154 19.447 72.068 19.317 C 71.987 19.182 71.901 19.057 71.815 18.942 C 71.834 19.086 71.844 19.235 71.844 19.384 C 71.853 19.529 71.858 19.673 71.858 19.817 L 71.858 27.265 L 70.841 27.265 L 70.841 18.345 L 70.654 17.455 L 72.312 17.455 L 72.312 17.46 Z M 65.735 17.46 L 67.168 17.46 L 67.168 27.265 L 65.926 27.265 L 65.926 18.345 C 65.926 18.345 65.907 18.263 65.874 18.129 C 65.845 17.994 65.821 17.854 65.793 17.71 C 65.764 17.566 65.75 17.479 65.74 17.455 L 65.735 17.46 Z M 61.017 22.632 L 56.284 22.632 L 56.284 27.265 L 55.042 27.265 L 55.042 18.345 C 55.042 18.345 55.023 18.263 54.989 18.129 C 54.961 17.994 54.937 17.854 54.908 17.71 C 54.88 17.566 54.865 17.479 54.856 17.455 L 56.289 17.455 L 56.289 21.713 L 61.021 21.713 L 61.021 17.455 L 62.263 17.455 L 62.263 27.26 L 61.021 27.26 L 61.021 22.627 L 61.017 22.632 Z M 48.017 18.388 L 45.127 18.388 L 45.127 17.46 L 52.215 17.46 L 52.215 18.388 L 49.287 18.388 L 49.287 27.265 L 48.017 27.265 L 48.017 18.388 Z M 37.534 17.46 L 39.793 21.27 L 41.894 17.46 L 43.059 17.46 L 40.265 22.415 L 40.265 27.265 L 38.995 27.265 L 38.995 22.415 L 36.091 17.46 L 37.534 17.46 Z M 28.803 18.388 L 28.803 21.944 L 29.873 21.944 C 30.317 21.944 30.718 21.896 31.077 21.795 C 31.444 21.689 31.731 21.497 31.946 21.227 C 32.161 20.958 32.266 20.578 32.266 20.082 C 32.266 19.697 32.17 19.38 31.984 19.139 C 31.798 18.889 31.549 18.701 31.249 18.571 C 30.948 18.446 30.618 18.384 30.274 18.384 L 28.803 18.384 L 28.803 18.388 Z M 27.375 17.46 L 30.279 17.46 C 30.895 17.46 31.449 17.542 31.951 17.7 C 32.452 17.854 32.844 18.129 33.125 18.523 C 33.422 18.918 33.565 19.466 33.565 20.169 C 33.565 20.529 33.479 20.876 33.312 21.208 C 33.145 21.54 32.915 21.833 32.629 22.084 C 32.352 22.324 32.046 22.502 31.707 22.608 L 34.434 27.27 L 32.992 27.27 L 30.48 22.863 L 28.808 22.863 L 28.808 27.27 L 27.566 27.27 L 27.566 18.35 L 27.38 17.46 L 27.375 17.46 Z M 18.712 17.46 L 24.558 17.46 L 24.558 18.388 L 20.145 18.388 L 20.145 21.771 L 23.569 21.771 L 23.569 22.685 L 20.145 22.685 L 20.145 26.337 L 24.558 26.337 L 24.558 27.265 L 18.903 27.265 L 18.903 18.345 L 18.717 17.455 L 18.712 17.46 Z M 9.958 17.46 L 12.069 23.859 C 12.14 24.085 12.207 24.301 12.269 24.518 C 12.331 24.725 12.398 24.956 12.47 25.206 C 12.541 24.97 12.604 24.763 12.656 24.571 C 12.709 24.374 12.771 24.172 12.842 23.965 L 15.063 17.445 L 16.133 17.445 L 12.761 27.308 L 11.987 27.308 L 8.63 17.46 L 9.953 17.46 L 9.958 17.46 Z M 0.64 17.46 L 6.486 17.46 L 6.486 18.388 L 2.073 18.388 L 2.073 21.771 L 5.497 21.771 L 5.497 22.685 L 2.073 22.685 L 2.073 26.337 L 6.486 26.337 L 6.486 27.265 L 0.826 27.265 L 0.826 18.345 L 0.64 17.455 L 0.64 17.46 Z M 164.806 9.194 C 164.806 9.435 164.715 9.646 164.539 9.829 C 164.371 9.998 164.166 10.084 163.923 10.084 C 163.679 10.084 163.474 9.998 163.292 9.829 C 163.125 9.651 163.039 9.44 163.039 9.194 C 163.039 8.949 163.125 8.732 163.292 8.559 C 163.459 8.391 163.669 8.304 163.923 8.304 C 164.176 8.304 164.367 8.396 164.539 8.574 C 164.715 8.742 164.806 8.949 164.806 9.194 Z M 154.232 0.14 L 158.483 6.726 C 158.564 6.851 158.65 6.986 158.736 7.13 C 158.827 7.265 158.913 7.395 159.003 7.52 L 158.975 7.063 C 158.965 6.899 158.96 6.75 158.96 6.606 L 158.96 0.14 L 159.978 0.14 L 159.978 10.012 L 159.19 10.012 L 154.227 2.362 C 154.156 2.247 154.075 2.127 153.989 1.997 C 153.907 1.862 153.822 1.737 153.736 1.621 C 153.755 1.766 153.764 1.915 153.764 2.064 C 153.774 2.208 153.779 2.353 153.779 2.497 L 153.779 9.945 L 152.761 9.945 L 152.761 1.03 L 152.575 0.14 L 154.232 0.14 Z M 147.656 0.14 L 149.089 0.14 L 149.089 9.945 L 147.847 9.945 L 147.847 1.03 C 147.847 1.03 147.828 0.948 147.794 0.813 C 147.766 0.678 147.742 0.539 147.713 0.395 C 147.685 0.25 147.67 0.164 147.661 0.14 L 147.656 0.14 Z M 142.937 5.312 L 138.204 5.312 L 138.204 9.945 L 136.963 9.945 L 136.963 1.03 C 136.963 1.03 136.944 0.948 136.91 0.813 C 136.881 0.678 136.858 0.539 136.829 0.395 C 136.8 0.25 136.786 0.164 136.776 0.14 L 138.209 0.14 L 138.209 4.397 L 142.942 4.397 L 142.942 0.14 L 144.184 0.14 L 144.184 9.945 L 142.942 9.945 L 142.942 5.312 L 142.937 5.312 Z M 129.937 1.068 L 127.048 1.068 L 127.048 0.14 L 134.135 0.14 L 134.135 1.068 L 131.208 1.068 L 131.208 9.945 L 129.937 9.945 L 129.937 1.068 Z M 122.788 0.14 L 124.221 0.14 L 124.221 9.945 L 122.979 9.945 L 122.979 1.03 C 122.979 1.03 122.96 0.948 122.926 0.813 C 122.898 0.678 122.874 0.539 122.845 0.395 C 122.817 0.25 122.802 0.164 122.793 0.14 L 122.788 0.14 Z M 110.117 0.14 L 111.751 6.216 C 111.822 6.457 111.889 6.707 111.951 6.957 C 112.013 7.198 112.076 7.477 112.138 7.794 C 112.2 7.506 112.257 7.251 112.31 7.024 C 112.362 6.789 112.419 6.563 112.482 6.336 L 114.139 0.14 L 115.127 0.14 L 116.761 6.269 C 116.823 6.495 116.885 6.731 116.947 6.981 C 117.009 7.222 117.071 7.491 117.133 7.789 C 117.195 7.501 117.253 7.246 117.305 7.02 C 117.358 6.793 117.415 6.577 117.477 6.36 L 119.149 0.135 L 120.19 0.135 L 117.53 10.007 L 116.498 10.007 L 114.798 3.743 C 114.755 3.565 114.702 3.377 114.65 3.19 C 114.597 2.993 114.549 2.766 114.502 2.516 C 114.449 2.766 114.397 2.997 114.339 3.204 C 114.296 3.402 114.244 3.594 114.191 3.782 L 112.52 10.007 L 111.488 10.007 L 108.809 0.14 L 110.117 0.14 Z M 99.62 0.005 C 100.064 0.005 100.499 0.067 100.919 0.192 C 101.349 0.318 101.755 0.496 102.137 0.731 L 101.521 1.636 C 101.244 1.429 100.943 1.265 100.613 1.15 C 100.293 1.025 99.959 0.962 99.611 0.962 C 99.138 0.962 98.737 1.083 98.407 1.328 C 98.077 1.564 97.91 1.939 97.91 2.459 C 97.91 2.747 97.987 2.993 98.14 3.199 C 98.302 3.397 98.507 3.57 98.77 3.724 C 99.028 3.878 99.31 4.027 99.611 4.167 C 99.921 4.311 100.241 4.47 100.561 4.638 C 100.89 4.806 101.191 5.008 101.459 5.244 C 101.736 5.47 101.955 5.749 102.113 6.081 C 102.28 6.404 102.366 6.803 102.366 7.279 C 102.366 7.924 102.209 8.458 101.898 8.882 C 101.588 9.295 101.177 9.603 100.666 9.81 C 100.16 10.007 99.611 10.108 99.023 10.108 C 98.541 10.108 98.073 10.046 97.619 9.921 C 97.175 9.786 96.735 9.608 96.31 9.382 L 96.793 8.275 C 97.089 8.525 97.442 8.732 97.863 8.896 C 98.283 9.06 98.684 9.137 99.066 9.137 C 99.362 9.137 99.658 9.084 99.964 8.973 C 100.265 8.857 100.523 8.67 100.728 8.42 C 100.933 8.169 101.034 7.847 101.034 7.448 C 101.034 7.048 100.938 6.731 100.752 6.476 C 100.566 6.216 100.317 6 100.016 5.831 C 99.716 5.653 99.391 5.48 99.052 5.321 C 98.756 5.177 98.464 5.028 98.168 4.879 C 97.872 4.725 97.605 4.547 97.366 4.34 C 97.127 4.133 96.931 3.887 96.793 3.599 C 96.649 3.31 96.578 2.964 96.578 2.56 C 96.578 1.992 96.726 1.52 97.017 1.145 C 97.318 0.77 97.705 0.486 98.168 0.298 C 98.641 0.101 99.128 0 99.625 0 L 99.62 0.005 Z M 91.386 0.005 C 91.831 0.005 92.265 0.067 92.685 0.192 C 93.115 0.318 93.521 0.496 93.903 0.731 L 93.287 1.636 C 93.01 1.429 92.709 1.265 92.38 1.15 C 92.06 1.025 91.726 0.962 91.377 0.962 C 90.904 0.962 90.503 1.083 90.173 1.328 C 89.844 1.564 89.677 1.939 89.677 2.459 C 89.677 2.747 89.753 2.993 89.906 3.199 C 90.068 3.397 90.274 3.57 90.536 3.724 C 90.799 3.878 91.076 4.027 91.377 4.167 C 91.687 4.311 92.007 4.47 92.327 4.638 C 92.657 4.806 92.958 5.008 93.225 5.244 C 93.502 5.47 93.722 5.749 93.879 6.081 C 94.047 6.404 94.133 6.803 94.133 7.279 C 94.133 7.924 93.975 8.458 93.665 8.882 C 93.354 9.295 92.943 9.603 92.432 9.81 C 91.926 10.007 91.377 10.108 90.789 10.108 C 90.307 10.108 89.839 10.046 89.385 9.921 C 88.941 9.786 88.502 9.608 88.077 9.382 L 88.559 8.275 C 88.855 8.525 89.209 8.732 89.629 8.896 C 90.049 9.06 90.45 9.137 90.832 9.137 C 91.129 9.137 91.425 9.084 91.73 8.973 C 92.031 8.857 92.289 8.67 92.494 8.42 C 92.7 8.169 92.8 7.847 92.8 7.448 C 92.8 7.048 92.705 6.731 92.518 6.476 C 92.332 6.216 92.084 6 91.783 5.831 C 91.482 5.653 91.157 5.48 90.818 5.321 C 90.522 5.177 90.231 5.028 89.935 4.879 C 89.638 4.725 89.371 4.547 89.132 4.34 C 88.893 4.133 88.698 3.887 88.559 3.599 C 88.416 3.31 88.344 2.964 88.344 2.56 C 88.344 1.992 88.492 1.52 88.784 1.145 C 89.084 0.77 89.471 0.486 89.935 0.298 C 90.407 0.101 90.895 0 91.391 0 L 91.386 0.005 Z M 79.929 0.14 L 85.775 0.14 L 85.775 1.068 L 81.362 1.068 L 81.362 4.45 L 84.786 4.45 L 84.786 5.365 L 81.362 5.365 L 81.362 9.016 L 85.775 9.016 L 85.775 9.945 L 80.12 9.945 L 80.12 1.03 L 79.934 0.14 L 79.929 0.14 Z M 70.716 0.14 L 74.967 6.726 C 75.048 6.851 75.134 6.986 75.22 7.13 C 75.311 7.265 75.397 7.395 75.488 7.52 L 75.459 7.063 C 75.449 6.899 75.445 6.75 75.445 6.606 L 75.445 0.14 L 76.462 0.14 L 76.462 10.012 L 75.674 10.012 L 70.712 2.362 C 70.64 2.247 70.559 2.127 70.473 1.997 C 70.392 1.862 70.306 1.737 70.22 1.621 C 70.239 1.766 70.248 1.915 70.248 2.064 C 70.258 2.208 70.263 2.353 70.263 2.497 L 70.263 9.945 L 69.245 9.945 L 69.245 1.03 L 69.059 0.14 L 70.716 0.14 Z M 60.84 0.14 L 62.273 0.14 L 62.273 9.016 L 66.366 9.016 L 66.366 9.945 L 61.031 9.945 L 61.031 1.03 L 60.845 0.14 L 60.84 0.14 Z M 52.635 0.14 L 54.068 0.14 L 54.068 9.016 L 58.161 9.016 L 58.161 9.945 L 52.826 9.945 L 52.826 1.03 L 52.64 0.14 L 52.635 0.14 Z M 43.298 0.14 L 43.298 6.659 C 43.298 7.424 43.484 8.035 43.862 8.492 C 44.234 8.949 44.826 9.18 45.629 9.18 C 46.183 9.18 46.646 9.069 47.019 8.843 C 47.391 8.607 47.673 8.29 47.859 7.886 C 48.045 7.472 48.141 7 48.141 6.471 L 48.141 0.14 L 49.172 0.14 L 49.172 6.471 C 49.172 7.226 49.029 7.876 48.743 8.424 C 48.466 8.963 48.06 9.382 47.525 9.675 C 46.99 9.964 46.34 10.108 45.571 10.108 C 44.459 10.108 43.589 9.815 42.964 9.233 C 42.338 8.651 42.028 7.789 42.028 6.659 L 42.028 1.03 L 41.827 0.14 L 43.298 0.14 Z M 33.689 0.14 L 39.076 0.14 L 39.076 1.068 L 35.117 1.068 L 35.117 4.45 L 38.26 4.45 L 38.26 5.365 L 35.117 5.365 L 35.117 9.945 L 33.875 9.945 L 33.875 1.03 L 33.689 0.14 Z M 20.594 0.14 L 26.439 0.14 L 26.439 1.068 L 22.026 1.068 L 22.026 4.45 L 25.451 4.45 L 25.451 5.365 L 22.026 5.365 L 22.026 9.016 L 26.439 9.016 L 26.439 9.945 L 20.785 9.945 L 20.785 1.03 L 20.598 0.14 L 20.594 0.14 Z M 15.885 5.312 L 11.152 5.312 L 11.152 9.945 L 9.91 9.945 L 9.91 1.03 C 9.91 1.03 9.891 0.948 9.857 0.813 C 9.829 0.678 9.805 0.539 9.776 0.395 C 9.748 0.25 9.733 0.164 9.724 0.14 L 11.156 0.14 L 11.156 4.397 L 15.889 4.397 L 15.889 0.14 L 17.131 0.14 L 17.131 9.945 L 15.889 9.945 L 15.889 5.312 L 15.885 5.312 Z M 2.885 1.068 L 0 1.068 L 0 0.14 L 7.087 0.14 L 7.087 1.068 L 4.16 1.068 L 4.16 9.945 L 2.889 9.945 L 2.889 1.068 L 2.885 1.068 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 148.043,
    height: 20.077,
    viewBox: "0 0 148.043 20.077",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 38.918,
      width: 148.043,
      height: 20.077,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.2 18.745 C 138.2 18.874 138.152 18.985 138.061 19.076 C 137.97 19.163 137.861 19.206 137.741 19.206 C 137.622 19.206 137.512 19.163 137.421 19.076 C 137.33 18.985 137.283 18.874 137.283 18.745 C 137.283 18.615 137.326 18.499 137.412 18.413 C 137.502 18.326 137.612 18.283 137.741 18.283 C 137.87 18.283 137.97 18.331 138.061 18.422 C 138.152 18.509 138.2 18.619 138.2 18.745 Z M 134.35 13.476 C 134.589 13.476 134.823 13.51 135.048 13.582 C 135.277 13.654 135.501 13.75 135.721 13.866 L 135.463 14.304 C 135.291 14.193 135.11 14.097 134.928 14.025 C 134.751 13.953 134.556 13.919 134.345 13.919 C 134.035 13.919 133.777 13.996 133.572 14.15 C 133.371 14.304 133.276 14.549 133.276 14.881 C 133.276 15.049 133.323 15.199 133.419 15.319 C 133.519 15.439 133.653 15.54 133.811 15.636 C 133.968 15.723 134.14 15.81 134.322 15.896 C 134.498 15.978 134.68 16.069 134.866 16.175 C 135.048 16.272 135.215 16.387 135.363 16.522 C 135.516 16.656 135.64 16.815 135.73 17.008 C 135.821 17.19 135.869 17.417 135.869 17.676 C 135.869 18.042 135.778 18.34 135.602 18.571 C 135.425 18.797 135.191 18.966 134.904 19.072 C 134.618 19.173 134.312 19.226 133.987 19.226 C 133.734 19.226 133.486 19.187 133.252 19.11 C 133.023 19.028 132.793 18.932 132.564 18.826 L 132.793 18.312 C 132.956 18.451 133.156 18.562 133.395 18.648 C 133.634 18.73 133.858 18.773 134.068 18.773 C 134.24 18.773 134.422 18.74 134.613 18.672 C 134.804 18.605 134.962 18.494 135.086 18.34 C 135.219 18.186 135.286 17.984 135.286 17.734 C 135.286 17.484 135.229 17.282 135.119 17.128 C 135.014 16.969 134.871 16.834 134.689 16.729 C 134.517 16.623 134.331 16.522 134.131 16.43 C 133.959 16.349 133.787 16.262 133.62 16.175 C 133.452 16.084 133.3 15.978 133.161 15.867 C 133.023 15.747 132.913 15.612 132.827 15.454 C 132.746 15.29 132.703 15.093 132.703 14.867 C 132.703 14.573 132.784 14.323 132.946 14.121 C 133.109 13.909 133.319 13.75 133.572 13.645 C 133.825 13.539 134.088 13.481 134.35 13.481 L 134.35 13.476 Z M 129.646 13.476 C 129.885 13.476 130.119 13.51 130.343 13.582 C 130.573 13.654 130.797 13.75 131.017 13.866 L 130.759 14.304 C 130.587 14.193 130.405 14.097 130.224 14.025 C 130.047 13.953 129.851 13.919 129.641 13.919 C 129.331 13.919 129.073 13.996 128.868 14.15 C 128.667 14.304 128.571 14.549 128.571 14.881 C 128.571 15.049 128.619 15.199 128.715 15.319 C 128.815 15.439 128.949 15.54 129.106 15.636 C 129.264 15.723 129.436 15.81 129.617 15.896 C 129.794 15.978 129.976 16.069 130.162 16.175 C 130.343 16.272 130.51 16.387 130.658 16.522 C 130.811 16.656 130.936 16.815 131.026 17.008 C 131.117 17.19 131.165 17.417 131.165 17.676 C 131.165 18.042 131.074 18.34 130.897 18.571 C 130.721 18.797 130.487 18.966 130.2 19.072 C 129.913 19.173 129.608 19.226 129.283 19.226 C 129.03 19.226 128.782 19.187 128.548 19.11 C 128.318 19.028 128.089 18.932 127.86 18.826 L 128.089 18.312 C 128.251 18.451 128.452 18.562 128.691 18.648 C 128.93 18.73 129.154 18.773 129.364 18.773 C 129.536 18.773 129.718 18.74 129.909 18.672 C 130.095 18.605 130.257 18.494 130.382 18.34 C 130.515 18.186 130.582 17.984 130.582 17.734 C 130.582 17.484 130.525 17.282 130.415 17.128 C 130.31 16.969 130.167 16.834 129.985 16.729 C 129.813 16.623 129.627 16.522 129.426 16.43 C 129.254 16.349 129.082 16.262 128.915 16.175 C 128.748 16.084 128.595 15.978 128.457 15.867 C 128.318 15.747 128.208 15.612 128.122 15.454 C 128.041 15.29 127.998 15.093 127.998 14.867 C 127.998 14.573 128.08 14.323 128.242 14.121 C 128.404 13.909 128.614 13.75 128.868 13.645 C 129.121 13.539 129.383 13.481 129.646 13.481 L 129.646 13.476 Z M 123.175 13.548 L 126.413 13.548 L 126.413 13.957 L 123.805 13.957 L 123.805 16.065 L 125.84 16.065 L 125.84 16.464 L 123.805 16.464 L 123.805 18.725 L 126.413 18.725 L 126.413 19.134 L 123.27 19.134 L 123.27 14.078 L 123.17 13.548 L 123.175 13.548 Z M 117.749 13.548 L 120.3 17.513 C 120.343 17.58 120.386 17.652 120.438 17.729 C 120.491 17.802 120.538 17.874 120.591 17.946 L 120.577 17.7 L 120.577 13.553 L 121.021 13.553 L 121.021 19.182 L 120.768 19.182 L 117.764 14.54 C 117.73 14.482 117.687 14.419 117.639 14.357 C 117.592 14.285 117.544 14.222 117.496 14.174 C 117.506 14.251 117.511 14.333 117.511 14.419 L 117.511 19.144 L 117.066 19.144 L 117.066 14.078 L 116.961 13.553 L 117.749 13.553 L 117.749 13.548 Z M 112.262 13.548 L 112.897 13.548 L 112.897 18.73 L 115.314 18.73 L 115.314 19.139 L 112.381 19.139 L 112.381 14.082 L 112.267 13.553 L 112.262 13.548 Z M 107.572 13.548 L 108.207 13.548 L 108.207 18.73 L 110.624 18.73 L 110.624 19.139 L 107.691 19.139 L 107.691 14.082 L 107.577 13.553 L 107.572 13.548 Z M 102.046 13.548 L 102.046 17.267 C 102.046 17.734 102.151 18.109 102.361 18.393 C 102.572 18.672 102.925 18.807 103.431 18.807 C 103.785 18.807 104.071 18.735 104.296 18.591 C 104.525 18.441 104.697 18.239 104.807 17.984 C 104.917 17.725 104.974 17.426 104.974 17.099 L 104.974 13.548 L 105.418 13.548 L 105.418 17.234 C 105.418 17.609 105.346 17.946 105.203 18.249 C 105.06 18.552 104.84 18.793 104.544 18.971 C 104.253 19.144 103.885 19.23 103.436 19.23 C 102.834 19.23 102.361 19.076 102.013 18.769 C 101.674 18.456 101.502 17.994 101.502 17.393 L 101.502 14.073 L 101.397 13.544 L 102.046 13.544 L 102.046 13.548 Z M 96.745 13.548 L 99.716 13.548 L 99.716 13.957 L 97.375 13.957 L 97.375 16.065 L 99.257 16.065 L 99.257 16.464 L 97.375 16.464 L 97.375 19.134 L 96.85 19.134 L 96.85 14.078 L 96.745 13.548 Z M 89.576 13.957 L 89.576 16.214 L 90.25 16.214 C 90.532 16.214 90.785 16.185 91.014 16.122 C 91.248 16.055 91.434 15.94 91.573 15.766 C 91.716 15.593 91.788 15.348 91.788 15.035 C 91.788 14.79 91.726 14.588 91.606 14.429 C 91.487 14.27 91.334 14.15 91.138 14.073 C 90.942 13.996 90.737 13.957 90.512 13.957 L 89.581 13.957 L 89.576 13.957 Z M 88.941 13.548 L 90.46 13.548 C 90.818 13.548 91.133 13.597 91.415 13.688 C 91.702 13.775 91.926 13.933 92.089 14.159 C 92.251 14.386 92.332 14.703 92.332 15.107 C 92.332 15.309 92.284 15.502 92.194 15.685 C 92.108 15.867 91.988 16.031 91.84 16.171 C 91.692 16.31 91.525 16.416 91.334 16.488 L 92.814 19.144 L 92.179 19.144 L 90.804 16.618 L 89.567 16.618 L 89.567 19.144 L 89.032 19.144 L 89.032 14.087 L 88.932 13.558 L 88.941 13.548 Z M 83.989 13.548 L 87.227 13.548 L 87.227 13.957 L 84.619 13.957 L 84.619 16.065 L 86.654 16.065 L 86.654 16.464 L 84.619 16.464 L 84.619 18.725 L 87.227 18.725 L 87.227 19.134 L 84.084 19.134 L 84.084 14.078 L 83.984 13.548 L 83.989 13.548 Z M 78.563 13.548 L 81.114 17.513 C 81.157 17.58 81.2 17.652 81.252 17.729 C 81.305 17.802 81.352 17.874 81.405 17.946 L 81.391 17.7 L 81.391 13.553 L 81.835 13.553 L 81.835 19.182 L 81.582 19.182 L 78.578 14.54 C 78.544 14.482 78.501 14.419 78.453 14.357 C 78.406 14.285 78.358 14.222 78.31 14.174 C 78.32 14.251 78.324 14.333 78.324 14.419 L 78.324 19.144 L 77.88 19.144 L 77.88 14.078 L 77.775 13.553 L 78.563 13.553 L 78.563 13.548 Z M 72.345 13.548 L 74.895 17.513 C 74.938 17.58 74.981 17.652 75.034 17.729 C 75.086 17.802 75.134 17.874 75.187 17.946 C 75.182 17.864 75.177 17.782 75.172 17.7 L 75.172 13.553 L 75.616 13.553 L 75.616 19.182 L 75.363 19.182 L 72.359 14.54 C 72.326 14.482 72.283 14.419 72.235 14.357 C 72.187 14.285 72.14 14.222 72.092 14.174 C 72.101 14.251 72.106 14.333 72.106 14.419 L 72.106 19.144 L 71.662 19.144 L 71.662 14.078 L 71.557 13.553 L 72.345 13.553 L 72.345 13.548 Z M 68.749 13.548 L 69.384 13.548 L 69.384 19.139 L 68.859 19.139 L 68.859 14.082 C 68.859 14.082 68.849 14.034 68.83 13.957 C 68.816 13.876 68.801 13.789 68.782 13.702 C 68.763 13.616 68.758 13.563 68.754 13.548 L 68.749 13.548 Z M 63.825 16.32 C 63.825 15.839 63.763 15.444 63.643 15.136 C 63.524 14.828 63.352 14.588 63.118 14.419 C 62.889 14.246 62.607 14.126 62.268 14.058 C 61.938 13.991 61.561 13.957 61.136 13.957 L 60.74 13.957 L 60.74 18.73 L 61.819 18.73 C 62.325 18.73 62.722 18.624 63.013 18.413 C 63.309 18.196 63.519 17.907 63.639 17.542 C 63.768 17.176 63.83 16.767 63.83 16.32 L 63.825 16.32 Z M 64.36 16.363 C 64.36 16.897 64.279 17.373 64.116 17.797 C 63.959 18.21 63.701 18.542 63.342 18.783 C 62.984 19.019 62.516 19.139 61.929 19.139 L 60.21 19.139 L 60.21 14.082 C 60.21 14.082 60.2 14.03 60.186 13.953 C 60.171 13.871 60.157 13.789 60.138 13.707 C 60.124 13.621 60.114 13.568 60.109 13.553 L 61.179 13.553 C 61.661 13.553 62.101 13.597 62.488 13.683 C 62.879 13.77 63.218 13.919 63.495 14.131 C 63.777 14.342 63.987 14.626 64.135 14.992 C 64.283 15.357 64.355 15.814 64.355 16.368 L 64.36 16.363 Z M 54.684 13.548 L 57.234 17.513 C 57.277 17.58 57.32 17.652 57.373 17.729 C 57.425 17.802 57.473 17.874 57.525 17.946 C 57.521 17.864 57.516 17.782 57.511 17.7 L 57.511 13.553 L 57.955 13.553 L 57.955 19.182 L 57.702 19.182 L 54.698 14.54 C 54.665 14.482 54.622 14.419 54.574 14.357 C 54.526 14.285 54.478 14.222 54.431 14.174 C 54.44 14.251 54.445 14.333 54.445 14.419 L 54.445 19.144 L 54.001 19.144 L 54.001 14.078 L 53.896 13.553 L 54.684 13.553 L 54.684 13.548 Z M 50.056 14.28 L 49.215 16.652 L 50.873 16.652 L 50.056 14.28 Z M 50.409 13.548 L 52.305 19.139 L 51.704 19.139 L 51.006 17.051 L 49.086 17.051 L 48.389 19.139 L 47.869 19.139 L 49.779 13.548 L 50.405 13.548 L 50.409 13.548 Z M 43.432 18.244 C 43.609 18.244 43.747 18.307 43.838 18.427 C 43.933 18.552 43.981 18.696 43.981 18.865 C 43.981 19.115 43.905 19.346 43.752 19.548 C 43.604 19.76 43.432 19.938 43.231 20.077 C 43.198 20.048 43.155 20.01 43.107 19.962 C 43.059 19.918 43.021 19.88 42.983 19.846 C 43.031 19.793 43.083 19.74 43.145 19.683 C 43.207 19.63 43.26 19.572 43.308 19.505 C 43.355 19.442 43.375 19.375 43.375 19.303 C 43.375 19.23 43.341 19.168 43.274 19.12 C 43.207 19.067 43.141 19.009 43.074 18.942 C 43.012 18.87 42.983 18.773 42.983 18.658 C 42.983 18.542 43.026 18.437 43.112 18.36 C 43.203 18.278 43.308 18.235 43.427 18.235 L 43.432 18.244 Z M 38.26 13.548 L 41.498 13.548 L 41.498 13.957 L 38.89 13.957 L 38.89 16.065 L 40.925 16.065 L 40.925 16.464 L 38.89 16.464 L 38.89 18.725 L 41.498 18.725 L 41.498 19.134 L 38.355 19.134 L 38.355 14.078 L 38.255 13.548 L 38.26 13.548 Z M 35.012 19.23 C 34.577 19.23 34.205 19.149 33.894 18.99 C 33.584 18.831 33.331 18.619 33.13 18.36 C 32.93 18.1 32.782 17.806 32.686 17.489 C 32.595 17.171 32.548 16.849 32.548 16.527 C 32.548 16.151 32.6 15.786 32.7 15.425 C 32.806 15.064 32.963 14.742 33.173 14.448 C 33.388 14.155 33.656 13.924 33.976 13.746 C 34.296 13.572 34.673 13.486 35.107 13.486 C 35.284 13.486 35.475 13.51 35.671 13.553 C 35.876 13.601 36.067 13.669 36.254 13.76 C 36.435 13.852 36.583 13.972 36.698 14.121 L 36.383 14.438 C 36.282 14.328 36.153 14.232 36.001 14.155 C 35.853 14.078 35.695 14.02 35.528 13.977 C 35.365 13.933 35.213 13.914 35.069 13.914 C 34.778 13.914 34.515 13.986 34.276 14.131 C 34.038 14.275 33.832 14.467 33.665 14.718 C 33.498 14.963 33.369 15.242 33.274 15.55 C 33.183 15.853 33.135 16.161 33.135 16.483 C 33.135 16.945 33.211 17.344 33.364 17.686 C 33.522 18.023 33.742 18.287 34.028 18.47 C 34.315 18.653 34.649 18.749 35.031 18.749 C 35.246 18.749 35.48 18.72 35.733 18.658 C 35.986 18.595 36.249 18.499 36.512 18.364 L 36.703 18.735 C 36.612 18.807 36.492 18.874 36.344 18.937 C 36.196 19 36.039 19.052 35.872 19.101 C 35.709 19.144 35.552 19.173 35.399 19.202 C 35.246 19.226 35.117 19.24 35.007 19.24 L 35.012 19.23 Z M 27.304 13.548 L 29.854 17.513 C 29.897 17.58 29.94 17.652 29.993 17.729 C 30.045 17.802 30.093 17.874 30.145 17.946 C 30.141 17.864 30.136 17.782 30.131 17.7 L 30.131 13.553 L 30.575 13.553 L 30.575 19.182 L 30.322 19.182 L 27.318 14.54 C 27.285 14.482 27.242 14.419 27.194 14.357 C 27.146 14.285 27.098 14.222 27.051 14.174 C 27.06 14.251 27.065 14.333 27.065 14.419 L 27.065 19.144 L 26.621 19.144 L 26.621 14.078 L 26.516 13.553 L 27.304 13.553 L 27.304 13.548 Z M 22.676 14.28 L 21.835 16.652 L 23.493 16.652 L 22.676 14.28 Z M 23.025 13.548 L 24.921 19.139 L 24.319 19.139 L 23.621 17.051 L 21.702 17.051 L 21.004 19.139 L 20.484 19.139 L 22.394 13.548 L 23.02 13.548 L 23.025 13.548 Z M 17.059 13.476 C 17.255 13.476 17.461 13.5 17.68 13.544 C 17.9 13.592 18.11 13.664 18.306 13.76 C 18.511 13.856 18.678 13.981 18.812 14.131 L 18.492 14.53 C 18.335 14.395 18.187 14.285 18.048 14.198 C 17.91 14.111 17.761 14.049 17.604 14.005 C 17.451 13.962 17.27 13.943 17.059 13.943 C 16.72 13.943 16.424 14.01 16.181 14.145 C 15.937 14.28 15.737 14.463 15.584 14.693 C 15.436 14.92 15.326 15.175 15.254 15.463 C 15.183 15.747 15.149 16.041 15.149 16.349 C 15.149 16.656 15.183 16.945 15.249 17.234 C 15.316 17.522 15.421 17.782 15.565 18.013 C 15.713 18.239 15.904 18.417 16.147 18.552 C 16.386 18.687 16.677 18.754 17.026 18.754 C 17.308 18.754 17.547 18.692 17.752 18.562 C 17.962 18.427 18.12 18.249 18.234 18.023 C 18.354 17.797 18.411 17.547 18.411 17.277 L 18.411 16.753 L 16.93 16.753 L 17.021 16.315 L 18.946 16.315 L 18.955 18.023 C 18.955 18.206 18.97 18.393 18.994 18.586 C 19.018 18.769 19.037 18.951 19.041 19.134 L 18.745 19.134 L 18.507 18.547 C 18.296 18.797 18.062 18.98 17.795 19.086 C 17.537 19.187 17.246 19.24 16.93 19.24 C 16.539 19.24 16.195 19.163 15.899 19.009 C 15.608 18.855 15.369 18.643 15.173 18.379 C 14.977 18.114 14.834 17.811 14.738 17.479 C 14.648 17.142 14.6 16.791 14.6 16.426 C 14.6 16.031 14.648 15.661 14.743 15.309 C 14.843 14.953 14.996 14.641 15.192 14.371 C 15.397 14.092 15.655 13.88 15.966 13.726 C 16.276 13.568 16.644 13.486 17.064 13.486 L 17.059 13.476 Z M 10.082 13.548 L 13.32 13.548 L 13.32 13.957 L 10.712 13.957 L 10.712 16.065 L 12.747 16.065 L 12.747 16.464 L 10.712 16.464 L 10.712 18.725 L 13.32 18.725 L 13.32 19.134 L 10.177 19.134 L 10.177 14.078 L 10.077 13.548 L 10.082 13.548 Z M 5.387 13.548 L 6.022 13.548 L 6.022 18.73 L 8.439 18.73 L 8.439 19.139 L 5.507 19.139 L 5.507 14.082 L 5.392 13.553 L 5.387 13.548 Z M 0.435 13.548 L 3.673 13.548 L 3.673 13.957 L 1.07 13.957 L 1.07 16.065 L 3.104 16.065 L 3.104 16.464 L 1.07 16.464 L 1.07 18.725 L 3.677 18.725 L 3.677 19.134 L 0.535 19.134 L 0.535 14.078 L 0.435 13.548 Z M 147.493 4.773 C 147.67 4.773 147.809 4.835 147.899 4.956 C 147.995 5.081 148.043 5.225 148.043 5.393 C 148.043 5.644 147.966 5.874 147.813 6.077 C 147.665 6.288 147.493 6.466 147.293 6.606 C 147.259 6.577 147.216 6.538 147.169 6.49 C 147.121 6.447 147.083 6.409 147.045 6.375 C 147.092 6.322 147.145 6.269 147.207 6.211 C 147.269 6.158 147.322 6.101 147.369 6.033 C 147.417 5.971 147.436 5.903 147.436 5.831 C 147.436 5.759 147.403 5.696 147.336 5.648 C 147.269 5.595 147.202 5.538 147.135 5.47 C 147.073 5.398 147.045 5.302 147.045 5.186 C 147.045 5.071 147.088 4.965 147.173 4.888 C 147.264 4.806 147.369 4.763 147.489 4.763 L 147.493 4.773 Z M 142.321 0.077 L 145.559 0.077 L 145.559 0.486 L 142.952 0.486 L 142.952 2.593 L 144.986 2.593 L 144.986 2.993 L 142.952 2.993 L 142.952 5.254 L 145.559 5.254 L 145.559 5.663 L 142.417 5.663 L 142.417 0.606 L 142.316 0.077 L 142.321 0.077 Z M 139.074 5.759 C 138.639 5.759 138.266 5.677 137.956 5.518 C 137.646 5.36 137.392 5.148 137.192 4.888 C 136.991 4.628 136.843 4.335 136.748 4.017 C 136.657 3.7 136.609 3.377 136.609 3.055 C 136.609 2.68 136.662 2.314 136.762 1.953 C 136.867 1.593 137.025 1.27 137.235 0.977 C 137.45 0.683 137.717 0.452 138.037 0.274 C 138.357 0.096 138.735 0.014 139.169 0.014 C 139.346 0.014 139.537 0.038 139.733 0.082 C 139.938 0.13 140.129 0.197 140.315 0.289 C 140.497 0.38 140.645 0.5 140.759 0.65 L 140.444 0.967 C 140.344 0.856 140.215 0.76 140.062 0.683 C 139.914 0.606 139.757 0.548 139.589 0.505 C 139.427 0.462 139.274 0.443 139.131 0.443 C 138.84 0.443 138.577 0.515 138.338 0.659 C 138.099 0.803 137.894 0.996 137.727 1.246 C 137.56 1.491 137.431 1.771 137.335 2.078 C 137.244 2.382 137.197 2.689 137.197 3.012 C 137.197 3.474 137.273 3.873 137.426 4.215 C 137.584 4.551 137.803 4.816 138.09 4.999 C 138.376 5.182 138.711 5.278 139.093 5.278 C 139.308 5.278 139.542 5.249 139.795 5.186 C 140.048 5.124 140.311 5.028 140.573 4.893 L 140.764 5.263 C 140.674 5.336 140.554 5.403 140.406 5.466 C 140.258 5.528 140.1 5.581 139.933 5.629 C 139.771 5.672 139.613 5.701 139.46 5.73 C 139.308 5.754 139.179 5.769 139.069 5.769 L 139.074 5.759 Z M 131.365 0.077 L 133.916 4.041 C 133.959 4.109 134.002 4.181 134.054 4.258 C 134.107 4.33 134.154 4.402 134.207 4.474 C 134.202 4.393 134.197 4.311 134.193 4.229 L 134.193 0.082 L 134.637 0.082 L 134.637 5.711 L 134.384 5.711 L 131.38 1.068 C 131.346 1.01 131.303 0.948 131.255 0.885 C 131.208 0.813 131.16 0.751 131.112 0.702 C 131.122 0.779 131.127 0.861 131.127 0.948 L 131.127 5.672 L 130.682 5.672 L 130.682 0.606 L 130.577 0.082 L 131.365 0.082 L 131.365 0.077 Z M 125.61 0.077 L 128.848 0.077 L 128.848 0.486 L 126.241 0.486 L 126.241 2.593 L 128.275 2.593 L 128.275 2.993 L 126.241 2.993 L 126.241 5.254 L 128.848 5.254 L 128.848 5.663 L 125.706 5.663 L 125.706 0.606 L 125.606 0.077 L 125.61 0.077 Z M 122.42 0.005 C 122.659 0.005 122.893 0.038 123.117 0.111 C 123.347 0.183 123.571 0.279 123.791 0.395 L 123.533 0.832 C 123.361 0.722 123.179 0.625 122.998 0.553 C 122.821 0.481 122.625 0.447 122.415 0.447 C 122.105 0.447 121.847 0.524 121.642 0.678 C 121.441 0.832 121.346 1.078 121.346 1.41 C 121.346 1.578 121.393 1.727 121.489 1.848 C 121.589 1.968 121.723 2.069 121.88 2.165 C 122.038 2.252 122.21 2.338 122.391 2.425 C 122.568 2.507 122.75 2.598 122.936 2.704 C 123.117 2.8 123.285 2.916 123.433 3.05 C 123.585 3.185 123.71 3.344 123.8 3.536 C 123.891 3.719 123.939 3.945 123.939 4.205 C 123.939 4.571 123.848 4.869 123.671 5.1 C 123.495 5.326 123.261 5.494 122.974 5.6 C 122.688 5.701 122.382 5.754 122.057 5.754 C 121.804 5.754 121.556 5.716 121.322 5.639 C 121.092 5.557 120.863 5.461 120.634 5.355 L 120.863 4.84 C 121.026 4.98 121.226 5.09 121.465 5.177 C 121.704 5.259 121.928 5.302 122.138 5.302 C 122.31 5.302 122.492 5.268 122.683 5.201 C 122.874 5.134 123.031 5.023 123.156 4.869 C 123.289 4.715 123.356 4.513 123.356 4.263 C 123.356 4.013 123.299 3.81 123.189 3.657 C 123.084 3.498 122.941 3.363 122.759 3.257 C 122.587 3.151 122.401 3.05 122.2 2.959 C 122.028 2.877 121.857 2.791 121.689 2.704 C 121.522 2.612 121.369 2.507 121.231 2.396 C 121.092 2.276 120.983 2.141 120.897 1.982 C 120.815 1.819 120.772 1.621 120.772 1.395 C 120.772 1.102 120.854 0.852 121.016 0.65 C 121.178 0.438 121.389 0.279 121.642 0.173 C 121.895 0.067 122.157 0.01 122.42 0.01 L 122.42 0.005 Z M 115.949 0.077 L 119.187 0.077 L 119.187 0.486 L 116.579 0.486 L 116.579 2.593 L 118.614 2.593 L 118.614 2.993 L 116.579 2.993 L 116.579 5.254 L 119.187 5.254 L 119.187 5.663 L 116.044 5.663 L 116.044 0.606 L 115.944 0.077 L 115.949 0.077 Z M 111.297 0.486 L 111.297 2.742 L 111.97 2.742 C 112.252 2.742 112.505 2.714 112.735 2.651 C 112.969 2.584 113.155 2.468 113.293 2.295 C 113.437 2.122 113.508 1.876 113.508 1.564 C 113.508 1.318 113.446 1.116 113.327 0.957 C 113.207 0.799 113.055 0.678 112.859 0.601 C 112.663 0.524 112.458 0.486 112.233 0.486 L 111.302 0.486 L 111.297 0.486 Z M 110.662 0.077 L 112.181 0.077 C 112.539 0.077 112.854 0.125 113.136 0.217 C 113.422 0.303 113.647 0.462 113.809 0.688 C 113.972 0.914 114.053 1.232 114.053 1.636 C 114.053 1.838 114.005 2.03 113.914 2.213 C 113.828 2.396 113.709 2.56 113.561 2.699 C 113.413 2.839 113.246 2.944 113.055 3.017 L 114.535 5.672 L 113.9 5.672 L 112.524 3.147 L 111.288 3.147 L 111.288 5.672 L 110.753 5.672 L 110.753 0.616 L 110.652 0.087 L 110.662 0.077 Z M 106.144 0.486 L 106.144 3.065 L 107.075 3.065 C 107.462 3.065 107.772 2.949 108.002 2.718 C 108.236 2.483 108.355 2.17 108.355 1.78 C 108.355 1.39 108.245 1.058 108.026 0.832 C 107.806 0.601 107.495 0.486 107.085 0.486 L 106.144 0.486 Z M 105.504 0.077 L 107.109 0.077 C 107.476 0.077 107.792 0.14 108.054 0.26 C 108.326 0.38 108.532 0.563 108.675 0.813 C 108.823 1.058 108.895 1.381 108.895 1.775 C 108.895 2.141 108.814 2.449 108.656 2.699 C 108.503 2.949 108.293 3.142 108.021 3.276 C 107.758 3.406 107.452 3.469 107.113 3.469 L 106.144 3.469 L 106.144 5.663 L 105.619 5.663 L 105.619 0.606 L 105.504 0.077 Z M 99.104 0.486 L 97.399 0.486 L 97.399 0.077 L 101.358 0.077 L 101.358 0.486 L 99.63 0.486 L 99.63 5.668 L 99.104 5.668 L 99.104 0.486 Z M 92.848 0.077 L 96.086 0.077 L 96.086 0.486 L 93.478 0.486 L 93.478 2.593 L 95.513 2.593 L 95.513 2.993 L 93.478 2.993 L 93.478 5.254 L 96.086 5.254 L 96.086 5.663 L 92.943 5.663 L 92.943 0.606 L 92.843 0.077 L 92.848 0.077 Z M 90.044 0.077 L 90.68 0.077 L 90.68 5.668 L 90.154 5.668 L 90.154 0.611 C 90.154 0.611 90.145 0.563 90.126 0.486 C 90.111 0.404 90.097 0.318 90.078 0.231 C 90.064 0.144 90.054 0.091 90.049 0.077 L 90.044 0.077 Z M 84.504 0.077 L 84.504 3.796 C 84.504 4.263 84.609 4.638 84.82 4.922 C 85.03 5.201 85.383 5.336 85.889 5.336 C 86.243 5.336 86.529 5.263 86.754 5.119 C 86.983 4.97 87.155 4.768 87.265 4.513 C 87.375 4.253 87.432 3.955 87.432 3.628 L 87.432 0.077 L 87.876 0.077 L 87.876 3.762 C 87.876 4.138 87.805 4.474 87.661 4.778 C 87.518 5.081 87.298 5.321 87.002 5.499 C 86.711 5.672 86.343 5.759 85.894 5.759 C 85.292 5.759 84.82 5.605 84.471 5.297 C 84.132 4.984 83.96 4.523 83.96 3.921 L 83.96 0.601 L 83.855 0.072 L 84.504 0.072 L 84.504 0.077 Z M 79.657 5.34 C 79.996 5.34 80.283 5.268 80.512 5.124 C 80.746 4.975 80.932 4.782 81.071 4.547 C 81.214 4.306 81.314 4.041 81.376 3.753 C 81.438 3.459 81.467 3.166 81.467 2.877 C 81.467 2.588 81.438 2.295 81.376 2.006 C 81.314 1.718 81.214 1.458 81.071 1.222 C 80.932 0.986 80.746 0.794 80.512 0.654 C 80.283 0.51 79.996 0.438 79.657 0.438 C 79.318 0.438 79.026 0.51 78.792 0.654 C 78.563 0.799 78.377 0.991 78.234 1.232 C 78.095 1.467 77.995 1.727 77.938 2.016 C 77.88 2.305 77.852 2.593 77.852 2.887 C 77.852 3.18 77.88 3.464 77.942 3.758 C 78.004 4.046 78.105 4.311 78.238 4.551 C 78.377 4.787 78.558 4.98 78.788 5.129 C 79.022 5.273 79.308 5.345 79.652 5.345 L 79.657 5.34 Z M 85.55 7.058 C 85.469 7.092 85.374 7.13 85.259 7.164 C 85.154 7.207 85.035 7.241 84.901 7.27 C 84.772 7.303 84.633 7.332 84.481 7.356 C 84.328 7.38 84.161 7.395 83.984 7.395 C 83.75 7.395 83.492 7.356 83.21 7.279 C 82.933 7.207 82.651 7.111 82.36 6.986 C 82.069 6.866 81.787 6.745 81.51 6.615 C 81.233 6.486 80.985 6.365 80.76 6.245 C 80.54 6.134 80.359 6.043 80.216 5.985 C 80.063 5.913 79.896 5.855 79.719 5.807 L 79.198 5.682 C 78.749 5.576 78.386 5.389 78.105 5.119 C 77.823 4.855 77.618 4.527 77.484 4.142 C 77.35 3.753 77.283 3.329 77.283 2.872 C 77.283 2.487 77.331 2.122 77.422 1.78 C 77.517 1.429 77.665 1.121 77.856 0.856 C 78.052 0.592 78.296 0.38 78.592 0.231 C 78.893 0.077 79.246 0 79.647 0 C 80.049 0 80.397 0.077 80.693 0.231 C 80.989 0.385 81.233 0.597 81.429 0.861 C 81.625 1.121 81.763 1.429 81.859 1.775 C 81.954 2.117 82.002 2.483 82.002 2.867 C 82.002 3.252 81.949 3.632 81.839 3.998 C 81.734 4.364 81.562 4.686 81.333 4.97 C 81.104 5.249 80.803 5.456 80.431 5.595 C 80.44 5.605 80.454 5.615 80.478 5.624 C 80.497 5.634 80.521 5.644 80.545 5.653 C 80.626 5.701 80.765 5.773 80.965 5.875 C 81.171 5.98 81.405 6.101 81.677 6.231 C 81.954 6.36 82.241 6.481 82.542 6.601 C 82.847 6.726 83.143 6.822 83.43 6.899 C 83.721 6.976 83.979 7.015 84.204 7.015 C 84.313 7.015 84.452 7 84.609 6.976 C 84.772 6.952 84.929 6.919 85.082 6.885 C 85.235 6.851 85.355 6.818 85.44 6.793 L 85.541 7.048 L 85.55 7.058 Z M 70.282 0.077 L 73.252 0.077 L 73.252 0.486 L 70.912 0.486 L 70.912 2.593 L 72.794 2.593 L 72.794 2.993 L 70.912 2.993 L 70.912 5.663 L 70.387 5.663 L 70.387 0.606 L 70.282 0.077 Z M 66.074 5.336 C 66.413 5.336 66.7 5.263 66.929 5.119 C 67.163 4.97 67.349 4.778 67.488 4.532 C 67.631 4.292 67.732 4.027 67.794 3.738 C 67.86 3.445 67.894 3.151 67.894 2.863 C 67.894 2.574 67.86 2.281 67.794 2.001 C 67.732 1.713 67.631 1.453 67.488 1.217 C 67.345 0.981 67.158 0.794 66.929 0.654 C 66.7 0.51 66.418 0.438 66.079 0.438 C 65.74 0.438 65.458 0.51 65.224 0.659 C 64.995 0.803 64.809 0.996 64.665 1.246 C 64.527 1.487 64.427 1.756 64.369 2.045 C 64.307 2.333 64.279 2.622 64.279 2.916 C 64.279 3.209 64.307 3.488 64.369 3.777 C 64.436 4.061 64.536 4.32 64.675 4.556 C 64.813 4.792 64.995 4.984 65.224 5.124 C 65.453 5.263 65.735 5.331 66.074 5.331 L 66.074 5.336 Z M 66.084 5.749 C 65.678 5.749 65.324 5.672 65.024 5.518 C 64.727 5.36 64.484 5.143 64.288 4.874 C 64.092 4.6 63.949 4.296 63.854 3.96 C 63.763 3.618 63.715 3.257 63.715 2.892 C 63.715 2.526 63.763 2.165 63.854 1.823 C 63.944 1.482 64.088 1.174 64.283 0.9 C 64.479 0.625 64.723 0.414 65.024 0.255 C 65.324 0.096 65.678 0.014 66.084 0.014 C 66.49 0.014 66.848 0.096 67.139 0.26 C 67.435 0.419 67.679 0.635 67.865 0.905 C 68.061 1.179 68.2 1.487 68.295 1.828 C 68.386 2.165 68.434 2.516 68.434 2.882 C 68.434 3.248 68.386 3.608 68.295 3.95 C 68.204 4.292 68.061 4.6 67.875 4.874 C 67.689 5.138 67.445 5.355 67.149 5.514 C 66.853 5.672 66.499 5.754 66.089 5.754 L 66.084 5.749 Z M 56.503 0.077 L 57.888 2.3 L 59.111 0.077 L 59.646 0.077 L 58.079 2.786 L 58.079 5.663 L 57.506 5.663 L 57.506 2.786 L 55.84 0.077 L 56.503 0.077 Z M 53.456 2.949 L 50.562 2.949 L 50.562 5.668 L 50.037 5.668 L 50.037 0.611 C 50.037 0.611 50.027 0.563 50.008 0.486 C 49.994 0.404 49.98 0.318 49.96 0.231 C 49.946 0.144 49.937 0.091 49.932 0.077 L 50.567 0.077 L 50.567 2.55 L 53.461 2.55 L 53.461 0.077 L 53.987 0.077 L 53.987 5.668 L 53.461 5.668 L 53.461 2.949 L 53.456 2.949 Z M 45.395 0.486 L 45.395 3.065 L 46.326 3.065 C 46.713 3.065 47.023 2.949 47.253 2.718 C 47.487 2.483 47.606 2.17 47.606 1.78 C 47.606 1.39 47.496 1.058 47.276 0.832 C 47.057 0.601 46.746 0.486 46.336 0.486 L 45.395 0.486 Z M 44.75 0.077 L 46.355 0.077 C 46.722 0.077 47.038 0.14 47.3 0.26 C 47.573 0.38 47.778 0.563 47.921 0.813 C 48.069 1.058 48.141 1.381 48.141 1.775 C 48.141 2.141 48.06 2.449 47.902 2.699 C 47.749 2.949 47.539 3.142 47.267 3.276 C 47.004 3.406 46.699 3.469 46.359 3.469 L 45.39 3.469 L 45.39 5.663 L 44.865 5.663 L 44.865 0.606 L 44.75 0.077 Z M 40.547 5.336 C 40.886 5.336 41.173 5.263 41.402 5.119 C 41.636 4.97 41.822 4.778 41.961 4.532 C 42.104 4.292 42.204 4.027 42.267 3.738 C 42.333 3.445 42.367 3.151 42.367 2.863 C 42.367 2.574 42.333 2.281 42.267 2.001 C 42.204 1.713 42.104 1.453 41.961 1.217 C 41.818 0.981 41.631 0.794 41.402 0.654 C 41.173 0.51 40.891 0.438 40.552 0.438 C 40.213 0.438 39.931 0.51 39.697 0.659 C 39.468 0.803 39.282 0.996 39.138 1.246 C 39 1.487 38.9 1.756 38.842 2.045 C 38.78 2.333 38.751 2.622 38.751 2.916 C 38.751 3.209 38.78 3.488 38.842 3.777 C 38.909 4.061 39.009 4.32 39.148 4.556 C 39.286 4.792 39.468 4.984 39.697 5.124 C 39.926 5.263 40.208 5.331 40.547 5.331 L 40.547 5.336 Z M 40.552 5.749 C 40.146 5.749 39.793 5.672 39.492 5.518 C 39.196 5.36 38.952 5.143 38.756 4.874 C 38.56 4.6 38.417 4.296 38.322 3.96 C 38.231 3.618 38.183 3.257 38.183 2.892 C 38.183 2.526 38.231 2.165 38.322 1.823 C 38.412 1.482 38.556 1.174 38.751 0.9 C 38.947 0.625 39.191 0.414 39.492 0.255 C 39.793 0.096 40.146 0.014 40.552 0.014 C 40.958 0.014 41.316 0.096 41.607 0.26 C 41.904 0.419 42.147 0.635 42.333 0.905 C 42.529 1.179 42.668 1.487 42.763 1.828 C 42.854 2.165 42.902 2.516 42.902 2.882 C 42.902 3.248 42.854 3.608 42.763 3.95 C 42.672 4.292 42.529 4.6 42.343 4.874 C 42.157 5.138 41.913 5.355 41.617 5.514 C 41.321 5.672 40.967 5.754 40.557 5.754 L 40.552 5.749 Z M 35.17 0.005 C 35.408 0.005 35.642 0.038 35.867 0.111 C 36.096 0.183 36.321 0.279 36.54 0.395 L 36.282 0.832 C 36.11 0.722 35.929 0.625 35.747 0.553 C 35.571 0.481 35.375 0.447 35.165 0.447 C 34.854 0.447 34.596 0.524 34.391 0.678 C 34.191 0.832 34.095 1.078 34.095 1.41 C 34.095 1.578 34.143 1.727 34.238 1.848 C 34.339 1.968 34.472 2.069 34.63 2.165 C 34.788 2.252 34.959 2.338 35.141 2.425 C 35.318 2.507 35.499 2.598 35.685 2.704 C 35.867 2.8 36.034 2.916 36.182 3.05 C 36.335 3.185 36.459 3.344 36.55 3.536 C 36.641 3.719 36.688 3.945 36.688 4.205 C 36.688 4.571 36.598 4.869 36.421 5.1 C 36.244 5.326 36.01 5.494 35.724 5.6 C 35.437 5.701 35.131 5.754 34.807 5.754 C 34.553 5.754 34.305 5.716 34.071 5.639 C 33.842 5.557 33.613 5.461 33.383 5.355 L 33.613 4.84 C 33.775 4.98 33.976 5.09 34.214 5.177 C 34.453 5.259 34.678 5.302 34.888 5.302 C 35.06 5.302 35.241 5.268 35.432 5.201 C 35.619 5.134 35.781 5.023 35.905 4.869 C 36.039 4.715 36.106 4.513 36.106 4.263 C 36.106 4.013 36.048 3.81 35.938 3.657 C 35.833 3.498 35.69 3.363 35.509 3.257 C 35.337 3.151 35.15 3.05 34.95 2.959 C 34.778 2.877 34.606 2.791 34.439 2.704 C 34.272 2.612 34.119 2.507 33.98 2.396 C 33.842 2.276 33.732 2.141 33.646 1.982 C 33.565 1.819 33.522 1.621 33.522 1.395 C 33.522 1.102 33.603 0.852 33.765 0.65 C 33.928 0.438 34.138 0.279 34.391 0.173 C 34.644 0.067 34.907 0.01 35.17 0.01 L 35.17 0.005 Z M 29.443 5.336 C 29.782 5.336 30.069 5.263 30.298 5.119 C 30.532 4.97 30.718 4.778 30.857 4.532 C 31 4.292 31.101 4.027 31.163 3.738 C 31.229 3.445 31.263 3.151 31.263 2.863 C 31.263 2.574 31.229 2.281 31.163 2.001 C 31.101 1.713 31 1.453 30.857 1.217 C 30.714 0.981 30.527 0.794 30.298 0.654 C 30.069 0.51 29.787 0.438 29.448 0.438 C 29.109 0.438 28.827 0.51 28.593 0.659 C 28.364 0.803 28.178 0.996 28.034 1.246 C 27.896 1.487 27.796 1.756 27.738 2.045 C 27.676 2.333 27.648 2.622 27.648 2.916 C 27.648 3.209 27.676 3.488 27.738 3.777 C 27.805 4.061 27.905 4.32 28.044 4.556 C 28.182 4.792 28.364 4.984 28.593 5.124 C 28.822 5.263 29.104 5.331 29.443 5.331 L 29.443 5.336 Z M 29.453 5.749 C 29.047 5.749 28.693 5.672 28.393 5.518 C 28.096 5.36 27.853 5.143 27.657 4.874 C 27.461 4.6 27.318 4.296 27.223 3.96 C 27.132 3.618 27.084 3.257 27.084 2.892 C 27.084 2.526 27.132 2.165 27.223 1.823 C 27.313 1.482 27.457 1.174 27.652 0.9 C 27.848 0.625 28.092 0.414 28.393 0.255 C 28.693 0.096 29.047 0.014 29.453 0.014 C 29.859 0.014 30.217 0.096 30.508 0.26 C 30.804 0.419 31.048 0.635 31.234 0.905 C 31.43 1.179 31.569 1.487 31.664 1.828 C 31.755 2.165 31.803 2.516 31.803 2.882 C 31.803 3.248 31.755 3.608 31.664 3.95 C 31.573 4.292 31.43 4.6 31.244 4.874 C 31.058 5.138 30.814 5.355 30.518 5.514 C 30.222 5.672 29.868 5.754 29.458 5.754 L 29.453 5.749 Z M 22.724 0.077 L 23.359 0.077 L 23.359 5.259 L 25.775 5.259 L 25.775 5.668 L 22.843 5.668 L 22.843 0.611 L 22.728 0.082 L 22.724 0.077 Z M 19.93 0.077 L 20.565 0.077 L 20.565 5.668 L 20.04 5.668 L 20.04 0.611 C 20.04 0.611 20.03 0.563 20.011 0.486 C 19.997 0.404 19.982 0.318 19.963 0.231 C 19.944 0.144 19.939 0.091 19.935 0.077 L 19.93 0.077 Z M 17.241 2.949 L 14.347 2.949 L 14.347 5.668 L 13.821 5.668 L 13.821 0.611 C 13.821 0.611 13.812 0.563 13.793 0.486 C 13.778 0.404 13.764 0.318 13.745 0.231 C 13.731 0.144 13.721 0.091 13.716 0.077 L 14.352 0.077 L 14.352 2.55 L 17.246 2.55 L 17.246 0.077 L 17.771 0.077 L 17.771 5.668 L 17.246 5.668 L 17.246 2.949 L 17.241 2.949 Z M 9.179 0.486 L 9.179 3.065 L 10.111 3.065 C 10.497 3.065 10.808 2.949 11.037 2.718 C 11.271 2.483 11.39 2.17 11.39 1.78 C 11.39 1.39 11.281 1.058 11.061 0.832 C 10.841 0.601 10.531 0.486 10.12 0.486 L 9.179 0.486 Z M 8.539 0.077 L 10.144 0.077 C 10.512 0.077 10.827 0.14 11.09 0.26 C 11.362 0.38 11.567 0.563 11.71 0.813 C 11.859 1.058 11.93 1.381 11.93 1.775 C 11.93 2.141 11.849 2.449 11.691 2.699 C 11.539 2.949 11.328 3.142 11.056 3.276 C 10.793 3.406 10.488 3.469 10.149 3.469 L 9.179 3.469 L 9.179 5.663 L 8.654 5.663 L 8.654 0.606 L 8.539 0.077 Z M 2.187 0.808 L 1.347 3.18 L 3.004 3.18 L 2.187 0.808 Z M 2.536 0.077 L 4.432 5.668 L 3.83 5.668 L 3.133 3.58 L 1.213 3.58 L 0.516 5.668 L 0 5.668 L 1.91 0.077 L 2.536 0.077 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 52,
      top: 381.82,
      width: 318.544,
      height: 56.18,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 5.448,
    height: 54.538,
    viewBox: "0 0 5.448 54.538",
    fill: "none",
    style: {
      position: "absolute",
      left: 151.684,
      top: 0.454,
      width: 5.448,
      height: 54.538,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.448 0 L 0 0 L 0 54.538 L 5.448 54.538 L 5.448 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 43.893,
    height: 53.804,
    viewBox: "0 0 43.893 53.804",
    fill: "none",
    style: {
      position: "absolute",
      left: 81.363,
      top: 1.188,
      width: 43.893,
      height: 53.804,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.01 53.804 L 0.01 0 L 43.256 0 L 43.256 5.004 L 5.487 5.004 L 5.487 24.043 L 37.479 24.043 L 37.479 28.959 L 5.487 28.959 L 5.487 48.8 L 43.893 48.8 L 43.893 53.804 L 0 53.804 L 0.01 53.804 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 57.880,
    height: 56.180,
    viewBox: "0 0 57.880 56.180",
    fill: "none",
    style: {
      position: "absolute",
      left: 260.664,
      top: 0,
      width: 57.88,
      height: 56.18,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57.88 56.18 L 32.649 0 L 25.076 0 L 0 56.18 L 6.366 56.18 L 12.364 42.57 L 15.339 35.625 C 32.224 34.581 45.98 44.676 49.776 52.877 L 51.215 56.18 L 57.871 56.18 L 57.88 56.18 Z M 26.158 10.78 C 27.375 7.921 28.032 6.23 28.766 3.448 C 29.336 5.97 29.829 7.496 31.287 10.78 L 41.382 33.77 L 43.912 39.44 C 35.905 34.803 22.855 33.161 16.209 33.654 L 26.168 10.78 L 26.158 10.78 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 58.006,
    height: 54.538,
    viewBox: "0 0 58.006 54.538",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.454,
      width: 58.006,
      height: 54.538,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.782 18.315 C 30.321 10.751 41.546 6.143 53.823 6.143 L 53.823 0.734 C 32.591 0.734 9.843 17.938 5.448 38.532 L 5.448 0 L 0 0 L 0 54.538 L 5.448 54.538 L 5.448 53.843 C 5.622 41.662 10.307 30.563 17.909 22.14 L 50.307 54.538 L 58.006 54.538 L 21.782 18.315 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 58.006,
    height: 54.538,
    viewBox: "0 0 58.006 54.538",
    fill: "none",
    style: {
      position: "absolute",
      left: 191.337,
      top: 0.454,
      width: 58.006,
      height: 54.538,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.782 18.315 C 30.321 10.751 41.546 6.143 53.823 6.143 L 53.823 0.734 C 32.591 0.734 9.843 17.938 5.448 38.532 L 5.448 0 L 0 0 L 0 54.538 L 5.448 54.538 L 5.448 53.843 C 5.622 41.662 10.307 30.563 17.909 22.14 L 50.307 54.538 L 58.006 54.538 L 21.782 18.315 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 562,
      width: 1440,
      height: 54,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 1440,
    height: 1,
    viewBox: "0 -0.500 1440 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 1440 0 L 1440 -0.5 L 1440 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 1062,
      top: 0,
      width: 144,
      height: 54,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 12,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      color: "rgb(42,43,45)"
    }
  }, props.text1 ?? "特定商取引法に基づく表記"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 51,
      top: 0,
      width: 52,
      height: 54,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 12,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)"
    }
  }, props.text2 ?? "©KEiKA1"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 1269,
      top: 0,
      width: 120,
      height: 54,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 12,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      color: "rgb(42,43,45)"
    }
  }, props.text3 ?? "プライバシーポリシー")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1062,
      top: 167,
      display: "flex",
      flexDirection: "column",
      gap: 26,
      alignItems: "flex-start",
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch",
      whiteSpace: "nowrap"
    }
  }, props.text4 ?? "PRODUCTS"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "Ingredientslist"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "CONCEPT"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "NEWS"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "COLUMN"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "MEDICAL PERSPECTIVES")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1277,
      top: 167,
      width: 90,
      height: 125,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 37,
      height: 19,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, "Q&A"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 71,
      width: 75,
      height: 54,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)"
    }
  }, "\u3054\u5229\u7528\u6848\u5185"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 28,
      width: 90,
      height: 54,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)"
    }
  }, "\u304A\u554F\u3044\u5408\u308F\u305B")));
}

// figma node: 271:22947 header2 (2 variants)
const __venc_Header24 = v => String(v).replace(/[%|=]/g, encodeURIComponent);
const __vkey_Header24 = p => "prop=" + __venc_Header24(p.prop);
function Header24() {
  /* canvas 内のヘッダーは描画しない */
  return null;
}
function Header24Figma(_p = {}) {
  const props = {
    ..._p,
    prop: _p.prop ?? "default"
  };
  const __body0 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 1440,
      height: 90,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 90
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 622.421,
      top: 31.312,
      width: 200.579,
      height: 35.375,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 3.430,
    height: 34.341,
    viewBox: "0 0 3.430 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 95.512,
      top: 0.286,
      width: 3.43,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 27.638,
    height: 33.879,
    viewBox: "0 0 27.638 33.879",
    fill: "none",
    style: {
      position: "absolute",
      left: 51.232,
      top: 0.748,
      width: 27.638,
      height: 33.879,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.006 33.879 L 0.006 0 L 27.237 0 L 27.237 3.151 L 3.455 3.151 L 3.455 15.139 L 23.6 15.139 L 23.6 18.235 L 3.455 18.235 L 3.455 30.728 L 27.638 30.728 L 27.638 33.879 L 0 33.879 L 0.006 33.879 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.446,
    height: 35.375,
    viewBox: "0 0 36.446 35.375",
    fill: "none",
    style: {
      position: "absolute",
      left: 164.133,
      top: 0,
      width: 36.446,
      height: 35.375,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.446 35.375 L 20.558 0 L 15.79 0 L 0 35.375 L 4.008 35.375 L 7.785 26.805 L 9.659 22.432 C 20.291 21.775 28.952 28.131 31.343 33.295 L 32.249 35.375 L 36.44 35.375 L 36.446 35.375 Z M 16.471 6.788 C 17.238 4.988 17.651 3.923 18.113 2.171 C 18.472 3.759 18.782 4.72 19.701 6.788 L 26.057 21.264 L 27.651 24.834 C 22.608 21.915 14.391 20.881 10.206 21.191 L 16.477 6.788 L 16.471 6.788 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.525,
    height: 34.341,
    viewBox: "0 0 36.525 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.286,
      width: 36.525,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.716 11.532 C 19.093 6.77 26.16 3.868 33.891 3.868 L 33.891 0.462 C 20.522 0.462 6.198 11.295 3.43 24.263 L 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 33.903 C 3.54 26.233 6.49 19.245 11.277 13.941 L 31.677 34.341 L 36.525 34.341 L 13.716 11.532 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.525,
    height: 34.341,
    viewBox: "0 0 36.525 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 120.48,
      top: 0.286,
      width: 36.525,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.716 11.532 C 19.093 6.77 26.16 3.868 33.891 3.868 L 33.891 0.462 C 20.522 0.462 6.198 11.295 3.43 24.263 L 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 33.903 C 3.54 26.233 6.49 19.245 11.277 13.941 L 31.677 34.341 L 36.525 34.341 L 13.716 11.532 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1213,
      top: 42,
      width: 98,
      height: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 7.5,
      top: -11.5,
      width: 20,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 10.353,
    height: 10.498,
    viewBox: "0 0 10.353 10.498",
    fill: "none",
    style: {
      position: "absolute",
      left: 5.024,
      top: 0,
      width: 10.353,
      height: 10.498,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.176 10.498 C 8.033 10.498 10.353 8.146 10.353 5.249 C 10.353 2.352 8.026 0 5.176 0 C 2.326 0 0 2.352 0 5.249 C 0 8.146 2.319 10.498 5.176 10.498 Z M 5.176 1.474 C 7.226 1.474 8.899 3.17 8.899 5.249 C 8.899 7.328 7.226 9.023 5.176 9.023 C 3.126 9.023 1.454 7.328 1.454 5.249 C 1.454 3.17 3.126 1.474 5.176 1.474 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20,
    height: 7.202,
    viewBox: "0 0 20 7.202",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 12.798,
      width: 20,
      height: 7.202,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.927 6.391 C 19.927 6.325 19.753 4.711 18.401 3.118 C 17.186 1.696 14.751 0 10.004 0 C 5.256 0 2.814 1.696 1.607 3.118 C 0.247 4.711 0.08 6.325 0.08 6.391 L 0 7.202 L 20 7.202 L 19.92 6.391 L 19.927 6.391 Z M 10.004 5.728 L 1.73 5.728 C 2.246 4.29 4.028 1.482 10.004 1.482 C 15.98 1.482 17.761 4.298 18.277 5.728 L 10.004 5.728 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 3,
      top: 13,
      width: 29,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text1 ?? "Login"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 66,
      top: 13,
      width: 25,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text2 ?? "Cart "), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 64,
      top: -10,
      width: 23,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 55,
      top: 37,
      display: "flex",
      flexDirection: "row",
      gap: 72,
      alignItems: "center",
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, props.text3 ?? "Products"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, props.text4 ?? "Ingredientslist"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, "News")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1340,
      top: 40,
      width: 50,
      height: 14,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1.300,
    viewBox: "0 -0.650 50 1.300",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 50,
      height: 1.2999999523162842,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.65 L 0 0 L 50 0 L 50 -0.65 L 50 -1.3 L 0 -1.3 L 0 -0.65 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1.300,
    viewBox: "0 -0.650 50 1.300",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 14,
      width: 50,
      height: 1.2999999523162842,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.65 L 0 0 L 50 0 L 50 -0.65 L 50 -1.3 L 0 -1.3 L 0 -0.65 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
  const __body1 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 1440,
      height: 90,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 90,
      backgroundColor: "rgb(249,249,249)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 89,
      width: 1440,
      height: 1,
      backgroundColor: "rgb(42,43,45)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 622.421,
      top: 31.312,
      width: 200.579,
      height: 35.375,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 3.430,
    height: 34.341,
    viewBox: "0 0 3.430 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 95.512,
      top: 0.286,
      width: 3.43,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 27.638,
    height: 33.879,
    viewBox: "0 0 27.638 33.879",
    fill: "none",
    style: {
      position: "absolute",
      left: 51.232,
      top: 0.748,
      width: 27.638,
      height: 33.879,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.006 33.879 L 0.006 0 L 27.237 0 L 27.237 3.151 L 3.455 3.151 L 3.455 15.139 L 23.6 15.139 L 23.6 18.235 L 3.455 18.235 L 3.455 30.728 L 27.638 30.728 L 27.638 33.879 L 0 33.879 L 0.006 33.879 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.446,
    height: 35.375,
    viewBox: "0 0 36.446 35.375",
    fill: "none",
    style: {
      position: "absolute",
      left: 164.133,
      top: 0,
      width: 36.446,
      height: 35.375,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.446 35.375 L 20.558 0 L 15.79 0 L 0 35.375 L 4.008 35.375 L 7.785 26.805 L 9.659 22.432 C 20.291 21.775 28.952 28.131 31.343 33.295 L 32.249 35.375 L 36.44 35.375 L 36.446 35.375 Z M 16.471 6.788 C 17.238 4.988 17.651 3.923 18.113 2.171 C 18.472 3.759 18.782 4.72 19.701 6.788 L 26.057 21.264 L 27.651 24.834 C 22.608 21.915 14.391 20.881 10.206 21.191 L 16.477 6.788 L 16.471 6.788 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.525,
    height: 34.341,
    viewBox: "0 0 36.525 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.286,
      width: 36.525,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.716 11.532 C 19.093 6.77 26.16 3.868 33.891 3.868 L 33.891 0.462 C 20.522 0.462 6.198 11.295 3.43 24.263 L 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 33.903 C 3.54 26.233 6.49 19.245 11.277 13.941 L 31.677 34.341 L 36.525 34.341 L 13.716 11.532 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.525,
    height: 34.341,
    viewBox: "0 0 36.525 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 120.48,
      top: 0.286,
      width: 36.525,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.716 11.532 C 19.093 6.77 26.16 3.868 33.891 3.868 L 33.891 0.462 C 20.522 0.462 6.198 11.295 3.43 24.263 L 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 33.903 C 3.54 26.233 6.49 19.245 11.277 13.941 L 31.677 34.341 L 36.525 34.341 L 13.716 11.532 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 55,
      top: 37,
      display: "flex",
      flexDirection: "row",
      gap: 72,
      alignItems: "center",
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, props.text1 ?? "Products"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, props.text2 ?? "Ingredientslist"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, props.text3 ?? "News")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1340,
      top: 40,
      width: 50,
      height: 14,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1.300,
    viewBox: "0 -0.650 50 1.300",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 50,
      height: 1.2999999523162842,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.65 L 0 0 L 50 0 L 50 -0.65 L 50 -1.3 L 0 -1.3 L 0 -0.65 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1.300,
    viewBox: "0 -0.650 50 1.300",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 14,
      width: 50,
      height: 1.2999999523162842,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.65 L 0 0 L 50 0 L 50 -0.65 L 50 -1.3 L 0 -1.3 L 0 -0.65 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1213,
      top: 42,
      width: 98,
      height: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 7.5,
      top: -11.5,
      width: 20,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 10.353,
    height: 10.498,
    viewBox: "0 0 10.353 10.498",
    fill: "none",
    style: {
      position: "absolute",
      left: 5.024,
      top: 0,
      width: 10.353,
      height: 10.498,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.176 10.498 C 8.033 10.498 10.353 8.146 10.353 5.249 C 10.353 2.352 8.026 0 5.176 0 C 2.326 0 0 2.352 0 5.249 C 0 8.146 2.319 10.498 5.176 10.498 Z M 5.176 1.474 C 7.226 1.474 8.899 3.17 8.899 5.249 C 8.899 7.328 7.226 9.023 5.176 9.023 C 3.126 9.023 1.454 7.328 1.454 5.249 C 1.454 3.17 3.126 1.474 5.176 1.474 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20,
    height: 7.202,
    viewBox: "0 0 20 7.202",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 12.798,
      width: 20,
      height: 7.202,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.927 6.391 C 19.927 6.325 19.753 4.711 18.401 3.118 C 17.186 1.696 14.751 0 10.004 0 C 5.256 0 2.814 1.696 1.607 3.118 C 0.247 4.711 0.08 6.325 0.08 6.391 L 0 7.202 L 20 7.202 L 19.92 6.391 L 19.927 6.391 Z M 10.004 5.728 L 1.73 5.728 C 2.246 4.29 4.028 1.482 10.004 1.482 C 15.98 1.482 17.761 4.298 18.277 5.728 L 10.004 5.728 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 3,
      top: 13,
      width: 29,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text4 ?? "Login"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 66,
      top: 13,
      width: 25,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, "Cart "), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 64,
      top: -10,
      width: 23,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
  const __impls = {
    // figma: プロパティ1=Default
    "prop=default": __body0,
    // figma: プロパティ1=バリアント2
    "prop=バリアント2": __body1
  };
  return (__impls[__vkey_Header24(props)] ?? __body0)();
}

// figma node: 271:25405 12PC_contract
function PCContract12(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 1440,
      height: 3219,
      overflow: "hidden",
      backgroundColor: "rgb(227,226,222)",
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement(Footer8, {
    style: {
      position: "absolute",
      left: 0,
      top: 2603,
      width: 1440,
      height: 616
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 2202,
      width: 1440,
      height: 400
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 400,
      backgroundColor: "rgb(20,41,80)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 525,
      top: 51,
      width: 390,
      height: 290
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 480,
      height: 400,
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 480,
      height: 400
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 480,
      height: 400,
      clipPath: "inset(0px 0px 0px 0px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: -1087.706,
      width: 1440,
      height: 1524.706,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 1524.7059326171875,
      clipPath: "inset(0px 0px 0px 0px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fig-asset-2c93637f5cfae14f",
    style: {
      position: "absolute",
      left: -13,
      top: -122.294,
      width: 1458,
      height: 2592
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 45,
      top: 55,
      width: 390,
      height: 290
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 290
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 125,
      top: 24,
      width: 140,
      height: 237
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 138,
      height: 94,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 24,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "94px",
      letterSpacing: "0.160em",
      color: "rgb(249,249,249)"
    }
  }, "Instagram"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 9,
      top: 150,
      width: 122,
      height: 94,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 18,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "94px",
      letterSpacing: "0.160em",
      color: "rgb(249,249,249)"
    }
  }, "FOLLOW US")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 175,
      top: 128,
      width: 39,
      height: 39,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 39.000,
    height: 39,
    viewBox: "0 0 39.000 39",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 39,
      height: 39,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.424 0.135 C 9.349 0.233 7.932 0.565 6.694 1.05 C 5.412 1.55 4.325 2.22 3.244 3.305 C 2.162 4.391 1.497 5.48 1.001 6.763 C 0.521 8.004 0.195 9.422 0.104 11.498 C 0.013 13.579 -0.008 14.242 0.002 19.537 C 0.012 24.832 0.036 25.497 0.135 27.577 C 0.234 29.652 0.565 31.068 1.05 32.307 C 1.551 33.589 2.22 34.675 3.306 35.757 C 4.391 36.838 5.48 37.502 6.764 37.999 C 8.004 38.479 9.423 38.805 11.498 38.896 C 13.578 38.988 14.242 39.008 19.536 38.998 C 24.832 38.988 25.497 38.964 27.577 38.865 C 29.651 38.766 31.067 38.434 32.307 37.95 C 33.589 37.449 34.675 36.781 35.756 35.695 C 36.837 34.609 37.502 33.52 37.998 32.236 C 38.478 30.996 38.805 29.578 38.895 27.503 C 38.986 25.422 39.007 24.757 38.997 19.463 C 38.987 14.168 38.963 13.505 38.865 11.425 C 38.766 9.349 38.434 7.933 37.949 6.694 C 37.448 5.412 36.78 4.326 35.694 3.244 C 34.609 2.163 33.52 1.497 32.236 1.002 C 30.995 0.522 29.577 0.195 27.502 0.105 C 25.422 0.013 24.758 -0.008 19.463 0.002 C 14.168 0.013 13.504 0.035 11.424 0.135 M 11.652 35.386 C 9.75 35.304 8.718 34.988 8.03 34.723 C 7.119 34.37 6.469 33.948 5.784 33.269 C 5.102 32.587 4.678 31.939 4.322 31.03 C 4.055 30.342 3.733 29.31 3.644 27.409 C 3.547 25.354 3.525 24.737 3.516 19.53 C 3.506 14.325 3.525 13.708 3.615 11.651 C 3.696 9.752 4.014 8.718 4.278 8.031 C 4.63 7.118 5.052 6.469 5.732 5.785 C 6.414 5.101 7.062 4.678 7.972 4.322 C 8.66 4.054 9.69 3.735 11.591 3.645 C 13.647 3.547 14.263 3.526 19.469 3.516 C 24.675 3.506 25.292 3.524 27.349 3.615 C 29.249 3.698 30.283 4.012 30.97 4.278 C 31.881 4.631 32.531 5.051 33.215 5.733 C 33.899 6.414 34.323 7.061 34.678 7.973 C 34.947 8.659 35.266 9.691 35.356 11.591 C 35.454 13.647 35.476 14.264 35.485 19.47 C 35.495 24.676 35.476 25.293 35.386 27.349 C 35.304 29.25 34.988 30.283 34.723 30.971 C 34.37 31.882 33.949 32.532 33.268 33.216 C 32.587 33.898 31.939 34.323 31.028 34.679 C 30.342 34.947 29.31 35.267 27.41 35.357 C 25.354 35.453 24.738 35.476 19.53 35.485 C 14.325 35.495 13.709 35.476 11.652 35.386 M 27.548 9.076 C 27.55 10.368 28.601 11.413 29.892 11.411 C 31.184 11.409 32.23 10.359 32.228 9.068 C 32.225 7.776 31.175 6.73 29.883 6.732 C 28.591 6.735 27.545 7.785 27.548 9.076 M 9.488 19.519 C 9.498 25.049 13.99 29.523 19.519 29.512 C 25.048 29.501 29.524 25.011 29.513 19.481 C 29.502 13.952 25.01 9.477 19.48 9.487 C 13.951 9.498 9.477 13.99 9.488 19.519 Z M 13 19.512 C 12.994 15.923 15.899 13.007 19.487 13.001 C 23.076 12.994 25.993 15.898 26 19.488 C 26.007 23.077 23.102 25.993 19.512 26 C 15.923 26.007 13.007 23.102 13 19.513",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement(Component32_, {
    style: {
      position: "relative",
      width: 480,
      height: 400,
      flexShrink: 0
    },
    prop: "デフォルト"
  }), /*#__PURE__*/React.createElement(Component33_, {
    style: {
      position: "relative",
      width: 480,
      height: 400,
      flexShrink: 0
    },
    prop: "デフォルト"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 400,
    height: 1,
    viewBox: "0 -0.500 400 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,1,-1,0,480,0)",
      transformOrigin: "0 0",
      width: 400,
      height: 1,
      color: "rgb(227,226,222)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 400 0 L 400 -0.5 L 400 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 400,
    height: 1,
    viewBox: "0 -0.500 400 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,1,-1,0,959,0)",
      transformOrigin: "0 0",
      width: 400,
      height: 1,
      color: "rgb(227,226,222)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 400 0 L 400 -0.5 L 400 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("svg", {
    width: 1436,
    height: 1,
    viewBox: "0 -0.500 1436 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 4,
      top: 7068,
      width: 1436,
      height: 1,
      color: "rgb(217,217,217)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 1436 0 L 1436 -0.5 L 1436 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 1436,
    height: 1,
    viewBox: "0 -0.500 1436 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 4,
      top: 7585,
      width: 1436,
      height: 1,
      color: "rgb(217,217,217)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 1436 0 L 1436 -0.5 L 1436 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 40,
      width: 1440,
      height: 380
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 380,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 380,
      overflow: "hidden"
    }
  })), /*#__PURE__*/React.createElement(Component22__, {
    style: {
      position: "absolute",
      left: 52,
      top: 243,
      width: 279,
      height: 86
    },
    text1: "CONTRACT",
    text2: "特定商取引法"
  })), /*#__PURE__*/React.createElement(window.KEIKANewsPC || "div", {
    style: { position: "absolute", left: 0, top: 0, width: 1440, height: 40 }
  }), /*#__PURE__*/React.createElement(Header24, {
    style: {
      position: "absolute",
      left: 0,
      top: 40,
      width: 1440,
      height: 90
    },
    prop: "default"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 480,
      top: 496,
      width: 910,
      display: "flex",
      flexDirection: "column",
      gap: 32,
      alignItems: "flex-start",
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u696D\u8005\u306E\u540D\u79F0")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u682A\u5F0F\u4F1A\u793EKEiKA1"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u8CAC\u4EFB\u8005\u540D")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u5C3E\u5CF6\u6842\u9999"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u696D\u8005\u306E\u4F4F\u6240")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u6771\u4EAC\u90FD\u6E0B\u8C37\u533A\u4EE3\u5B98\u5C71\u753A13-8-513"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u696D\u8005\u306E\u9023\u7D61\u5148")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      whiteSpace: "pre-wrap"
    }
  }, "メールアドレス：contact@keika1.com\n電話番号：09086467996"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      height: 99,
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      height: 69,
      display: "flex",
      flexDirection: "row",
      gap: 20,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      height: 113,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      width: 240,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      whiteSpace: "pre-wrap"
    }
  }, "商品代金以外の必要料金・銀行振り込みでご購入の際の\n振り込み手数料")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u30FB\u4EE3\u91D1\u5F15\u63DB\u3067\u3054\u8CFC\u5165\u306E\u969B\u306E\u4EE3\u5F15\u304D\u624B\u6570\u6599\u2028\u30FB\u5404\u7A2E\u6C7A\u6E08\u65B9\u6CD5\u3067\u767A\u751F\u3059\u308B\u624B\u6570\u6599"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u7533\u3057\u8FBC\u307F\u6709\u52B9\u671F\u9650")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u539F\u5247\u3001\u53D7\u6CE8\u78BA\u8A8D\uFF08\u53D7\u6CE8\u78BA\u8A8D\u306E\u70BA\u306E\u81EA\u52D5\u9001\u4FE1\u30E1\u30FC\u30EB\u767A\u4FE1\uFF09\u5F8C\u30015\u65E5\u9593\u3068\u3057\u307E\u3059\u3002"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u4E0D\u826F\u54C1")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u5546\u54C1\u5230\u7740\u5F8C24\u6642\u9593\u4EE5\u5185\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002\u2028\u5546\u54C1\u306B\u554F\u984C\u304C\u3042\u308B\u5834\u5408\u306F\u3001\u901F\u3084\u304B\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002\u2028\u5546\u54C1\u306B\u6B20\u9665\u304C\u3042\u308B\u5834\u5408\u3092\u9664\u304D\u3001\u8FD4\u54C1\u306B\u306F\u5FDC\u3058\u304B\u306D\u307E\u3059\u306E\u3067\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u6570\u91CF\u3000")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u5404\u5546\u54C1\u30DA\u30FC\u30B8\u306B\u3066\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u5F15\u304D\u6E21\u3057\u6642\u671F")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      width: 639,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u5728\u5EAB\u304C\u3042\u308B\u5834\u5408 \u30FB\u767A\u9001\u306F\u3054\u6CE8\u6587\u3092\u53D7\u3051\u3066\u304B\u30893\u55B6\u696D\u65E5\u4EE5\u5185\u306B\u767A\u9001\u3044\u305F\u3057\u307E\u3059\u3002\uFF08\u65E5\u795D\u9664\u304F\uFF09\u2028\u30FB\u4E88\u7D04\u8CA9\u58F2\u306E\u5834\u5408\u3001\u4E88\u7D04\u8CA9\u58F2\u65E5\u3088\u308A\u3054\u6CE8\u6587\u3092\u53D7\u3051\u3066\u304B\u30893\u55B6\u696D\u65E5\u4EE5\u5185\u306B\u767A\u9001\u3044\u305F\u3057\u307E\u3059\u3002\uFF08\u65E5\u795D\u9664\u304F\uFF09"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u304A\u652F\u6255\u3044")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      width: 639,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u65B9\u6CD5\u9280\u884C\u632F\u8FBC\u30FB\u5404\u7A2E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u304A\u652F\u6255\u3044\u306B\u3064\u3044\u3066")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      width: 639,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u30FB\u9280\u884C\u632F\u8FBC\u306E\u5834\u5408\u2028\u3054\u6CE8\u6587\u65E5\u3088\u308A5\u65E5\u4EE5\u5185\u306B\u5F53\u5E97\u6307\u5B9A\u306E\u53E3\u5EA7\u3078\u304A\u632F\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002\u20285\u65E5\u3092\u8D85\u3048\u305F\u5834\u5408\u306F\u4E00\u65E6\u30AD\u30E3\u30F3\u30BB\u30EB\u6271\u3044\u3068\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002\u2028\u518D\u5EA6\u3001\u5FA1\u6CE8\u6587\u3044\u305F\u3060\u304D\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u3057\u307E\u3059\u3002\u2028\u2028\u30FB\u4EE3\u91D1\u5F15\u63DB\u306E\u5834\u5408\u2028\u5546\u54C1\u306E\u304A\u5C4A\u3051\u6642\u306B\u3001\u914D\u9054\u54E1\u306B\u4EE3\u91D1\u306E\u304A\u652F\u6255\u3044\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8FD4\u54C1\u306B\u3064\u3044\u3066")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      width: 639,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      whiteSpace: "pre-wrap"
    }
  }, "以下の場合を除き、ご注文後の返品・変更・キャンセルはお受けできません。 \n商品がご注文と異なった場合や商品に欠陥がある場合、ご到着後24時間以内にご連絡いただき返送は５日以内とさせていただきます。"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 910 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch",
      color: "rgb(129,136,148)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 910 0 L 910 -0.5 L 910 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 503,
      display: "flex",
      flexDirection: "row",
      gap: 70,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      height: 30,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8FD4\u54C1\u9001\u6599\u3000")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      width: 639,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u5546\u54C1\u304C\u3054\u6CE8\u6587\u3068\u7570\u306A\u3063\u305F\u5834\u5408\u3084\u5546\u54C1\u306B\u6B20\u9665\u304C\u3042\u308B\u5834\u5408\u306F\u5F53\u5E97\u8CA0\u62C5\u3068\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002")))));
}

// figma node: 271:24112 定期購入継続率90％超え！トゥインクルヴィヴィ　ミニボトル販売中！
function Component25_(p) {
  /* 共通パーツへ委譲 → KEIKANewsSP */
  var C = window.KEIKANewsSP;
  if (!C) { console.error("[KEIKA] KEIKANewsSP 未読込"); return null; }
  return React.createElement(C, Object.assign({ bare: true }, p));
}
function Component25_Figma(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 366,
      height: 18,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 1,
      width: 839,
      height: 17,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 12,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(249,249,249)"
    }
  }, props.text1 ?? "定期購入継続率90％超え！トゥインクルヴィヴィ　ミニボトル販売中！  定期購入継続率90％超え！トゥインクルヴィヴィ　ミニボトル販売中！"));
}

// figma node: 271:23588 footer
function Footer7(p) {
  /* 共通パーツへ委譲 → KEIKAFooterSP */
  var C = window.KEIKAFooterSP;
  if (!C) { console.error("[KEIKA] KEIKAFooterSP 未読込"); return null; }
  return React.createElement(C, p);
}
function Footer7Figma(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 390,
      height: 654,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: -0.006,
      top: 0,
      width: 390,
      height: 654,
      backgroundColor: "rgb(227,226,222)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 600.238,
      width: 390,
      height: 54,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 390,
    height: 1,
    viewBox: "0 -0.500 390 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 390 0 L 390 -0.5 L 390 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 14,
      top: 0,
      width: 52,
      height: 54,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 12,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)"
    }
  }, props.text1 ?? "©KEiKA1")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 129,
      top: 600.238,
      width: 120,
      height: 54,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 10,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      color: "rgb(42,43,45)"
    }
  }, props.text2 ?? "特定商取引法に基づく表記"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 267,
      top: 600.238,
      width: 100,
      height: 54,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 10,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      color: "rgb(42,43,45)"
    }
  }, props.text3 ?? "プライバシーポリシー"), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 20,
      top: 286.238,
      display: "flex",
      flexDirection: "column",
      gap: 26,
      alignItems: "flex-start",
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch",
      whiteSpace: "nowrap"
    }
  }, props.text4 ?? "PRODUCTS"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, "Ingredientslist"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "CONCEPT"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "NEWS"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "COLUMN"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "MEDICAL PERSPECTIVES")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 204,
      top: 286.238,
      width: 90,
      height: 125,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 37,
      height: 19,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, "Q&A"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 71,
      width: 75,
      height: 54,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)"
    }
  }, "\u3054\u5229\u7528\u6848\u5185"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 28,
      width: 90,
      height: 54,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "54px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)"
    }
  }, "\u304A\u554F\u3044\u5408\u308F\u305B")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 20,
      top: 163.738,
      width: 249,
      height: 59,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 248.876,
    height: 27.434,
    viewBox: "0 0 248.876 27.434",
    fill: "none",
    style: {
      position: "absolute",
      left: 0.124,
      top: -0.005,
      width: 248.876,
      height: 27.434,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 248.876 26.515 C 248.876 26.755 248.785 26.967 248.608 27.15 C 248.441 27.318 248.236 27.405 247.992 27.405 C 247.749 27.405 247.543 27.318 247.362 27.15 C 247.195 26.972 247.109 26.76 247.109 26.515 C 247.109 26.269 247.195 26.053 247.362 25.88 C 247.529 25.711 247.739 25.625 247.992 25.625 C 248.245 25.625 248.436 25.716 248.608 25.894 C 248.785 26.062 248.876 26.269 248.876 26.515 Z M 240.69 18.388 L 237.801 18.388 L 237.801 17.46 L 244.888 17.46 L 244.888 18.388 L 241.96 18.388 L 241.96 27.265 L 240.69 27.265 L 240.69 18.388 Z M 232.853 27.429 C 232.084 27.429 231.42 27.294 230.861 27.025 C 230.307 26.755 229.849 26.39 229.486 25.932 C 229.118 25.466 228.851 24.941 228.669 24.354 C 228.502 23.772 228.416 23.171 228.416 22.55 C 228.416 21.877 228.516 21.232 228.712 20.611 C 228.908 19.981 229.194 19.423 229.567 18.927 C 229.949 18.432 230.427 18.042 231 17.753 C 231.568 17.465 232.232 17.32 232.977 17.32 C 233.287 17.32 233.626 17.359 233.994 17.441 C 234.367 17.513 234.725 17.624 235.064 17.777 C 235.403 17.931 235.68 18.133 235.895 18.384 L 235.198 19.163 C 235.031 18.966 234.816 18.802 234.558 18.677 C 234.3 18.542 234.028 18.441 233.741 18.369 C 233.464 18.297 233.201 18.263 232.953 18.263 C 232.437 18.263 231.984 18.384 231.587 18.629 C 231.196 18.865 230.866 19.182 230.599 19.586 C 230.331 19.991 230.126 20.443 229.982 20.948 C 229.849 21.453 229.782 21.963 229.782 22.483 C 229.782 23.291 229.911 23.994 230.169 24.585 C 230.427 25.167 230.794 25.625 231.267 25.947 C 231.74 26.26 232.299 26.418 232.939 26.418 C 233.311 26.418 233.717 26.365 234.157 26.255 C 234.596 26.144 235.045 25.976 235.508 25.745 L 235.924 26.515 C 235.728 26.659 235.499 26.789 235.241 26.904 C 234.992 27.01 234.725 27.106 234.438 27.188 C 234.161 27.27 233.884 27.328 233.607 27.361 C 233.34 27.405 233.092 27.429 232.858 27.429 L 232.853 27.429 Z M 220.412 17.46 L 226.257 17.46 L 226.257 18.388 L 221.844 18.388 L 221.844 21.771 L 225.269 21.771 L 225.269 22.685 L 221.844 22.685 L 221.844 26.337 L 226.257 26.337 L 226.257 27.265 L 220.603 27.265 L 220.603 18.345 L 220.416 17.455 L 220.412 17.46 Z M 211.199 17.46 L 215.449 24.046 C 215.531 24.172 215.617 24.306 215.703 24.451 C 215.793 24.585 215.879 24.715 215.97 24.84 C 215.96 24.686 215.951 24.537 215.941 24.383 C 215.932 24.22 215.927 24.071 215.927 23.926 L 215.927 17.46 L 216.944 17.46 L 216.944 27.333 L 216.156 27.333 L 211.194 19.683 C 211.123 19.567 211.041 19.447 210.955 19.317 C 210.874 19.182 210.788 19.057 210.702 18.942 C 210.721 19.086 210.731 19.235 210.731 19.384 C 210.74 19.529 210.745 19.673 210.745 19.817 L 210.745 27.265 L 209.728 27.265 L 209.728 18.345 L 209.542 17.455 L 211.199 17.455 L 211.199 17.46 Z M 200.315 17.46 L 204.565 24.046 C 204.646 24.172 204.732 24.306 204.818 24.451 C 204.909 24.585 204.995 24.715 205.086 24.84 L 205.057 24.383 C 205.048 24.22 205.043 24.071 205.043 23.926 L 205.043 17.46 L 206.06 17.46 L 206.06 27.333 L 205.272 27.333 L 200.31 19.683 C 200.238 19.567 200.157 19.447 200.071 19.317 C 199.99 19.182 199.904 19.057 199.818 18.942 C 199.837 19.086 199.847 19.235 199.847 19.384 C 199.856 19.529 199.861 19.673 199.861 19.817 L 199.861 27.265 L 198.844 27.265 L 198.844 18.345 L 198.657 17.455 L 200.315 17.455 L 200.315 17.46 Z M 191.417 26.5 C 191.986 26.5 192.463 26.38 192.85 26.135 C 193.232 25.894 193.542 25.567 193.772 25.163 C 194.006 24.759 194.168 24.316 194.268 23.83 C 194.374 23.344 194.431 22.858 194.431 22.377 C 194.431 21.896 194.378 21.405 194.268 20.924 C 194.168 20.438 194.006 20 193.772 19.606 C 193.538 19.202 193.227 18.879 192.836 18.634 C 192.454 18.393 191.981 18.268 191.417 18.268 C 190.854 18.268 190.381 18.388 189.984 18.634 C 189.602 18.874 189.292 19.202 189.063 19.606 C 188.838 20.01 188.676 20.452 188.566 20.938 C 188.466 21.424 188.418 21.91 188.418 22.391 C 188.418 22.873 188.466 23.363 188.566 23.844 C 188.671 24.321 188.838 24.759 189.063 25.163 C 189.297 25.567 189.602 25.889 189.984 26.135 C 190.376 26.375 190.854 26.5 191.417 26.5 Z M 191.403 27.414 C 190.682 27.414 190.047 27.28 189.502 27.01 C 188.967 26.741 188.523 26.37 188.165 25.904 C 187.807 25.427 187.539 24.888 187.363 24.287 C 187.186 23.686 187.095 23.046 187.095 22.372 C 187.095 21.699 187.181 21.059 187.348 20.457 C 187.525 19.846 187.792 19.307 188.151 18.841 C 188.509 18.364 188.958 17.994 189.502 17.725 C 190.047 17.455 190.682 17.32 191.412 17.32 C 192.143 17.32 192.778 17.455 193.313 17.725 C 193.858 17.994 194.307 18.364 194.665 18.841 C 195.023 19.307 195.286 19.846 195.453 20.457 C 195.63 21.059 195.72 21.699 195.72 22.372 C 195.72 23.046 195.63 23.686 195.453 24.297 C 195.276 24.898 195.009 25.432 194.65 25.899 C 194.292 26.365 193.843 26.736 193.299 27.005 C 192.764 27.275 192.129 27.41 191.398 27.41 L 191.403 27.414 Z M 182.052 27.429 C 181.283 27.429 180.619 27.294 180.06 27.025 C 179.506 26.755 179.048 26.39 178.685 25.932 C 178.317 25.466 178.05 24.941 177.868 24.354 C 177.701 23.772 177.615 23.171 177.615 22.55 C 177.615 21.877 177.715 21.232 177.911 20.611 C 178.107 19.981 178.393 19.423 178.766 18.927 C 179.148 18.432 179.626 18.042 180.199 17.753 C 180.767 17.465 181.431 17.32 182.176 17.32 C 182.486 17.32 182.825 17.359 183.193 17.441 C 183.566 17.513 183.924 17.624 184.263 17.777 C 184.602 17.931 184.879 18.133 185.094 18.384 L 184.397 19.163 C 184.23 18.966 184.015 18.802 183.757 18.677 C 183.499 18.542 183.227 18.441 182.94 18.369 C 182.663 18.297 182.4 18.263 182.152 18.263 C 181.636 18.263 181.183 18.384 180.786 18.629 C 180.395 18.865 180.065 19.182 179.798 19.586 C 179.53 19.991 179.325 20.443 179.181 20.948 C 179.048 21.453 178.981 21.963 178.981 22.483 C 178.981 23.291 179.11 23.994 179.368 24.585 C 179.626 25.167 179.993 25.625 180.466 25.947 C 180.939 26.26 181.498 26.418 182.138 26.418 C 182.51 26.418 182.916 26.365 183.356 26.255 C 183.795 26.144 184.244 25.976 184.707 25.745 L 185.123 26.515 C 184.927 26.659 184.698 26.789 184.44 26.904 C 184.191 27.01 183.924 27.106 183.637 27.188 C 183.36 27.27 183.083 27.328 182.806 27.361 C 182.539 27.405 182.291 27.429 182.057 27.429 L 182.052 27.429 Z M 166.315 26.5 C 166.884 26.5 167.361 26.38 167.748 26.135 C 168.13 25.894 168.44 25.567 168.67 25.163 C 168.904 24.759 169.066 24.316 169.166 23.83 C 169.271 23.344 169.329 22.858 169.329 22.377 C 169.329 21.896 169.276 21.405 169.166 20.924 C 169.066 20.438 168.904 20 168.67 19.606 C 168.436 19.202 168.125 18.879 167.734 18.634 C 167.352 18.393 166.879 18.268 166.315 18.268 C 165.752 18.268 165.279 18.388 164.882 18.634 C 164.5 18.874 164.19 19.202 163.961 19.606 C 163.736 20.01 163.574 20.452 163.464 20.938 C 163.364 21.424 163.316 21.91 163.316 22.391 C 163.316 22.873 163.364 23.363 163.464 23.844 C 163.569 24.321 163.736 24.759 163.961 25.163 C 164.195 25.567 164.5 25.889 164.882 26.135 C 165.274 26.375 165.752 26.5 166.315 26.5 Z M 166.301 27.414 C 165.58 27.414 164.945 27.28 164.4 27.01 C 163.865 26.741 163.421 26.37 163.063 25.904 C 162.705 25.427 162.437 24.888 162.26 24.287 C 162.084 23.686 161.993 23.046 161.993 22.372 C 161.993 21.699 162.079 21.059 162.246 20.457 C 162.423 19.846 162.69 19.307 163.049 18.841 C 163.407 18.364 163.856 17.994 164.4 17.725 C 164.945 17.455 165.58 17.32 166.31 17.32 C 167.041 17.32 167.676 17.455 168.211 17.725 C 168.756 17.994 169.205 18.364 169.563 18.841 C 169.921 19.307 170.184 19.846 170.351 20.457 C 170.528 21.059 170.618 21.699 170.618 22.372 C 170.618 23.046 170.528 23.686 170.351 24.297 C 170.174 24.898 169.907 25.432 169.548 25.899 C 169.19 26.365 168.741 26.736 168.197 27.005 C 167.662 27.275 167.027 27.41 166.296 27.41 L 166.301 27.414 Z M 156.123 18.388 L 153.234 18.388 L 153.234 17.46 L 160.322 17.46 L 160.322 18.388 L 157.394 18.388 L 157.394 27.265 L 156.123 27.265 L 156.123 18.388 Z M 144.007 17.325 C 144.451 17.325 144.886 17.388 145.306 17.513 C 145.736 17.638 146.142 17.816 146.524 18.052 L 145.908 18.956 C 145.631 18.749 145.33 18.586 145 18.47 C 144.68 18.345 144.346 18.283 143.998 18.283 C 143.525 18.283 143.124 18.403 142.794 18.648 C 142.464 18.884 142.297 19.259 142.297 19.779 C 142.297 20.068 142.374 20.313 142.527 20.52 C 142.689 20.717 142.894 20.89 143.157 21.044 C 143.42 21.198 143.697 21.347 143.998 21.487 C 144.308 21.631 144.628 21.79 144.948 21.958 C 145.277 22.127 145.578 22.329 145.846 22.565 C 146.123 22.791 146.342 23.07 146.5 23.402 C 146.667 23.724 146.753 24.123 146.753 24.6 C 146.753 25.244 146.596 25.779 146.285 26.202 C 145.975 26.616 145.564 26.924 145.053 27.13 C 144.547 27.328 143.998 27.429 143.41 27.429 C 142.928 27.429 142.46 27.366 142.006 27.241 C 141.562 27.106 141.122 26.928 140.697 26.702 L 141.18 25.596 C 141.476 25.846 141.829 26.053 142.25 26.216 C 142.67 26.38 143.071 26.457 143.453 26.457 C 143.749 26.457 144.045 26.404 144.351 26.293 C 144.652 26.178 144.91 25.99 145.115 25.74 C 145.32 25.49 145.421 25.167 145.421 24.768 C 145.421 24.369 145.325 24.051 145.139 23.796 C 144.953 23.536 144.704 23.32 144.403 23.152 C 144.103 22.974 143.778 22.8 143.439 22.642 C 143.143 22.497 142.851 22.348 142.555 22.199 C 142.259 22.045 141.992 21.867 141.753 21.66 C 141.514 21.453 141.318 21.208 141.18 20.919 C 141.036 20.631 140.965 20.284 140.965 19.88 C 140.965 19.312 141.113 18.841 141.404 18.465 C 141.705 18.09 142.092 17.806 142.555 17.619 C 143.028 17.421 143.515 17.32 144.012 17.32 L 144.007 17.325 Z M 132.015 17.46 L 136.265 24.046 C 136.347 24.172 136.433 24.306 136.518 24.451 C 136.609 24.585 136.695 24.715 136.786 24.84 C 136.776 24.686 136.767 24.537 136.757 24.383 C 136.748 24.22 136.743 24.071 136.743 23.926 L 136.743 17.46 L 137.76 17.46 L 137.76 27.333 L 136.972 27.333 L 132.01 19.683 C 131.938 19.567 131.857 19.447 131.771 19.317 C 131.69 19.182 131.604 19.057 131.518 18.942 C 131.537 19.086 131.547 19.235 131.547 19.384 C 131.556 19.529 131.561 19.673 131.561 19.817 L 131.561 27.265 L 130.544 27.265 L 130.544 18.345 L 130.358 17.455 L 132.015 17.455 L 132.015 17.46 Z M 125.438 17.46 L 126.871 17.46 L 126.871 27.265 L 125.63 27.265 L 125.63 18.345 C 125.63 18.345 125.61 18.263 125.577 18.129 C 125.548 17.994 125.524 17.854 125.496 17.71 C 125.467 17.566 125.453 17.479 125.443 17.455 L 125.438 17.46 Z M 118.819 17.325 C 119.168 17.325 119.535 17.364 119.927 17.445 C 120.328 17.518 120.71 17.638 121.078 17.811 C 121.451 17.975 121.766 18.182 122.014 18.446 L 121.307 19.283 C 121.03 19.057 120.772 18.874 120.534 18.73 C 120.295 18.586 120.037 18.48 119.77 18.408 C 119.512 18.336 119.196 18.302 118.819 18.302 C 118.232 18.302 117.73 18.413 117.319 18.639 C 116.918 18.865 116.589 19.168 116.331 19.553 C 116.083 19.938 115.896 20.376 115.782 20.861 C 115.667 21.347 115.61 21.848 115.61 22.372 C 115.61 22.868 115.662 23.354 115.772 23.84 C 115.877 24.316 116.054 24.749 116.293 25.148 C 116.531 25.543 116.851 25.856 117.243 26.091 C 117.635 26.327 118.117 26.442 118.685 26.442 C 119.158 26.442 119.564 26.341 119.903 26.135 C 120.252 25.918 120.519 25.629 120.706 25.273 C 120.901 24.903 121.002 24.494 121.002 24.032 L 121.002 23.142 L 118.609 23.142 L 118.771 22.228 L 122.263 22.228 L 122.263 25.042 C 122.263 25.413 122.277 25.783 122.301 26.159 C 122.334 26.534 122.363 26.909 122.382 27.275 L 121.713 27.275 L 121.283 26.25 C 120.892 26.673 120.467 26.977 120.013 27.164 C 119.569 27.342 119.053 27.434 118.475 27.434 C 117.773 27.434 117.157 27.304 116.632 27.044 C 116.116 26.774 115.681 26.409 115.333 25.952 C 114.984 25.485 114.726 24.956 114.559 24.364 C 114.392 23.772 114.306 23.147 114.306 22.492 C 114.306 21.776 114.401 21.107 114.588 20.486 C 114.774 19.856 115.056 19.307 115.428 18.841 C 115.801 18.364 116.269 17.999 116.832 17.734 C 117.401 17.465 118.069 17.33 118.824 17.33 L 118.819 17.325 Z M 106.287 17.46 L 112.133 17.46 L 112.133 18.388 L 107.72 18.388 L 107.72 21.771 L 111.144 21.771 L 111.144 22.685 L 107.72 22.685 L 107.72 26.337 L 112.133 26.337 L 112.133 27.265 L 106.478 27.265 L 106.478 18.345 L 106.292 17.455 L 106.287 17.46 Z M 102.041 24.316 C 102.041 23.859 101.922 23.493 101.678 23.224 C 101.444 22.945 101.144 22.747 100.771 22.632 C 100.403 22.507 100.026 22.444 99.634 22.444 L 98.149 22.444 L 98.149 26.337 L 99.634 26.337 C 100.107 26.337 100.523 26.284 100.876 26.173 C 101.244 26.058 101.526 25.851 101.731 25.552 C 101.936 25.254 102.037 24.845 102.037 24.311 L 102.041 24.316 Z M 101.626 19.764 C 101.626 19.404 101.545 19.125 101.387 18.927 C 101.234 18.73 101.029 18.591 100.771 18.509 C 100.513 18.427 100.231 18.388 99.931 18.388 L 98.154 18.388 L 98.154 21.516 L 99.587 21.516 C 100.007 21.516 100.365 21.463 100.671 21.352 C 100.976 21.242 101.21 21.064 101.378 20.813 C 101.545 20.554 101.631 20.202 101.631 19.764 L 101.626 19.764 Z M 102.925 19.736 C 102.925 20.068 102.858 20.39 102.724 20.707 C 102.6 21.011 102.414 21.28 102.161 21.501 C 101.922 21.718 101.626 21.857 101.277 21.92 C 101.721 21.982 102.099 22.141 102.4 22.391 C 102.71 22.632 102.949 22.94 103.106 23.306 C 103.274 23.676 103.36 24.08 103.36 24.518 C 103.36 25.1 103.255 25.576 103.04 25.947 C 102.825 26.308 102.538 26.587 102.17 26.784 C 101.803 26.972 101.397 27.102 100.938 27.174 C 100.485 27.236 100.021 27.27 99.548 27.27 L 96.903 27.27 L 96.903 18.35 C 96.903 18.35 96.883 18.268 96.85 18.133 C 96.821 17.999 96.798 17.859 96.769 17.715 C 96.74 17.571 96.726 17.484 96.716 17.46 L 99.964 17.46 C 100.346 17.46 100.714 17.494 101.062 17.566 C 101.421 17.628 101.736 17.744 102.013 17.917 C 102.299 18.085 102.519 18.321 102.681 18.619 C 102.844 18.908 102.92 19.279 102.92 19.736 L 102.925 19.736 Z M 85.708 17.325 C 86.057 17.325 86.424 17.364 86.816 17.445 C 87.217 17.518 87.599 17.638 87.967 17.811 C 88.339 17.975 88.655 18.182 88.903 18.446 L 88.196 19.283 C 87.919 19.057 87.661 18.874 87.422 18.73 C 87.184 18.586 86.926 18.48 86.658 18.408 C 86.4 18.336 86.085 18.302 85.708 18.302 C 85.12 18.302 84.619 18.413 84.208 18.639 C 83.807 18.865 83.478 19.168 83.22 19.553 C 82.971 19.938 82.785 20.376 82.67 20.861 C 82.556 21.347 82.499 21.848 82.499 22.372 C 82.499 22.868 82.551 23.354 82.661 23.84 C 82.766 24.316 82.943 24.749 83.181 25.148 C 83.42 25.543 83.74 25.856 84.132 26.091 C 84.524 26.327 85.006 26.442 85.574 26.442 C 86.047 26.442 86.453 26.341 86.792 26.135 C 87.141 25.918 87.408 25.629 87.594 25.273 C 87.79 24.903 87.891 24.494 87.891 24.032 L 87.891 23.142 L 85.498 23.142 L 85.66 22.228 L 89.151 22.228 L 89.151 25.042 C 89.151 25.413 89.166 25.783 89.19 26.159 C 89.223 26.534 89.252 26.909 89.271 27.275 L 88.602 27.275 L 88.172 26.25 C 87.781 26.673 87.356 26.977 86.902 27.164 C 86.458 27.342 85.942 27.434 85.364 27.434 C 84.662 27.434 84.046 27.304 83.521 27.044 C 83.005 26.774 82.57 26.409 82.222 25.952 C 81.873 25.485 81.615 24.956 81.448 24.364 C 81.281 23.772 81.195 23.147 81.195 22.492 C 81.195 21.776 81.29 21.107 81.477 20.486 C 81.663 19.856 81.945 19.307 82.317 18.841 C 82.69 18.364 83.158 17.999 83.721 17.734 C 84.289 17.465 84.958 17.33 85.713 17.33 L 85.708 17.325 Z M 72.312 17.46 L 76.562 24.046 C 76.643 24.172 76.729 24.306 76.815 24.451 C 76.906 24.585 76.992 24.715 77.083 24.84 L 77.054 24.383 C 77.044 24.22 77.04 24.071 77.04 23.926 L 77.04 17.46 L 78.057 17.46 L 78.057 27.333 L 77.269 27.333 L 72.307 19.683 C 72.235 19.567 72.154 19.447 72.068 19.317 C 71.987 19.182 71.901 19.057 71.815 18.942 C 71.834 19.086 71.844 19.235 71.844 19.384 C 71.853 19.529 71.858 19.673 71.858 19.817 L 71.858 27.265 L 70.841 27.265 L 70.841 18.345 L 70.654 17.455 L 72.312 17.455 L 72.312 17.46 Z M 65.735 17.46 L 67.168 17.46 L 67.168 27.265 L 65.926 27.265 L 65.926 18.345 C 65.926 18.345 65.907 18.263 65.874 18.129 C 65.845 17.994 65.821 17.854 65.793 17.71 C 65.764 17.566 65.75 17.479 65.74 17.455 L 65.735 17.46 Z M 61.017 22.632 L 56.284 22.632 L 56.284 27.265 L 55.042 27.265 L 55.042 18.345 C 55.042 18.345 55.023 18.263 54.989 18.129 C 54.961 17.994 54.937 17.854 54.908 17.71 C 54.88 17.566 54.865 17.479 54.856 17.455 L 56.289 17.455 L 56.289 21.713 L 61.021 21.713 L 61.021 17.455 L 62.263 17.455 L 62.263 27.26 L 61.021 27.26 L 61.021 22.627 L 61.017 22.632 Z M 48.017 18.388 L 45.127 18.388 L 45.127 17.46 L 52.215 17.46 L 52.215 18.388 L 49.287 18.388 L 49.287 27.265 L 48.017 27.265 L 48.017 18.388 Z M 37.534 17.46 L 39.793 21.27 L 41.894 17.46 L 43.059 17.46 L 40.265 22.415 L 40.265 27.265 L 38.995 27.265 L 38.995 22.415 L 36.091 17.46 L 37.534 17.46 Z M 28.803 18.388 L 28.803 21.944 L 29.873 21.944 C 30.317 21.944 30.718 21.896 31.077 21.795 C 31.444 21.689 31.731 21.497 31.946 21.227 C 32.161 20.958 32.266 20.578 32.266 20.082 C 32.266 19.697 32.17 19.38 31.984 19.139 C 31.798 18.889 31.549 18.701 31.249 18.571 C 30.948 18.446 30.618 18.384 30.274 18.384 L 28.803 18.384 L 28.803 18.388 Z M 27.375 17.46 L 30.279 17.46 C 30.895 17.46 31.449 17.542 31.951 17.7 C 32.452 17.854 32.844 18.129 33.125 18.523 C 33.422 18.918 33.565 19.466 33.565 20.169 C 33.565 20.529 33.479 20.876 33.312 21.208 C 33.145 21.54 32.915 21.833 32.629 22.084 C 32.352 22.324 32.046 22.502 31.707 22.608 L 34.434 27.27 L 32.992 27.27 L 30.48 22.863 L 28.808 22.863 L 28.808 27.27 L 27.566 27.27 L 27.566 18.35 L 27.38 17.46 L 27.375 17.46 Z M 18.712 17.46 L 24.558 17.46 L 24.558 18.388 L 20.145 18.388 L 20.145 21.771 L 23.569 21.771 L 23.569 22.685 L 20.145 22.685 L 20.145 26.337 L 24.558 26.337 L 24.558 27.265 L 18.903 27.265 L 18.903 18.345 L 18.717 17.455 L 18.712 17.46 Z M 9.958 17.46 L 12.069 23.859 C 12.14 24.085 12.207 24.301 12.269 24.518 C 12.331 24.725 12.398 24.956 12.47 25.206 C 12.541 24.97 12.604 24.763 12.656 24.571 C 12.709 24.374 12.771 24.172 12.842 23.965 L 15.063 17.445 L 16.133 17.445 L 12.761 27.308 L 11.987 27.308 L 8.63 17.46 L 9.953 17.46 L 9.958 17.46 Z M 0.64 17.46 L 6.486 17.46 L 6.486 18.388 L 2.073 18.388 L 2.073 21.771 L 5.497 21.771 L 5.497 22.685 L 2.073 22.685 L 2.073 26.337 L 6.486 26.337 L 6.486 27.265 L 0.826 27.265 L 0.826 18.345 L 0.64 17.455 L 0.64 17.46 Z M 164.806 9.194 C 164.806 9.435 164.715 9.646 164.539 9.829 C 164.371 9.998 164.166 10.084 163.923 10.084 C 163.679 10.084 163.474 9.998 163.292 9.829 C 163.125 9.651 163.039 9.44 163.039 9.194 C 163.039 8.949 163.125 8.732 163.292 8.559 C 163.459 8.391 163.669 8.304 163.923 8.304 C 164.176 8.304 164.367 8.396 164.539 8.574 C 164.715 8.742 164.806 8.949 164.806 9.194 Z M 154.232 0.14 L 158.483 6.726 C 158.564 6.851 158.65 6.986 158.736 7.13 C 158.827 7.265 158.913 7.395 159.003 7.52 L 158.975 7.063 C 158.965 6.899 158.96 6.75 158.96 6.606 L 158.96 0.14 L 159.978 0.14 L 159.978 10.012 L 159.19 10.012 L 154.227 2.362 C 154.156 2.247 154.075 2.127 153.989 1.997 C 153.907 1.862 153.822 1.737 153.736 1.621 C 153.755 1.766 153.764 1.915 153.764 2.064 C 153.774 2.208 153.779 2.353 153.779 2.497 L 153.779 9.945 L 152.761 9.945 L 152.761 1.03 L 152.575 0.14 L 154.232 0.14 Z M 147.656 0.14 L 149.089 0.14 L 149.089 9.945 L 147.847 9.945 L 147.847 1.03 C 147.847 1.03 147.828 0.948 147.794 0.813 C 147.766 0.678 147.742 0.539 147.713 0.395 C 147.685 0.25 147.67 0.164 147.661 0.14 L 147.656 0.14 Z M 142.937 5.312 L 138.204 5.312 L 138.204 9.945 L 136.963 9.945 L 136.963 1.03 C 136.963 1.03 136.944 0.948 136.91 0.813 C 136.881 0.678 136.858 0.539 136.829 0.395 C 136.8 0.25 136.786 0.164 136.776 0.14 L 138.209 0.14 L 138.209 4.397 L 142.942 4.397 L 142.942 0.14 L 144.184 0.14 L 144.184 9.945 L 142.942 9.945 L 142.942 5.312 L 142.937 5.312 Z M 129.937 1.068 L 127.048 1.068 L 127.048 0.14 L 134.135 0.14 L 134.135 1.068 L 131.208 1.068 L 131.208 9.945 L 129.937 9.945 L 129.937 1.068 Z M 122.788 0.14 L 124.221 0.14 L 124.221 9.945 L 122.979 9.945 L 122.979 1.03 C 122.979 1.03 122.96 0.948 122.926 0.813 C 122.898 0.678 122.874 0.539 122.845 0.395 C 122.817 0.25 122.802 0.164 122.793 0.14 L 122.788 0.14 Z M 110.117 0.14 L 111.751 6.216 C 111.822 6.457 111.889 6.707 111.951 6.957 C 112.013 7.198 112.076 7.477 112.138 7.794 C 112.2 7.506 112.257 7.251 112.31 7.024 C 112.362 6.789 112.419 6.563 112.482 6.336 L 114.139 0.14 L 115.127 0.14 L 116.761 6.269 C 116.823 6.495 116.885 6.731 116.947 6.981 C 117.009 7.222 117.071 7.491 117.133 7.789 C 117.195 7.501 117.253 7.246 117.305 7.02 C 117.358 6.793 117.415 6.577 117.477 6.36 L 119.149 0.135 L 120.19 0.135 L 117.53 10.007 L 116.498 10.007 L 114.798 3.743 C 114.755 3.565 114.702 3.377 114.65 3.19 C 114.597 2.993 114.549 2.766 114.502 2.516 C 114.449 2.766 114.397 2.997 114.339 3.204 C 114.296 3.402 114.244 3.594 114.191 3.782 L 112.52 10.007 L 111.488 10.007 L 108.809 0.14 L 110.117 0.14 Z M 99.62 0.005 C 100.064 0.005 100.499 0.067 100.919 0.192 C 101.349 0.318 101.755 0.496 102.137 0.731 L 101.521 1.636 C 101.244 1.429 100.943 1.265 100.613 1.15 C 100.293 1.025 99.959 0.962 99.611 0.962 C 99.138 0.962 98.737 1.083 98.407 1.328 C 98.077 1.564 97.91 1.939 97.91 2.459 C 97.91 2.747 97.987 2.993 98.14 3.199 C 98.302 3.397 98.507 3.57 98.77 3.724 C 99.028 3.878 99.31 4.027 99.611 4.167 C 99.921 4.311 100.241 4.47 100.561 4.638 C 100.89 4.806 101.191 5.008 101.459 5.244 C 101.736 5.47 101.955 5.749 102.113 6.081 C 102.28 6.404 102.366 6.803 102.366 7.279 C 102.366 7.924 102.209 8.458 101.898 8.882 C 101.588 9.295 101.177 9.603 100.666 9.81 C 100.16 10.007 99.611 10.108 99.023 10.108 C 98.541 10.108 98.073 10.046 97.619 9.921 C 97.175 9.786 96.735 9.608 96.31 9.382 L 96.793 8.275 C 97.089 8.525 97.442 8.732 97.863 8.896 C 98.283 9.06 98.684 9.137 99.066 9.137 C 99.362 9.137 99.658 9.084 99.964 8.973 C 100.265 8.857 100.523 8.67 100.728 8.42 C 100.933 8.169 101.034 7.847 101.034 7.448 C 101.034 7.048 100.938 6.731 100.752 6.476 C 100.566 6.216 100.317 6 100.016 5.831 C 99.716 5.653 99.391 5.48 99.052 5.321 C 98.756 5.177 98.464 5.028 98.168 4.879 C 97.872 4.725 97.605 4.547 97.366 4.34 C 97.127 4.133 96.931 3.887 96.793 3.599 C 96.649 3.31 96.578 2.964 96.578 2.56 C 96.578 1.992 96.726 1.52 97.017 1.145 C 97.318 0.77 97.705 0.486 98.168 0.298 C 98.641 0.101 99.128 0 99.625 0 L 99.62 0.005 Z M 91.386 0.005 C 91.831 0.005 92.265 0.067 92.685 0.192 C 93.115 0.318 93.521 0.496 93.903 0.731 L 93.287 1.636 C 93.01 1.429 92.709 1.265 92.38 1.15 C 92.06 1.025 91.726 0.962 91.377 0.962 C 90.904 0.962 90.503 1.083 90.173 1.328 C 89.844 1.564 89.677 1.939 89.677 2.459 C 89.677 2.747 89.753 2.993 89.906 3.199 C 90.068 3.397 90.274 3.57 90.536 3.724 C 90.799 3.878 91.076 4.027 91.377 4.167 C 91.687 4.311 92.007 4.47 92.327 4.638 C 92.657 4.806 92.958 5.008 93.225 5.244 C 93.502 5.47 93.722 5.749 93.879 6.081 C 94.047 6.404 94.133 6.803 94.133 7.279 C 94.133 7.924 93.975 8.458 93.665 8.882 C 93.354 9.295 92.943 9.603 92.432 9.81 C 91.926 10.007 91.377 10.108 90.789 10.108 C 90.307 10.108 89.839 10.046 89.385 9.921 C 88.941 9.786 88.502 9.608 88.077 9.382 L 88.559 8.275 C 88.855 8.525 89.209 8.732 89.629 8.896 C 90.049 9.06 90.45 9.137 90.832 9.137 C 91.129 9.137 91.425 9.084 91.73 8.973 C 92.031 8.857 92.289 8.67 92.494 8.42 C 92.7 8.169 92.8 7.847 92.8 7.448 C 92.8 7.048 92.705 6.731 92.518 6.476 C 92.332 6.216 92.084 6 91.783 5.831 C 91.482 5.653 91.157 5.48 90.818 5.321 C 90.522 5.177 90.231 5.028 89.935 4.879 C 89.638 4.725 89.371 4.547 89.132 4.34 C 88.893 4.133 88.698 3.887 88.559 3.599 C 88.416 3.31 88.344 2.964 88.344 2.56 C 88.344 1.992 88.492 1.52 88.784 1.145 C 89.084 0.77 89.471 0.486 89.935 0.298 C 90.407 0.101 90.895 0 91.391 0 L 91.386 0.005 Z M 79.929 0.14 L 85.775 0.14 L 85.775 1.068 L 81.362 1.068 L 81.362 4.45 L 84.786 4.45 L 84.786 5.365 L 81.362 5.365 L 81.362 9.016 L 85.775 9.016 L 85.775 9.945 L 80.12 9.945 L 80.12 1.03 L 79.934 0.14 L 79.929 0.14 Z M 70.716 0.14 L 74.967 6.726 C 75.048 6.851 75.134 6.986 75.22 7.13 C 75.311 7.265 75.397 7.395 75.488 7.52 L 75.459 7.063 C 75.449 6.899 75.445 6.75 75.445 6.606 L 75.445 0.14 L 76.462 0.14 L 76.462 10.012 L 75.674 10.012 L 70.712 2.362 C 70.64 2.247 70.559 2.127 70.473 1.997 C 70.392 1.862 70.306 1.737 70.22 1.621 C 70.239 1.766 70.248 1.915 70.248 2.064 C 70.258 2.208 70.263 2.353 70.263 2.497 L 70.263 9.945 L 69.245 9.945 L 69.245 1.03 L 69.059 0.14 L 70.716 0.14 Z M 60.84 0.14 L 62.273 0.14 L 62.273 9.016 L 66.366 9.016 L 66.366 9.945 L 61.031 9.945 L 61.031 1.03 L 60.845 0.14 L 60.84 0.14 Z M 52.635 0.14 L 54.068 0.14 L 54.068 9.016 L 58.161 9.016 L 58.161 9.945 L 52.826 9.945 L 52.826 1.03 L 52.64 0.14 L 52.635 0.14 Z M 43.298 0.14 L 43.298 6.659 C 43.298 7.424 43.484 8.035 43.862 8.492 C 44.234 8.949 44.826 9.18 45.629 9.18 C 46.183 9.18 46.646 9.069 47.019 8.843 C 47.391 8.607 47.673 8.29 47.859 7.886 C 48.045 7.472 48.141 7 48.141 6.471 L 48.141 0.14 L 49.172 0.14 L 49.172 6.471 C 49.172 7.226 49.029 7.876 48.743 8.424 C 48.466 8.963 48.06 9.382 47.525 9.675 C 46.99 9.964 46.34 10.108 45.571 10.108 C 44.459 10.108 43.589 9.815 42.964 9.233 C 42.338 8.651 42.028 7.789 42.028 6.659 L 42.028 1.03 L 41.827 0.14 L 43.298 0.14 Z M 33.689 0.14 L 39.076 0.14 L 39.076 1.068 L 35.117 1.068 L 35.117 4.45 L 38.26 4.45 L 38.26 5.365 L 35.117 5.365 L 35.117 9.945 L 33.875 9.945 L 33.875 1.03 L 33.689 0.14 Z M 20.594 0.14 L 26.439 0.14 L 26.439 1.068 L 22.026 1.068 L 22.026 4.45 L 25.451 4.45 L 25.451 5.365 L 22.026 5.365 L 22.026 9.016 L 26.439 9.016 L 26.439 9.945 L 20.785 9.945 L 20.785 1.03 L 20.598 0.14 L 20.594 0.14 Z M 15.885 5.312 L 11.152 5.312 L 11.152 9.945 L 9.91 9.945 L 9.91 1.03 C 9.91 1.03 9.891 0.948 9.857 0.813 C 9.829 0.678 9.805 0.539 9.776 0.395 C 9.748 0.25 9.733 0.164 9.724 0.14 L 11.156 0.14 L 11.156 4.397 L 15.889 4.397 L 15.889 0.14 L 17.131 0.14 L 17.131 9.945 L 15.889 9.945 L 15.889 5.312 L 15.885 5.312 Z M 2.885 1.068 L 0 1.068 L 0 0.14 L 7.087 0.14 L 7.087 1.068 L 4.16 1.068 L 4.16 9.945 L 2.889 9.945 L 2.889 1.068 L 2.885 1.068 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 148.043,
    height: 20.077,
    viewBox: "0 0 148.043 20.077",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 38.918,
      width: 148.043,
      height: 20.077,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.2 18.745 C 138.2 18.874 138.152 18.985 138.061 19.076 C 137.97 19.163 137.861 19.206 137.741 19.206 C 137.622 19.206 137.512 19.163 137.421 19.076 C 137.33 18.985 137.283 18.874 137.283 18.745 C 137.283 18.615 137.326 18.499 137.412 18.413 C 137.502 18.326 137.612 18.283 137.741 18.283 C 137.87 18.283 137.97 18.331 138.061 18.422 C 138.152 18.509 138.2 18.619 138.2 18.745 Z M 134.35 13.476 C 134.589 13.476 134.823 13.51 135.048 13.582 C 135.277 13.654 135.501 13.75 135.721 13.866 L 135.463 14.304 C 135.291 14.193 135.11 14.097 134.928 14.025 C 134.751 13.953 134.556 13.919 134.345 13.919 C 134.035 13.919 133.777 13.996 133.572 14.15 C 133.371 14.304 133.276 14.549 133.276 14.881 C 133.276 15.049 133.323 15.199 133.419 15.319 C 133.519 15.439 133.653 15.54 133.811 15.636 C 133.968 15.723 134.14 15.81 134.322 15.896 C 134.498 15.978 134.68 16.069 134.866 16.175 C 135.048 16.272 135.215 16.387 135.363 16.522 C 135.516 16.656 135.64 16.815 135.73 17.008 C 135.821 17.19 135.869 17.417 135.869 17.676 C 135.869 18.042 135.778 18.34 135.602 18.571 C 135.425 18.797 135.191 18.966 134.904 19.072 C 134.618 19.173 134.312 19.226 133.987 19.226 C 133.734 19.226 133.486 19.187 133.252 19.11 C 133.023 19.028 132.793 18.932 132.564 18.826 L 132.793 18.312 C 132.956 18.451 133.156 18.562 133.395 18.648 C 133.634 18.73 133.858 18.773 134.068 18.773 C 134.24 18.773 134.422 18.74 134.613 18.672 C 134.804 18.605 134.962 18.494 135.086 18.34 C 135.219 18.186 135.286 17.984 135.286 17.734 C 135.286 17.484 135.229 17.282 135.119 17.128 C 135.014 16.969 134.871 16.834 134.689 16.729 C 134.517 16.623 134.331 16.522 134.131 16.43 C 133.959 16.349 133.787 16.262 133.62 16.175 C 133.452 16.084 133.3 15.978 133.161 15.867 C 133.023 15.747 132.913 15.612 132.827 15.454 C 132.746 15.29 132.703 15.093 132.703 14.867 C 132.703 14.573 132.784 14.323 132.946 14.121 C 133.109 13.909 133.319 13.75 133.572 13.645 C 133.825 13.539 134.088 13.481 134.35 13.481 L 134.35 13.476 Z M 129.646 13.476 C 129.885 13.476 130.119 13.51 130.343 13.582 C 130.573 13.654 130.797 13.75 131.017 13.866 L 130.759 14.304 C 130.587 14.193 130.405 14.097 130.224 14.025 C 130.047 13.953 129.851 13.919 129.641 13.919 C 129.331 13.919 129.073 13.996 128.868 14.15 C 128.667 14.304 128.571 14.549 128.571 14.881 C 128.571 15.049 128.619 15.199 128.715 15.319 C 128.815 15.439 128.949 15.54 129.106 15.636 C 129.264 15.723 129.436 15.81 129.617 15.896 C 129.794 15.978 129.976 16.069 130.162 16.175 C 130.343 16.272 130.51 16.387 130.658 16.522 C 130.811 16.656 130.936 16.815 131.026 17.008 C 131.117 17.19 131.165 17.417 131.165 17.676 C 131.165 18.042 131.074 18.34 130.897 18.571 C 130.721 18.797 130.487 18.966 130.2 19.072 C 129.913 19.173 129.608 19.226 129.283 19.226 C 129.03 19.226 128.782 19.187 128.548 19.11 C 128.318 19.028 128.089 18.932 127.86 18.826 L 128.089 18.312 C 128.251 18.451 128.452 18.562 128.691 18.648 C 128.93 18.73 129.154 18.773 129.364 18.773 C 129.536 18.773 129.718 18.74 129.909 18.672 C 130.095 18.605 130.257 18.494 130.382 18.34 C 130.515 18.186 130.582 17.984 130.582 17.734 C 130.582 17.484 130.525 17.282 130.415 17.128 C 130.31 16.969 130.167 16.834 129.985 16.729 C 129.813 16.623 129.627 16.522 129.426 16.43 C 129.254 16.349 129.082 16.262 128.915 16.175 C 128.748 16.084 128.595 15.978 128.457 15.867 C 128.318 15.747 128.208 15.612 128.122 15.454 C 128.041 15.29 127.998 15.093 127.998 14.867 C 127.998 14.573 128.08 14.323 128.242 14.121 C 128.404 13.909 128.614 13.75 128.868 13.645 C 129.121 13.539 129.383 13.481 129.646 13.481 L 129.646 13.476 Z M 123.175 13.548 L 126.413 13.548 L 126.413 13.957 L 123.805 13.957 L 123.805 16.065 L 125.84 16.065 L 125.84 16.464 L 123.805 16.464 L 123.805 18.725 L 126.413 18.725 L 126.413 19.134 L 123.27 19.134 L 123.27 14.078 L 123.17 13.548 L 123.175 13.548 Z M 117.749 13.548 L 120.3 17.513 C 120.343 17.58 120.386 17.652 120.438 17.729 C 120.491 17.802 120.538 17.874 120.591 17.946 L 120.577 17.7 L 120.577 13.553 L 121.021 13.553 L 121.021 19.182 L 120.768 19.182 L 117.764 14.54 C 117.73 14.482 117.687 14.419 117.639 14.357 C 117.592 14.285 117.544 14.222 117.496 14.174 C 117.506 14.251 117.511 14.333 117.511 14.419 L 117.511 19.144 L 117.066 19.144 L 117.066 14.078 L 116.961 13.553 L 117.749 13.553 L 117.749 13.548 Z M 112.262 13.548 L 112.897 13.548 L 112.897 18.73 L 115.314 18.73 L 115.314 19.139 L 112.381 19.139 L 112.381 14.082 L 112.267 13.553 L 112.262 13.548 Z M 107.572 13.548 L 108.207 13.548 L 108.207 18.73 L 110.624 18.73 L 110.624 19.139 L 107.691 19.139 L 107.691 14.082 L 107.577 13.553 L 107.572 13.548 Z M 102.046 13.548 L 102.046 17.267 C 102.046 17.734 102.151 18.109 102.361 18.393 C 102.572 18.672 102.925 18.807 103.431 18.807 C 103.785 18.807 104.071 18.735 104.296 18.591 C 104.525 18.441 104.697 18.239 104.807 17.984 C 104.917 17.725 104.974 17.426 104.974 17.099 L 104.974 13.548 L 105.418 13.548 L 105.418 17.234 C 105.418 17.609 105.346 17.946 105.203 18.249 C 105.06 18.552 104.84 18.793 104.544 18.971 C 104.253 19.144 103.885 19.23 103.436 19.23 C 102.834 19.23 102.361 19.076 102.013 18.769 C 101.674 18.456 101.502 17.994 101.502 17.393 L 101.502 14.073 L 101.397 13.544 L 102.046 13.544 L 102.046 13.548 Z M 96.745 13.548 L 99.716 13.548 L 99.716 13.957 L 97.375 13.957 L 97.375 16.065 L 99.257 16.065 L 99.257 16.464 L 97.375 16.464 L 97.375 19.134 L 96.85 19.134 L 96.85 14.078 L 96.745 13.548 Z M 89.576 13.957 L 89.576 16.214 L 90.25 16.214 C 90.532 16.214 90.785 16.185 91.014 16.122 C 91.248 16.055 91.434 15.94 91.573 15.766 C 91.716 15.593 91.788 15.348 91.788 15.035 C 91.788 14.79 91.726 14.588 91.606 14.429 C 91.487 14.27 91.334 14.15 91.138 14.073 C 90.942 13.996 90.737 13.957 90.512 13.957 L 89.581 13.957 L 89.576 13.957 Z M 88.941 13.548 L 90.46 13.548 C 90.818 13.548 91.133 13.597 91.415 13.688 C 91.702 13.775 91.926 13.933 92.089 14.159 C 92.251 14.386 92.332 14.703 92.332 15.107 C 92.332 15.309 92.284 15.502 92.194 15.685 C 92.108 15.867 91.988 16.031 91.84 16.171 C 91.692 16.31 91.525 16.416 91.334 16.488 L 92.814 19.144 L 92.179 19.144 L 90.804 16.618 L 89.567 16.618 L 89.567 19.144 L 89.032 19.144 L 89.032 14.087 L 88.932 13.558 L 88.941 13.548 Z M 83.989 13.548 L 87.227 13.548 L 87.227 13.957 L 84.619 13.957 L 84.619 16.065 L 86.654 16.065 L 86.654 16.464 L 84.619 16.464 L 84.619 18.725 L 87.227 18.725 L 87.227 19.134 L 84.084 19.134 L 84.084 14.078 L 83.984 13.548 L 83.989 13.548 Z M 78.563 13.548 L 81.114 17.513 C 81.157 17.58 81.2 17.652 81.252 17.729 C 81.305 17.802 81.352 17.874 81.405 17.946 L 81.391 17.7 L 81.391 13.553 L 81.835 13.553 L 81.835 19.182 L 81.582 19.182 L 78.578 14.54 C 78.544 14.482 78.501 14.419 78.453 14.357 C 78.406 14.285 78.358 14.222 78.31 14.174 C 78.32 14.251 78.324 14.333 78.324 14.419 L 78.324 19.144 L 77.88 19.144 L 77.88 14.078 L 77.775 13.553 L 78.563 13.553 L 78.563 13.548 Z M 72.345 13.548 L 74.895 17.513 C 74.938 17.58 74.981 17.652 75.034 17.729 C 75.086 17.802 75.134 17.874 75.187 17.946 C 75.182 17.864 75.177 17.782 75.172 17.7 L 75.172 13.553 L 75.616 13.553 L 75.616 19.182 L 75.363 19.182 L 72.359 14.54 C 72.326 14.482 72.283 14.419 72.235 14.357 C 72.187 14.285 72.14 14.222 72.092 14.174 C 72.101 14.251 72.106 14.333 72.106 14.419 L 72.106 19.144 L 71.662 19.144 L 71.662 14.078 L 71.557 13.553 L 72.345 13.553 L 72.345 13.548 Z M 68.749 13.548 L 69.384 13.548 L 69.384 19.139 L 68.859 19.139 L 68.859 14.082 C 68.859 14.082 68.849 14.034 68.83 13.957 C 68.816 13.876 68.801 13.789 68.782 13.702 C 68.763 13.616 68.758 13.563 68.754 13.548 L 68.749 13.548 Z M 63.825 16.32 C 63.825 15.839 63.763 15.444 63.643 15.136 C 63.524 14.828 63.352 14.588 63.118 14.419 C 62.889 14.246 62.607 14.126 62.268 14.058 C 61.938 13.991 61.561 13.957 61.136 13.957 L 60.74 13.957 L 60.74 18.73 L 61.819 18.73 C 62.325 18.73 62.722 18.624 63.013 18.413 C 63.309 18.196 63.519 17.907 63.639 17.542 C 63.768 17.176 63.83 16.767 63.83 16.32 L 63.825 16.32 Z M 64.36 16.363 C 64.36 16.897 64.279 17.373 64.116 17.797 C 63.959 18.21 63.701 18.542 63.342 18.783 C 62.984 19.019 62.516 19.139 61.929 19.139 L 60.21 19.139 L 60.21 14.082 C 60.21 14.082 60.2 14.03 60.186 13.953 C 60.171 13.871 60.157 13.789 60.138 13.707 C 60.124 13.621 60.114 13.568 60.109 13.553 L 61.179 13.553 C 61.661 13.553 62.101 13.597 62.488 13.683 C 62.879 13.77 63.218 13.919 63.495 14.131 C 63.777 14.342 63.987 14.626 64.135 14.992 C 64.283 15.357 64.355 15.814 64.355 16.368 L 64.36 16.363 Z M 54.684 13.548 L 57.234 17.513 C 57.277 17.58 57.32 17.652 57.373 17.729 C 57.425 17.802 57.473 17.874 57.525 17.946 C 57.521 17.864 57.516 17.782 57.511 17.7 L 57.511 13.553 L 57.955 13.553 L 57.955 19.182 L 57.702 19.182 L 54.698 14.54 C 54.665 14.482 54.622 14.419 54.574 14.357 C 54.526 14.285 54.478 14.222 54.431 14.174 C 54.44 14.251 54.445 14.333 54.445 14.419 L 54.445 19.144 L 54.001 19.144 L 54.001 14.078 L 53.896 13.553 L 54.684 13.553 L 54.684 13.548 Z M 50.056 14.28 L 49.215 16.652 L 50.873 16.652 L 50.056 14.28 Z M 50.409 13.548 L 52.305 19.139 L 51.704 19.139 L 51.006 17.051 L 49.086 17.051 L 48.389 19.139 L 47.869 19.139 L 49.779 13.548 L 50.405 13.548 L 50.409 13.548 Z M 43.432 18.244 C 43.609 18.244 43.747 18.307 43.838 18.427 C 43.933 18.552 43.981 18.696 43.981 18.865 C 43.981 19.115 43.905 19.346 43.752 19.548 C 43.604 19.76 43.432 19.938 43.231 20.077 C 43.198 20.048 43.155 20.01 43.107 19.962 C 43.059 19.918 43.021 19.88 42.983 19.846 C 43.031 19.793 43.083 19.74 43.145 19.683 C 43.207 19.63 43.26 19.572 43.308 19.505 C 43.355 19.442 43.375 19.375 43.375 19.303 C 43.375 19.23 43.341 19.168 43.274 19.12 C 43.207 19.067 43.141 19.009 43.074 18.942 C 43.012 18.87 42.983 18.773 42.983 18.658 C 42.983 18.542 43.026 18.437 43.112 18.36 C 43.203 18.278 43.308 18.235 43.427 18.235 L 43.432 18.244 Z M 38.26 13.548 L 41.498 13.548 L 41.498 13.957 L 38.89 13.957 L 38.89 16.065 L 40.925 16.065 L 40.925 16.464 L 38.89 16.464 L 38.89 18.725 L 41.498 18.725 L 41.498 19.134 L 38.355 19.134 L 38.355 14.078 L 38.255 13.548 L 38.26 13.548 Z M 35.012 19.23 C 34.577 19.23 34.205 19.149 33.894 18.99 C 33.584 18.831 33.331 18.619 33.13 18.36 C 32.93 18.1 32.782 17.806 32.686 17.489 C 32.595 17.171 32.548 16.849 32.548 16.527 C 32.548 16.151 32.6 15.786 32.7 15.425 C 32.806 15.064 32.963 14.742 33.173 14.448 C 33.388 14.155 33.656 13.924 33.976 13.746 C 34.296 13.572 34.673 13.486 35.107 13.486 C 35.284 13.486 35.475 13.51 35.671 13.553 C 35.876 13.601 36.067 13.669 36.254 13.76 C 36.435 13.852 36.583 13.972 36.698 14.121 L 36.383 14.438 C 36.282 14.328 36.153 14.232 36.001 14.155 C 35.853 14.078 35.695 14.02 35.528 13.977 C 35.365 13.933 35.213 13.914 35.069 13.914 C 34.778 13.914 34.515 13.986 34.276 14.131 C 34.038 14.275 33.832 14.467 33.665 14.718 C 33.498 14.963 33.369 15.242 33.274 15.55 C 33.183 15.853 33.135 16.161 33.135 16.483 C 33.135 16.945 33.211 17.344 33.364 17.686 C 33.522 18.023 33.742 18.287 34.028 18.47 C 34.315 18.653 34.649 18.749 35.031 18.749 C 35.246 18.749 35.48 18.72 35.733 18.658 C 35.986 18.595 36.249 18.499 36.512 18.364 L 36.703 18.735 C 36.612 18.807 36.492 18.874 36.344 18.937 C 36.196 19 36.039 19.052 35.872 19.101 C 35.709 19.144 35.552 19.173 35.399 19.202 C 35.246 19.226 35.117 19.24 35.007 19.24 L 35.012 19.23 Z M 27.304 13.548 L 29.854 17.513 C 29.897 17.58 29.94 17.652 29.993 17.729 C 30.045 17.802 30.093 17.874 30.145 17.946 C 30.141 17.864 30.136 17.782 30.131 17.7 L 30.131 13.553 L 30.575 13.553 L 30.575 19.182 L 30.322 19.182 L 27.318 14.54 C 27.285 14.482 27.242 14.419 27.194 14.357 C 27.146 14.285 27.098 14.222 27.051 14.174 C 27.06 14.251 27.065 14.333 27.065 14.419 L 27.065 19.144 L 26.621 19.144 L 26.621 14.078 L 26.516 13.553 L 27.304 13.553 L 27.304 13.548 Z M 22.676 14.28 L 21.835 16.652 L 23.493 16.652 L 22.676 14.28 Z M 23.025 13.548 L 24.921 19.139 L 24.319 19.139 L 23.621 17.051 L 21.702 17.051 L 21.004 19.139 L 20.484 19.139 L 22.394 13.548 L 23.02 13.548 L 23.025 13.548 Z M 17.059 13.476 C 17.255 13.476 17.461 13.5 17.68 13.544 C 17.9 13.592 18.11 13.664 18.306 13.76 C 18.511 13.856 18.678 13.981 18.812 14.131 L 18.492 14.53 C 18.335 14.395 18.187 14.285 18.048 14.198 C 17.91 14.111 17.761 14.049 17.604 14.005 C 17.451 13.962 17.27 13.943 17.059 13.943 C 16.72 13.943 16.424 14.01 16.181 14.145 C 15.937 14.28 15.737 14.463 15.584 14.693 C 15.436 14.92 15.326 15.175 15.254 15.463 C 15.183 15.747 15.149 16.041 15.149 16.349 C 15.149 16.656 15.183 16.945 15.249 17.234 C 15.316 17.522 15.421 17.782 15.565 18.013 C 15.713 18.239 15.904 18.417 16.147 18.552 C 16.386 18.687 16.677 18.754 17.026 18.754 C 17.308 18.754 17.547 18.692 17.752 18.562 C 17.962 18.427 18.12 18.249 18.234 18.023 C 18.354 17.797 18.411 17.547 18.411 17.277 L 18.411 16.753 L 16.93 16.753 L 17.021 16.315 L 18.946 16.315 L 18.955 18.023 C 18.955 18.206 18.97 18.393 18.994 18.586 C 19.018 18.769 19.037 18.951 19.041 19.134 L 18.745 19.134 L 18.507 18.547 C 18.296 18.797 18.062 18.98 17.795 19.086 C 17.537 19.187 17.246 19.24 16.93 19.24 C 16.539 19.24 16.195 19.163 15.899 19.009 C 15.608 18.855 15.369 18.643 15.173 18.379 C 14.977 18.114 14.834 17.811 14.738 17.479 C 14.648 17.142 14.6 16.791 14.6 16.426 C 14.6 16.031 14.648 15.661 14.743 15.309 C 14.843 14.953 14.996 14.641 15.192 14.371 C 15.397 14.092 15.655 13.88 15.966 13.726 C 16.276 13.568 16.644 13.486 17.064 13.486 L 17.059 13.476 Z M 10.082 13.548 L 13.32 13.548 L 13.32 13.957 L 10.712 13.957 L 10.712 16.065 L 12.747 16.065 L 12.747 16.464 L 10.712 16.464 L 10.712 18.725 L 13.32 18.725 L 13.32 19.134 L 10.177 19.134 L 10.177 14.078 L 10.077 13.548 L 10.082 13.548 Z M 5.387 13.548 L 6.022 13.548 L 6.022 18.73 L 8.439 18.73 L 8.439 19.139 L 5.507 19.139 L 5.507 14.082 L 5.392 13.553 L 5.387 13.548 Z M 0.435 13.548 L 3.673 13.548 L 3.673 13.957 L 1.07 13.957 L 1.07 16.065 L 3.104 16.065 L 3.104 16.464 L 1.07 16.464 L 1.07 18.725 L 3.677 18.725 L 3.677 19.134 L 0.535 19.134 L 0.535 14.078 L 0.435 13.548 Z M 147.493 4.773 C 147.67 4.773 147.809 4.835 147.899 4.956 C 147.995 5.081 148.043 5.225 148.043 5.393 C 148.043 5.644 147.966 5.874 147.813 6.077 C 147.665 6.288 147.493 6.466 147.293 6.606 C 147.259 6.577 147.216 6.538 147.169 6.49 C 147.121 6.447 147.083 6.409 147.045 6.375 C 147.092 6.322 147.145 6.269 147.207 6.211 C 147.269 6.158 147.322 6.101 147.369 6.033 C 147.417 5.971 147.436 5.903 147.436 5.831 C 147.436 5.759 147.403 5.696 147.336 5.648 C 147.269 5.595 147.202 5.538 147.135 5.47 C 147.073 5.398 147.045 5.302 147.045 5.186 C 147.045 5.071 147.088 4.965 147.173 4.888 C 147.264 4.806 147.369 4.763 147.489 4.763 L 147.493 4.773 Z M 142.321 0.077 L 145.559 0.077 L 145.559 0.486 L 142.952 0.486 L 142.952 2.593 L 144.986 2.593 L 144.986 2.993 L 142.952 2.993 L 142.952 5.254 L 145.559 5.254 L 145.559 5.663 L 142.417 5.663 L 142.417 0.606 L 142.316 0.077 L 142.321 0.077 Z M 139.074 5.759 C 138.639 5.759 138.266 5.677 137.956 5.518 C 137.646 5.36 137.392 5.148 137.192 4.888 C 136.991 4.628 136.843 4.335 136.748 4.017 C 136.657 3.7 136.609 3.377 136.609 3.055 C 136.609 2.68 136.662 2.314 136.762 1.953 C 136.867 1.593 137.025 1.27 137.235 0.977 C 137.45 0.683 137.717 0.452 138.037 0.274 C 138.357 0.096 138.735 0.014 139.169 0.014 C 139.346 0.014 139.537 0.038 139.733 0.082 C 139.938 0.13 140.129 0.197 140.315 0.289 C 140.497 0.38 140.645 0.5 140.759 0.65 L 140.444 0.967 C 140.344 0.856 140.215 0.76 140.062 0.683 C 139.914 0.606 139.757 0.548 139.589 0.505 C 139.427 0.462 139.274 0.443 139.131 0.443 C 138.84 0.443 138.577 0.515 138.338 0.659 C 138.099 0.803 137.894 0.996 137.727 1.246 C 137.56 1.491 137.431 1.771 137.335 2.078 C 137.244 2.382 137.197 2.689 137.197 3.012 C 137.197 3.474 137.273 3.873 137.426 4.215 C 137.584 4.551 137.803 4.816 138.09 4.999 C 138.376 5.182 138.711 5.278 139.093 5.278 C 139.308 5.278 139.542 5.249 139.795 5.186 C 140.048 5.124 140.311 5.028 140.573 4.893 L 140.764 5.263 C 140.674 5.336 140.554 5.403 140.406 5.466 C 140.258 5.528 140.1 5.581 139.933 5.629 C 139.771 5.672 139.613 5.701 139.46 5.73 C 139.308 5.754 139.179 5.769 139.069 5.769 L 139.074 5.759 Z M 131.365 0.077 L 133.916 4.041 C 133.959 4.109 134.002 4.181 134.054 4.258 C 134.107 4.33 134.154 4.402 134.207 4.474 C 134.202 4.393 134.197 4.311 134.193 4.229 L 134.193 0.082 L 134.637 0.082 L 134.637 5.711 L 134.384 5.711 L 131.38 1.068 C 131.346 1.01 131.303 0.948 131.255 0.885 C 131.208 0.813 131.16 0.751 131.112 0.702 C 131.122 0.779 131.127 0.861 131.127 0.948 L 131.127 5.672 L 130.682 5.672 L 130.682 0.606 L 130.577 0.082 L 131.365 0.082 L 131.365 0.077 Z M 125.61 0.077 L 128.848 0.077 L 128.848 0.486 L 126.241 0.486 L 126.241 2.593 L 128.275 2.593 L 128.275 2.993 L 126.241 2.993 L 126.241 5.254 L 128.848 5.254 L 128.848 5.663 L 125.706 5.663 L 125.706 0.606 L 125.606 0.077 L 125.61 0.077 Z M 122.42 0.005 C 122.659 0.005 122.893 0.038 123.117 0.111 C 123.347 0.183 123.571 0.279 123.791 0.395 L 123.533 0.832 C 123.361 0.722 123.179 0.625 122.998 0.553 C 122.821 0.481 122.625 0.447 122.415 0.447 C 122.105 0.447 121.847 0.524 121.642 0.678 C 121.441 0.832 121.346 1.078 121.346 1.41 C 121.346 1.578 121.393 1.727 121.489 1.848 C 121.589 1.968 121.723 2.069 121.88 2.165 C 122.038 2.252 122.21 2.338 122.391 2.425 C 122.568 2.507 122.75 2.598 122.936 2.704 C 123.117 2.8 123.285 2.916 123.433 3.05 C 123.585 3.185 123.71 3.344 123.8 3.536 C 123.891 3.719 123.939 3.945 123.939 4.205 C 123.939 4.571 123.848 4.869 123.671 5.1 C 123.495 5.326 123.261 5.494 122.974 5.6 C 122.688 5.701 122.382 5.754 122.057 5.754 C 121.804 5.754 121.556 5.716 121.322 5.639 C 121.092 5.557 120.863 5.461 120.634 5.355 L 120.863 4.84 C 121.026 4.98 121.226 5.09 121.465 5.177 C 121.704 5.259 121.928 5.302 122.138 5.302 C 122.31 5.302 122.492 5.268 122.683 5.201 C 122.874 5.134 123.031 5.023 123.156 4.869 C 123.289 4.715 123.356 4.513 123.356 4.263 C 123.356 4.013 123.299 3.81 123.189 3.657 C 123.084 3.498 122.941 3.363 122.759 3.257 C 122.587 3.151 122.401 3.05 122.2 2.959 C 122.028 2.877 121.857 2.791 121.689 2.704 C 121.522 2.612 121.369 2.507 121.231 2.396 C 121.092 2.276 120.983 2.141 120.897 1.982 C 120.815 1.819 120.772 1.621 120.772 1.395 C 120.772 1.102 120.854 0.852 121.016 0.65 C 121.178 0.438 121.389 0.279 121.642 0.173 C 121.895 0.067 122.157 0.01 122.42 0.01 L 122.42 0.005 Z M 115.949 0.077 L 119.187 0.077 L 119.187 0.486 L 116.579 0.486 L 116.579 2.593 L 118.614 2.593 L 118.614 2.993 L 116.579 2.993 L 116.579 5.254 L 119.187 5.254 L 119.187 5.663 L 116.044 5.663 L 116.044 0.606 L 115.944 0.077 L 115.949 0.077 Z M 111.297 0.486 L 111.297 2.742 L 111.97 2.742 C 112.252 2.742 112.505 2.714 112.735 2.651 C 112.969 2.584 113.155 2.468 113.293 2.295 C 113.437 2.122 113.508 1.876 113.508 1.564 C 113.508 1.318 113.446 1.116 113.327 0.957 C 113.207 0.799 113.055 0.678 112.859 0.601 C 112.663 0.524 112.458 0.486 112.233 0.486 L 111.302 0.486 L 111.297 0.486 Z M 110.662 0.077 L 112.181 0.077 C 112.539 0.077 112.854 0.125 113.136 0.217 C 113.422 0.303 113.647 0.462 113.809 0.688 C 113.972 0.914 114.053 1.232 114.053 1.636 C 114.053 1.838 114.005 2.03 113.914 2.213 C 113.828 2.396 113.709 2.56 113.561 2.699 C 113.413 2.839 113.246 2.944 113.055 3.017 L 114.535 5.672 L 113.9 5.672 L 112.524 3.147 L 111.288 3.147 L 111.288 5.672 L 110.753 5.672 L 110.753 0.616 L 110.652 0.087 L 110.662 0.077 Z M 106.144 0.486 L 106.144 3.065 L 107.075 3.065 C 107.462 3.065 107.772 2.949 108.002 2.718 C 108.236 2.483 108.355 2.17 108.355 1.78 C 108.355 1.39 108.245 1.058 108.026 0.832 C 107.806 0.601 107.495 0.486 107.085 0.486 L 106.144 0.486 Z M 105.504 0.077 L 107.109 0.077 C 107.476 0.077 107.792 0.14 108.054 0.26 C 108.326 0.38 108.532 0.563 108.675 0.813 C 108.823 1.058 108.895 1.381 108.895 1.775 C 108.895 2.141 108.814 2.449 108.656 2.699 C 108.503 2.949 108.293 3.142 108.021 3.276 C 107.758 3.406 107.452 3.469 107.113 3.469 L 106.144 3.469 L 106.144 5.663 L 105.619 5.663 L 105.619 0.606 L 105.504 0.077 Z M 99.104 0.486 L 97.399 0.486 L 97.399 0.077 L 101.358 0.077 L 101.358 0.486 L 99.63 0.486 L 99.63 5.668 L 99.104 5.668 L 99.104 0.486 Z M 92.848 0.077 L 96.086 0.077 L 96.086 0.486 L 93.478 0.486 L 93.478 2.593 L 95.513 2.593 L 95.513 2.993 L 93.478 2.993 L 93.478 5.254 L 96.086 5.254 L 96.086 5.663 L 92.943 5.663 L 92.943 0.606 L 92.843 0.077 L 92.848 0.077 Z M 90.044 0.077 L 90.68 0.077 L 90.68 5.668 L 90.154 5.668 L 90.154 0.611 C 90.154 0.611 90.145 0.563 90.126 0.486 C 90.111 0.404 90.097 0.318 90.078 0.231 C 90.064 0.144 90.054 0.091 90.049 0.077 L 90.044 0.077 Z M 84.504 0.077 L 84.504 3.796 C 84.504 4.263 84.609 4.638 84.82 4.922 C 85.03 5.201 85.383 5.336 85.889 5.336 C 86.243 5.336 86.529 5.263 86.754 5.119 C 86.983 4.97 87.155 4.768 87.265 4.513 C 87.375 4.253 87.432 3.955 87.432 3.628 L 87.432 0.077 L 87.876 0.077 L 87.876 3.762 C 87.876 4.138 87.805 4.474 87.661 4.778 C 87.518 5.081 87.298 5.321 87.002 5.499 C 86.711 5.672 86.343 5.759 85.894 5.759 C 85.292 5.759 84.82 5.605 84.471 5.297 C 84.132 4.984 83.96 4.523 83.96 3.921 L 83.96 0.601 L 83.855 0.072 L 84.504 0.072 L 84.504 0.077 Z M 79.657 5.34 C 79.996 5.34 80.283 5.268 80.512 5.124 C 80.746 4.975 80.932 4.782 81.071 4.547 C 81.214 4.306 81.314 4.041 81.376 3.753 C 81.438 3.459 81.467 3.166 81.467 2.877 C 81.467 2.588 81.438 2.295 81.376 2.006 C 81.314 1.718 81.214 1.458 81.071 1.222 C 80.932 0.986 80.746 0.794 80.512 0.654 C 80.283 0.51 79.996 0.438 79.657 0.438 C 79.318 0.438 79.026 0.51 78.792 0.654 C 78.563 0.799 78.377 0.991 78.234 1.232 C 78.095 1.467 77.995 1.727 77.938 2.016 C 77.88 2.305 77.852 2.593 77.852 2.887 C 77.852 3.18 77.88 3.464 77.942 3.758 C 78.004 4.046 78.105 4.311 78.238 4.551 C 78.377 4.787 78.558 4.98 78.788 5.129 C 79.022 5.273 79.308 5.345 79.652 5.345 L 79.657 5.34 Z M 85.55 7.058 C 85.469 7.092 85.374 7.13 85.259 7.164 C 85.154 7.207 85.035 7.241 84.901 7.27 C 84.772 7.303 84.633 7.332 84.481 7.356 C 84.328 7.38 84.161 7.395 83.984 7.395 C 83.75 7.395 83.492 7.356 83.21 7.279 C 82.933 7.207 82.651 7.111 82.36 6.986 C 82.069 6.866 81.787 6.745 81.51 6.615 C 81.233 6.486 80.985 6.365 80.76 6.245 C 80.54 6.134 80.359 6.043 80.216 5.985 C 80.063 5.913 79.896 5.855 79.719 5.807 L 79.198 5.682 C 78.749 5.576 78.386 5.389 78.105 5.119 C 77.823 4.855 77.618 4.527 77.484 4.142 C 77.35 3.753 77.283 3.329 77.283 2.872 C 77.283 2.487 77.331 2.122 77.422 1.78 C 77.517 1.429 77.665 1.121 77.856 0.856 C 78.052 0.592 78.296 0.38 78.592 0.231 C 78.893 0.077 79.246 0 79.647 0 C 80.049 0 80.397 0.077 80.693 0.231 C 80.989 0.385 81.233 0.597 81.429 0.861 C 81.625 1.121 81.763 1.429 81.859 1.775 C 81.954 2.117 82.002 2.483 82.002 2.867 C 82.002 3.252 81.949 3.632 81.839 3.998 C 81.734 4.364 81.562 4.686 81.333 4.97 C 81.104 5.249 80.803 5.456 80.431 5.595 C 80.44 5.605 80.454 5.615 80.478 5.624 C 80.497 5.634 80.521 5.644 80.545 5.653 C 80.626 5.701 80.765 5.773 80.965 5.875 C 81.171 5.98 81.405 6.101 81.677 6.231 C 81.954 6.36 82.241 6.481 82.542 6.601 C 82.847 6.726 83.143 6.822 83.43 6.899 C 83.721 6.976 83.979 7.015 84.204 7.015 C 84.313 7.015 84.452 7 84.609 6.976 C 84.772 6.952 84.929 6.919 85.082 6.885 C 85.235 6.851 85.355 6.818 85.44 6.793 L 85.541 7.048 L 85.55 7.058 Z M 70.282 0.077 L 73.252 0.077 L 73.252 0.486 L 70.912 0.486 L 70.912 2.593 L 72.794 2.593 L 72.794 2.993 L 70.912 2.993 L 70.912 5.663 L 70.387 5.663 L 70.387 0.606 L 70.282 0.077 Z M 66.074 5.336 C 66.413 5.336 66.7 5.263 66.929 5.119 C 67.163 4.97 67.349 4.778 67.488 4.532 C 67.631 4.292 67.732 4.027 67.794 3.738 C 67.86 3.445 67.894 3.151 67.894 2.863 C 67.894 2.574 67.86 2.281 67.794 2.001 C 67.732 1.713 67.631 1.453 67.488 1.217 C 67.345 0.981 67.158 0.794 66.929 0.654 C 66.7 0.51 66.418 0.438 66.079 0.438 C 65.74 0.438 65.458 0.51 65.224 0.659 C 64.995 0.803 64.809 0.996 64.665 1.246 C 64.527 1.487 64.427 1.756 64.369 2.045 C 64.307 2.333 64.279 2.622 64.279 2.916 C 64.279 3.209 64.307 3.488 64.369 3.777 C 64.436 4.061 64.536 4.32 64.675 4.556 C 64.813 4.792 64.995 4.984 65.224 5.124 C 65.453 5.263 65.735 5.331 66.074 5.331 L 66.074 5.336 Z M 66.084 5.749 C 65.678 5.749 65.324 5.672 65.024 5.518 C 64.727 5.36 64.484 5.143 64.288 4.874 C 64.092 4.6 63.949 4.296 63.854 3.96 C 63.763 3.618 63.715 3.257 63.715 2.892 C 63.715 2.526 63.763 2.165 63.854 1.823 C 63.944 1.482 64.088 1.174 64.283 0.9 C 64.479 0.625 64.723 0.414 65.024 0.255 C 65.324 0.096 65.678 0.014 66.084 0.014 C 66.49 0.014 66.848 0.096 67.139 0.26 C 67.435 0.419 67.679 0.635 67.865 0.905 C 68.061 1.179 68.2 1.487 68.295 1.828 C 68.386 2.165 68.434 2.516 68.434 2.882 C 68.434 3.248 68.386 3.608 68.295 3.95 C 68.204 4.292 68.061 4.6 67.875 4.874 C 67.689 5.138 67.445 5.355 67.149 5.514 C 66.853 5.672 66.499 5.754 66.089 5.754 L 66.084 5.749 Z M 56.503 0.077 L 57.888 2.3 L 59.111 0.077 L 59.646 0.077 L 58.079 2.786 L 58.079 5.663 L 57.506 5.663 L 57.506 2.786 L 55.84 0.077 L 56.503 0.077 Z M 53.456 2.949 L 50.562 2.949 L 50.562 5.668 L 50.037 5.668 L 50.037 0.611 C 50.037 0.611 50.027 0.563 50.008 0.486 C 49.994 0.404 49.98 0.318 49.96 0.231 C 49.946 0.144 49.937 0.091 49.932 0.077 L 50.567 0.077 L 50.567 2.55 L 53.461 2.55 L 53.461 0.077 L 53.987 0.077 L 53.987 5.668 L 53.461 5.668 L 53.461 2.949 L 53.456 2.949 Z M 45.395 0.486 L 45.395 3.065 L 46.326 3.065 C 46.713 3.065 47.023 2.949 47.253 2.718 C 47.487 2.483 47.606 2.17 47.606 1.78 C 47.606 1.39 47.496 1.058 47.276 0.832 C 47.057 0.601 46.746 0.486 46.336 0.486 L 45.395 0.486 Z M 44.75 0.077 L 46.355 0.077 C 46.722 0.077 47.038 0.14 47.3 0.26 C 47.573 0.38 47.778 0.563 47.921 0.813 C 48.069 1.058 48.141 1.381 48.141 1.775 C 48.141 2.141 48.06 2.449 47.902 2.699 C 47.749 2.949 47.539 3.142 47.267 3.276 C 47.004 3.406 46.699 3.469 46.359 3.469 L 45.39 3.469 L 45.39 5.663 L 44.865 5.663 L 44.865 0.606 L 44.75 0.077 Z M 40.547 5.336 C 40.886 5.336 41.173 5.263 41.402 5.119 C 41.636 4.97 41.822 4.778 41.961 4.532 C 42.104 4.292 42.204 4.027 42.267 3.738 C 42.333 3.445 42.367 3.151 42.367 2.863 C 42.367 2.574 42.333 2.281 42.267 2.001 C 42.204 1.713 42.104 1.453 41.961 1.217 C 41.818 0.981 41.631 0.794 41.402 0.654 C 41.173 0.51 40.891 0.438 40.552 0.438 C 40.213 0.438 39.931 0.51 39.697 0.659 C 39.468 0.803 39.282 0.996 39.138 1.246 C 39 1.487 38.9 1.756 38.842 2.045 C 38.78 2.333 38.751 2.622 38.751 2.916 C 38.751 3.209 38.78 3.488 38.842 3.777 C 38.909 4.061 39.009 4.32 39.148 4.556 C 39.286 4.792 39.468 4.984 39.697 5.124 C 39.926 5.263 40.208 5.331 40.547 5.331 L 40.547 5.336 Z M 40.552 5.749 C 40.146 5.749 39.793 5.672 39.492 5.518 C 39.196 5.36 38.952 5.143 38.756 4.874 C 38.56 4.6 38.417 4.296 38.322 3.96 C 38.231 3.618 38.183 3.257 38.183 2.892 C 38.183 2.526 38.231 2.165 38.322 1.823 C 38.412 1.482 38.556 1.174 38.751 0.9 C 38.947 0.625 39.191 0.414 39.492 0.255 C 39.793 0.096 40.146 0.014 40.552 0.014 C 40.958 0.014 41.316 0.096 41.607 0.26 C 41.904 0.419 42.147 0.635 42.333 0.905 C 42.529 1.179 42.668 1.487 42.763 1.828 C 42.854 2.165 42.902 2.516 42.902 2.882 C 42.902 3.248 42.854 3.608 42.763 3.95 C 42.672 4.292 42.529 4.6 42.343 4.874 C 42.157 5.138 41.913 5.355 41.617 5.514 C 41.321 5.672 40.967 5.754 40.557 5.754 L 40.552 5.749 Z M 35.17 0.005 C 35.408 0.005 35.642 0.038 35.867 0.111 C 36.096 0.183 36.321 0.279 36.54 0.395 L 36.282 0.832 C 36.11 0.722 35.929 0.625 35.747 0.553 C 35.571 0.481 35.375 0.447 35.165 0.447 C 34.854 0.447 34.596 0.524 34.391 0.678 C 34.191 0.832 34.095 1.078 34.095 1.41 C 34.095 1.578 34.143 1.727 34.238 1.848 C 34.339 1.968 34.472 2.069 34.63 2.165 C 34.788 2.252 34.959 2.338 35.141 2.425 C 35.318 2.507 35.499 2.598 35.685 2.704 C 35.867 2.8 36.034 2.916 36.182 3.05 C 36.335 3.185 36.459 3.344 36.55 3.536 C 36.641 3.719 36.688 3.945 36.688 4.205 C 36.688 4.571 36.598 4.869 36.421 5.1 C 36.244 5.326 36.01 5.494 35.724 5.6 C 35.437 5.701 35.131 5.754 34.807 5.754 C 34.553 5.754 34.305 5.716 34.071 5.639 C 33.842 5.557 33.613 5.461 33.383 5.355 L 33.613 4.84 C 33.775 4.98 33.976 5.09 34.214 5.177 C 34.453 5.259 34.678 5.302 34.888 5.302 C 35.06 5.302 35.241 5.268 35.432 5.201 C 35.619 5.134 35.781 5.023 35.905 4.869 C 36.039 4.715 36.106 4.513 36.106 4.263 C 36.106 4.013 36.048 3.81 35.938 3.657 C 35.833 3.498 35.69 3.363 35.509 3.257 C 35.337 3.151 35.15 3.05 34.95 2.959 C 34.778 2.877 34.606 2.791 34.439 2.704 C 34.272 2.612 34.119 2.507 33.98 2.396 C 33.842 2.276 33.732 2.141 33.646 1.982 C 33.565 1.819 33.522 1.621 33.522 1.395 C 33.522 1.102 33.603 0.852 33.765 0.65 C 33.928 0.438 34.138 0.279 34.391 0.173 C 34.644 0.067 34.907 0.01 35.17 0.01 L 35.17 0.005 Z M 29.443 5.336 C 29.782 5.336 30.069 5.263 30.298 5.119 C 30.532 4.97 30.718 4.778 30.857 4.532 C 31 4.292 31.101 4.027 31.163 3.738 C 31.229 3.445 31.263 3.151 31.263 2.863 C 31.263 2.574 31.229 2.281 31.163 2.001 C 31.101 1.713 31 1.453 30.857 1.217 C 30.714 0.981 30.527 0.794 30.298 0.654 C 30.069 0.51 29.787 0.438 29.448 0.438 C 29.109 0.438 28.827 0.51 28.593 0.659 C 28.364 0.803 28.178 0.996 28.034 1.246 C 27.896 1.487 27.796 1.756 27.738 2.045 C 27.676 2.333 27.648 2.622 27.648 2.916 C 27.648 3.209 27.676 3.488 27.738 3.777 C 27.805 4.061 27.905 4.32 28.044 4.556 C 28.182 4.792 28.364 4.984 28.593 5.124 C 28.822 5.263 29.104 5.331 29.443 5.331 L 29.443 5.336 Z M 29.453 5.749 C 29.047 5.749 28.693 5.672 28.393 5.518 C 28.096 5.36 27.853 5.143 27.657 4.874 C 27.461 4.6 27.318 4.296 27.223 3.96 C 27.132 3.618 27.084 3.257 27.084 2.892 C 27.084 2.526 27.132 2.165 27.223 1.823 C 27.313 1.482 27.457 1.174 27.652 0.9 C 27.848 0.625 28.092 0.414 28.393 0.255 C 28.693 0.096 29.047 0.014 29.453 0.014 C 29.859 0.014 30.217 0.096 30.508 0.26 C 30.804 0.419 31.048 0.635 31.234 0.905 C 31.43 1.179 31.569 1.487 31.664 1.828 C 31.755 2.165 31.803 2.516 31.803 2.882 C 31.803 3.248 31.755 3.608 31.664 3.95 C 31.573 4.292 31.43 4.6 31.244 4.874 C 31.058 5.138 30.814 5.355 30.518 5.514 C 30.222 5.672 29.868 5.754 29.458 5.754 L 29.453 5.749 Z M 22.724 0.077 L 23.359 0.077 L 23.359 5.259 L 25.775 5.259 L 25.775 5.668 L 22.843 5.668 L 22.843 0.611 L 22.728 0.082 L 22.724 0.077 Z M 19.93 0.077 L 20.565 0.077 L 20.565 5.668 L 20.04 5.668 L 20.04 0.611 C 20.04 0.611 20.03 0.563 20.011 0.486 C 19.997 0.404 19.982 0.318 19.963 0.231 C 19.944 0.144 19.939 0.091 19.935 0.077 L 19.93 0.077 Z M 17.241 2.949 L 14.347 2.949 L 14.347 5.668 L 13.821 5.668 L 13.821 0.611 C 13.821 0.611 13.812 0.563 13.793 0.486 C 13.778 0.404 13.764 0.318 13.745 0.231 C 13.731 0.144 13.721 0.091 13.716 0.077 L 14.352 0.077 L 14.352 2.55 L 17.246 2.55 L 17.246 0.077 L 17.771 0.077 L 17.771 5.668 L 17.246 5.668 L 17.246 2.949 L 17.241 2.949 Z M 9.179 0.486 L 9.179 3.065 L 10.111 3.065 C 10.497 3.065 10.808 2.949 11.037 2.718 C 11.271 2.483 11.39 2.17 11.39 1.78 C 11.39 1.39 11.281 1.058 11.061 0.832 C 10.841 0.601 10.531 0.486 10.12 0.486 L 9.179 0.486 Z M 8.539 0.077 L 10.144 0.077 C 10.512 0.077 10.827 0.14 11.09 0.26 C 11.362 0.38 11.567 0.563 11.71 0.813 C 11.859 1.058 11.93 1.381 11.93 1.775 C 11.93 2.141 11.849 2.449 11.691 2.699 C 11.539 2.949 11.328 3.142 11.056 3.276 C 10.793 3.406 10.488 3.469 10.149 3.469 L 9.179 3.469 L 9.179 5.663 L 8.654 5.663 L 8.654 0.606 L 8.539 0.077 Z M 2.187 0.808 L 1.347 3.18 L 3.004 3.18 L 2.187 0.808 Z M 2.536 0.077 L 4.432 5.668 L 3.83 5.668 L 3.133 3.58 L 1.213 3.58 L 0.516 5.668 L 0 5.668 L 1.91 0.077 L 2.536 0.077 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 21,
      top: 92.289,
      width: 200.999,
      height: 35.449,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 3.438,
    height: 34.413,
    viewBox: "0 0 3.438 34.413",
    fill: "none",
    style: {
      position: "absolute",
      left: 95.712,
      top: 0.287,
      width: 3.438,
      height: 34.413,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.438 0 L 0 0 L 0 34.413 L 3.438 34.413 L 3.438 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 27.696,
    height: 33.950,
    viewBox: "0 0 27.696 33.950",
    fill: "none",
    style: {
      position: "absolute",
      left: 51.34,
      top: 0.749,
      width: 27.696,
      height: 33.95,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.006 33.95 L 0.006 0 L 27.294 0 L 27.294 3.157 L 3.462 3.157 L 3.462 15.171 L 23.649 15.171 L 23.649 18.273 L 3.462 18.273 L 3.462 30.793 L 27.696 30.793 L 27.696 33.95 L 0 33.95 L 0.006 33.95 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.522,
    height: 35.449,
    viewBox: "0 0 36.522 35.449",
    fill: "none",
    style: {
      position: "absolute",
      left: 164.478,
      top: 0,
      width: 36.522,
      height: 35.449,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.522 35.449 L 20.602 0 L 15.823 0 L 0 35.449 L 4.017 35.449 L 7.802 26.861 L 9.679 22.479 C 20.333 21.821 29.013 28.19 31.408 33.365 L 32.317 35.449 L 36.516 35.449 L 36.522 35.449 Z M 16.506 6.802 C 17.274 4.998 17.688 3.931 18.151 2.176 C 18.511 3.767 18.822 4.73 19.742 6.802 L 26.112 21.309 L 27.709 24.887 C 22.656 21.961 14.421 20.925 10.228 21.236 L 16.512 6.802 L 16.506 6.802 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.601,
    height: 34.413,
    viewBox: "0 0 36.601 34.413",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.287,
      width: 36.601,
      height: 34.413,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.745 11.556 C 19.133 6.784 26.215 3.877 33.962 3.877 L 33.962 0.463 C 20.565 0.463 6.211 11.319 3.438 24.314 L 3.438 0 L 0 0 L 0 34.413 L 3.438 34.413 L 3.438 33.974 C 3.547 26.288 6.504 19.285 11.3 13.97 L 31.744 34.413 L 36.601 34.413 L 13.745 11.556 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.601,
    height: 34.413,
    viewBox: "0 0 36.601 34.413",
    fill: "none",
    style: {
      position: "absolute",
      left: 120.732,
      top: 0.287,
      width: 36.601,
      height: 34.413,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.745 11.556 C 19.133 6.784 26.215 3.877 33.962 3.877 L 33.962 0.463 C 20.565 0.463 6.211 11.319 3.438 24.314 L 3.438 0 L 0 0 L 0 34.413 L 3.438 34.413 L 3.438 33.974 C 3.547 26.288 6.504 19.285 11.3 13.97 L 31.744 34.413 L 36.601 34.413 L 13.745 11.556 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

// figma node: 271:23484 Frame 554
function Frame554(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: "fit-content",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 28,
      lineHeight: "38px",
      letterSpacing: "0.120em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch",
      whiteSpace: "pre-wrap"
    }
  }, props.text1 ?? "BRAND\nCONCEPT"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 13,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, props.text2 ?? "ブランドコンセプト"));
}

// figma node: 271:23501 header (2 variants)
const __venc_Header6 = v => String(v).replace(/[%|=]/g, encodeURIComponent);
const __vkey_Header6 = p => "prop=" + __venc_Header6(p.prop);
function Header6() {
  /* canvas 内のヘッダーは描画しない */
  return null;
}
function Header6Figma(_p = {}) {
  const props = {
    ..._p,
    prop: _p.prop ?? "デフォルト"
  };
  const __body0 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 390,
      height: 60,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 60
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 137,
      top: 21,
      width: 115.073,
      height: 20.295,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 1.968,
    height: 19.701,
    viewBox: "0 0 1.968 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 54.794,
      top: 0.164,
      width: 1.968,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 15.856,
    height: 19.436,
    viewBox: "0 0 15.856 19.436",
    fill: "none",
    style: {
      position: "absolute",
      left: 29.392,
      top: 0.429,
      width: 15.856,
      height: 19.436,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.003 19.436 L 0.003 0 L 15.626 0 L 15.626 1.808 L 1.982 1.808 L 1.982 8.685 L 13.539 8.685 L 13.539 10.461 L 1.982 10.461 L 1.982 17.629 L 15.856 17.629 L 15.856 19.436 L 0 19.436 L 0.003 19.436 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.909,
    height: 20.295,
    viewBox: "0 0 20.909 20.295",
    fill: "none",
    style: {
      position: "absolute",
      left: 94.162,
      top: 0,
      width: 20.909,
      height: 20.295,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.909 20.295 L 11.794 0 L 9.059 0 L 0 20.295 L 2.3 20.295 L 4.466 15.378 L 5.541 12.869 C 11.641 12.492 16.61 16.139 17.981 19.101 L 18.501 20.295 L 20.905 20.295 L 20.909 20.295 Z M 9.449 3.894 C 9.889 2.861 10.126 2.251 10.392 1.246 C 10.597 2.156 10.775 2.708 11.302 3.894 L 14.949 12.199 L 15.863 14.247 C 12.97 12.572 8.256 11.979 5.855 12.157 L 9.453 3.894 L 9.449 3.894 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.954,
    height: 19.701,
    viewBox: "0 0 20.954 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.164,
      width: 20.954,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.869 6.616 C 10.953 3.884 15.008 2.219 19.443 2.219 L 19.443 0.265 C 11.773 0.265 3.556 6.48 1.968 13.919 L 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 19.45 C 2.031 15.05 3.723 11.041 6.469 7.998 L 18.173 19.701 L 20.954 19.701 L 7.869 6.616 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.954,
    height: 19.701,
    viewBox: "0 0 20.954 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 69.119,
      top: 0.164,
      width: 20.954,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.869 6.616 C 10.953 3.884 15.008 2.219 19.443 2.219 L 19.443 0.265 C 11.773 0.265 3.556 6.48 1.968 13.919 L 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 19.45 C 2.031 15.05 3.723 11.041 6.469 7.998 L 18.173 19.701 L 20.954 19.701 L 7.869 6.616 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 19,
      top: 24,
      width: 50,
      height: 14,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1,
    viewBox: "0 -0.500 50 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 50,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 50 0 L 50 -0.5 L 50 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1,
    viewBox: "0 -0.500 50 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 14,
      width: 50,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 50 0 L 50 -0.5 L 50 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 296,
      top: 26,
      width: 98,
      height: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: -8,
      top: -11.5,
      width: 29,
      height: 34.5,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 4.5,
      top: 0,
      width: 20,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 10.353,
    height: 10.498,
    viewBox: "0 0 10.353 10.498",
    fill: "none",
    style: {
      position: "absolute",
      left: 5.024,
      top: 0,
      width: 10.353,
      height: 10.498,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.176 10.498 C 8.033 10.498 10.353 8.146 10.353 5.249 C 10.353 2.352 8.026 0 5.176 0 C 2.326 0 0 2.352 0 5.249 C 0 8.146 2.319 10.498 5.176 10.498 Z M 5.176 1.474 C 7.226 1.474 8.899 3.17 8.899 5.249 C 8.899 7.328 7.226 9.023 5.176 9.023 C 3.126 9.023 1.454 7.328 1.454 5.249 C 1.454 3.17 3.126 1.474 5.176 1.474 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20,
    height: 7.202,
    viewBox: "0 0 20 7.202",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 12.798,
      width: 20,
      height: 7.202,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.927 6.391 C 19.927 6.325 19.753 4.711 18.401 3.118 C 17.186 1.696 14.751 0 10.004 0 C 5.256 0 2.814 1.696 1.607 3.118 C 0.247 4.711 0.08 6.325 0.08 6.391 L 0 7.202 L 20 7.202 L 19.92 6.391 L 19.927 6.391 Z M 10.004 5.728 L 1.73 5.728 C 2.246 4.29 4.028 1.482 10.004 1.482 C 15.98 1.482 17.761 4.298 18.277 5.728 L 10.004 5.728 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 24.5,
      width: 29,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text1 ?? "Login")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 42,
      top: -10,
      width: 26,
      height: 33,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 1,
      top: 23,
      width: 25,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text2 ?? "Cart "), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 23,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
  const __body1 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 390,
      height: 60,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 60,
      backgroundColor: "rgb(249,249,249)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 60,
      width: 390,
      height: 1,
      backgroundColor: "rgb(42,43,45)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 137,
      top: 21,
      width: 115.073,
      height: 20.295,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 1.968,
    height: 19.701,
    viewBox: "0 0 1.968 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 54.794,
      top: 0.164,
      width: 1.968,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 15.856,
    height: 19.436,
    viewBox: "0 0 15.856 19.436",
    fill: "none",
    style: {
      position: "absolute",
      left: 29.392,
      top: 0.429,
      width: 15.856,
      height: 19.436,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.003 19.436 L 0.003 0 L 15.626 0 L 15.626 1.808 L 1.982 1.808 L 1.982 8.685 L 13.539 8.685 L 13.539 10.461 L 1.982 10.461 L 1.982 17.629 L 15.856 17.629 L 15.856 19.436 L 0 19.436 L 0.003 19.436 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.909,
    height: 20.295,
    viewBox: "0 0 20.909 20.295",
    fill: "none",
    style: {
      position: "absolute",
      left: 94.162,
      top: 0,
      width: 20.909,
      height: 20.295,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.909 20.295 L 11.794 0 L 9.059 0 L 0 20.295 L 2.3 20.295 L 4.466 15.378 L 5.541 12.869 C 11.641 12.492 16.61 16.139 17.981 19.101 L 18.501 20.295 L 20.905 20.295 L 20.909 20.295 Z M 9.449 3.894 C 9.889 2.861 10.126 2.251 10.392 1.246 C 10.597 2.156 10.775 2.708 11.302 3.894 L 14.949 12.199 L 15.863 14.247 C 12.97 12.572 8.256 11.979 5.855 12.157 L 9.453 3.894 L 9.449 3.894 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.954,
    height: 19.701,
    viewBox: "0 0 20.954 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.164,
      width: 20.954,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.869 6.616 C 10.953 3.884 15.008 2.219 19.443 2.219 L 19.443 0.265 C 11.773 0.265 3.556 6.48 1.968 13.919 L 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 19.45 C 2.031 15.05 3.723 11.041 6.469 7.998 L 18.173 19.701 L 20.954 19.701 L 7.869 6.616 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.954,
    height: 19.701,
    viewBox: "0 0 20.954 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 69.119,
      top: 0.164,
      width: 20.954,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.869 6.616 C 10.953 3.884 15.008 2.219 19.443 2.219 L 19.443 0.265 C 11.773 0.265 3.556 6.48 1.968 13.919 L 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 19.45 C 2.031 15.05 3.723 11.041 6.469 7.998 L 18.173 19.701 L 20.954 19.701 L 7.869 6.616 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 19,
      top: 24,
      width: 50,
      height: 14,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1,
    viewBox: "0 -0.500 50 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 50,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 50 0 L 50 -0.5 L 50 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1,
    viewBox: "0 -0.500 50 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 14,
      width: 50,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 50 0 L 50 -0.5 L 50 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 296,
      top: 26,
      width: 98,
      height: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: -8,
      top: -11.5,
      width: 29,
      height: 34.5,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 4.5,
      top: 0,
      width: 20,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 10.353,
    height: 10.498,
    viewBox: "0 0 10.353 10.498",
    fill: "none",
    style: {
      position: "absolute",
      left: 5.024,
      top: 0,
      width: 10.353,
      height: 10.498,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.176 10.498 C 8.033 10.498 10.353 8.146 10.353 5.249 C 10.353 2.352 8.026 0 5.176 0 C 2.326 0 0 2.352 0 5.249 C 0 8.146 2.319 10.498 5.176 10.498 Z M 5.176 1.474 C 7.226 1.474 8.899 3.17 8.899 5.249 C 8.899 7.328 7.226 9.023 5.176 9.023 C 3.126 9.023 1.454 7.328 1.454 5.249 C 1.454 3.17 3.126 1.474 5.176 1.474 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20,
    height: 7.202,
    viewBox: "0 0 20 7.202",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 12.798,
      width: 20,
      height: 7.202,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.927 6.391 C 19.927 6.325 19.753 4.711 18.401 3.118 C 17.186 1.696 14.751 0 10.004 0 C 5.256 0 2.814 1.696 1.607 3.118 C 0.247 4.711 0.08 6.325 0.08 6.391 L 0 7.202 L 20 7.202 L 19.92 6.391 L 19.927 6.391 Z M 10.004 5.728 L 1.73 5.728 C 2.246 4.29 4.028 1.482 10.004 1.482 C 15.98 1.482 17.761 4.298 18.277 5.728 L 10.004 5.728 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 24.5,
      width: 29,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text1 ?? "Login")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 42,
      top: -10,
      width: 26,
      height: 33,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 1,
      top: 23,
      width: 25,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text2 ?? "Cart "), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 23,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
  const __impls = {
    // figma: プロパティ1=デフォルト
    "prop=デフォルト": __body0,
    // figma: プロパティ1=バリアント2
    "prop=バリアント2": __body1
  };
  return (__impls[__vkey_Header6(props)] ?? __body0)();
}

// figma node: 271:23627 under
function Under4(p) {
  /* 共通パーツへ委譲 → KEIKAUnderSP */
  var C = window.KEIKAUnderSP;
  if (!C) { console.error("[KEIKA] KEIKAUnderSP 未読込"); return null; }
  return React.createElement(C, p);
}
function Under4Figma(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 390,
      height: 318,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 195,
      top: 0,
      width: 195,
      height: 159
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 195,
      height: 159,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 195,
      height: 159,
      clipPath: "inset(0px 0px 0px 0px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fig-asset-2c93637f5cfae14f",
    style: {
      position: "absolute",
      left: -206,
      top: -515,
      width: 661,
      height: 1175
    }
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 55,
      top: 27,
      width: 95,
      height: 20,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 16,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.200em",
      color: "rgb(249,249,249)"
    }
  }, props.text1 ?? "CONTACT"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 60,
      top: 109,
      width: 84,
      height: 19,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 13,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(249,249,249)"
    }
  }, props.text2 ?? "お問い合わせ"), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 82,
      top: 64,
      width: 38,
      height: 32,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 4.055,
    height: 2.663,
    viewBox: "0 0 4.055 2.663",
    fill: "none",
    style: {
      position: "absolute",
      left: 22.817,
      top: 26.976,
      width: 4.055,
      height: 2.663,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.658 C 1.094 1.618 2.422 2.312 3.841 2.663 L 4.055 1.811 C 2.773 1.494 1.574 0.867 0.586 0 L 0 0.658 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 8.719,
    height: 20.156,
    viewBox: "0 0 8.719 20.156",
    fill: "none",
    style: {
      position: "absolute",
      left: 29.281,
      top: 11.841,
      width: 8.719,
      height: 20.156,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.15 5.94 C 6.895 2.519 3.715 0.188 0.046 0 L 0 0.876 C 3.311 1.044 6.183 3.149 7.316 6.238 C 8.894 10.539 6.787 15.111 2.52 16.649 L 2.017 16.829 L 4.025 20.156 L 4.784 19.704 L 3.32 17.277 C 5.369 16.403 6.985 14.837 7.91 12.819 C 8.899 10.654 8.984 8.211 8.15 5.936 L 8.15 5.94 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 27.602,
    height: 30.666,
    viewBox: "0 0 27.602 30.666",
    fill: "none",
    style: {
      position: "absolute",
      left: -0.001,
      top: 0,
      width: 27.602,
      height: 30.666,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.529 0.823 C 11.384 -1.752 3.459 1.915 0.861 8.996 C -0.401 12.436 -0.272 16.133 1.224 19.405 C 2.657 22.536 5.196 24.949 8.411 26.247 L 6.017 30.215 L 6.777 30.666 L 9.716 25.794 L 9.213 25.613 C 5.989 24.451 3.438 22.116 2.032 19.043 C 0.631 15.982 0.511 12.52 1.693 9.296 C 4.125 2.67 11.542 -0.762 18.226 1.648 C 24.91 4.058 28.372 11.409 25.941 18.037 C 24.473 22.036 21.109 25.041 16.939 26.076 L 17.153 26.928 C 21.608 25.822 25.204 22.611 26.771 18.337 C 29.369 11.257 25.672 3.4 18.527 0.823 L 18.529 0.823 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 13.818,
    height: 0.878,
    viewBox: "0 0 13.818 0.878",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.281,
      top: 10.897,
      width: 13.818,
      height: 0.878,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.818 0 L 0 0 L 0 0.878 L 13.818 0.878 L 13.818 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 7.851,
    height: 0.878,
    viewBox: "0 0 7.851 0.878",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.281,
      top: 16.11,
      width: 7.851,
      height: 0.878,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.851 0 L 0 0 L 0 0.878 L 7.851 0.878 L 7.851 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", {
    width: 159,
    height: 1,
    viewBox: "0 -0.500 159 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,1,-1,0,195,0)",
      transformOrigin: "0 0",
      width: 159,
      height: 1,
      color: "rgb(227,226,222)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 159 0 L 159 -0.5 L 159 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 195,
      height: 159
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 195,
      height: 159,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 195,
      height: 159,
      clipPath: "inset(0px 0px 0px 0px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fig-asset-2c93637f5cfae14f",
    style: {
      position: "absolute",
      left: -11,
      top: -515,
      width: 661,
      height: 1175
    }
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 76,
      top: 27,
      width: 41,
      height: 20,
      fontFamily: "Selna, \"Marcellus\", serif",
      fontWeight: 400,
      fontSize: 16,
      textAlign: "center",
      whiteSpace: "pre-wrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(249,249,249)",
      display: "inline-block"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "rgb(249,249,249)",
      fontSize: 16
    }
  }, "Q"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 16
    }
  }, "&A")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 47,
      top: 109,
      width: 98,
      height: 19,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 13,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(249,249,249)"
    }
  }, props.text3 ?? "よくあるご質問"), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 81,
      top: 63,
      width: 30,
      height: 34,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 29.999,
    height: 34.000,
    viewBox: "0 0 29.999 34.000",
    fill: "none",
    style: {
      position: "absolute",
      left: -0.001,
      top: 0,
      width: 29.999,
      height: 34,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.138 0.921 C 16.376 -0.463 12.308 -0.282 8.682 1.428 C 5.054 3.141 2.304 6.176 0.936 9.979 C -0.436 13.793 -0.296 17.89 1.331 21.517 C 2.887 24.988 5.649 27.663 9.142 29.101 L 6.54 33.5 L 7.366 34 L 10.56 28.599 L 10.014 28.399 C 6.509 27.111 3.736 24.523 2.208 21.116 C 0.686 17.723 0.555 13.886 1.841 10.312 C 3.12 6.754 5.695 3.913 9.088 2.312 C 12.481 0.71 16.289 0.541 19.809 1.835 C 27.074 4.506 30.836 12.655 28.194 20.001 C 26.598 24.434 22.942 27.764 18.41 28.912 L 18.643 29.856 C 23.485 28.63 27.393 25.072 29.096 20.334 C 31.919 12.485 27.901 3.777 20.136 0.921 L 20.138 0.921 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 1.312,
    height: 1.677,
    viewBox: "0 0 1.312 1.677",
    fill: "none",
    style: {
      position: "absolute",
      left: 14.302,
      top: 19.976,
      width: 1.312,
      height: 1.677,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.312 0 L 0 0 L 0 1.677 L 1.312 1.677 L 1.312 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 7.170,
    height: 9.213,
    viewBox: "0 0 7.170 9.213",
    fill: "none",
    style: {
      position: "absolute",
      left: 11.57,
      top: 9.078,
      width: 7.17,
      height: 9.213,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.17 3.288 C 7.17 2.866 7.107 2.467 6.98 2.094 C 6.853 1.72 6.655 1.387 6.383 1.095 C 6.045 0.702 5.627 0.42 5.131 0.253 C 4.634 0.086 4.109 0 3.556 0 C 3.104 0 2.658 0.07 2.215 0.21 C 1.772 0.35 1.384 0.574 1.051 0.881 C 0.718 1.173 0.466 1.533 0.293 1.965 C 0.119 2.397 0.023 2.837 0 3.288 L 1.287 3.288 C 1.287 3.002 1.332 2.732 1.418 2.475 C 1.507 2.218 1.645 1.998 1.838 1.815 C 2.036 1.609 2.284 1.457 2.586 1.358 C 2.889 1.259 3.214 1.208 3.564 1.208 C 3.914 1.208 4.261 1.259 4.588 1.362 C 4.915 1.465 5.192 1.656 5.417 1.936 C 5.564 2.101 5.673 2.298 5.743 2.527 C 5.814 2.755 5.848 3.016 5.848 3.306 C 5.848 3.596 5.812 3.874 5.739 4.136 C 5.666 4.399 5.519 4.658 5.298 4.915 C 5.055 5.177 4.798 5.405 4.528 5.596 C 4.257 5.786 3.997 5.989 3.749 6.203 C 3.501 6.417 3.291 6.687 3.121 7.012 C 2.941 7.355 2.829 7.695 2.787 8.035 C 2.744 8.376 2.723 8.767 2.723 9.213 L 4.043 9.213 C 4.043 8.835 4.051 8.526 4.064 8.279 C 4.078 8.034 4.159 7.773 4.305 7.5 C 4.424 7.279 4.594 7.07 4.817 6.88 C 5.04 6.689 5.273 6.502 5.515 6.323 C 5.758 6.144 5.975 5.948 6.168 5.738 C 6.483 5.413 6.73 5.041 6.905 4.625 C 7.08 4.208 7.167 3.763 7.167 3.29 L 7.17 3.288 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 160,
      width: 390,
      height: 159
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 159,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 159,
      clipPath: "inset(0px 0px 0px 0px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fig-asset-2c93637f5cfae14f",
    style: {
      position: "absolute",
      left: -11,
      top: -669,
      width: 661,
      height: 1175
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 38,
      top: 33,
      width: 320,
      height: 94
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 143,
      top: 38,
      width: 27,
      height: 27,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 27.000,
    height: 27,
    viewBox: "0 0 27.000 27",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 27,
      height: 27,
      color: "rgb(249,249,249)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.909 0.093 C 6.472 0.161 5.491 0.391 4.634 0.727 C 3.747 1.073 2.994 1.537 2.246 2.288 C 1.497 3.04 1.037 3.794 0.693 4.682 C 0.361 5.541 0.135 6.523 0.072 7.96 C 0.009 9.401 -0.005 9.86 0.002 13.526 C 0.009 17.191 0.025 17.652 0.093 19.092 C 0.162 20.528 0.391 21.509 0.727 22.367 C 1.074 23.254 1.537 24.006 2.289 24.755 C 3.04 25.503 3.794 25.963 4.683 26.307 C 5.541 26.639 6.523 26.865 7.96 26.928 C 9.4 26.991 9.86 27.005 13.525 26.998 C 17.192 26.991 17.652 26.975 19.091 26.907 C 20.528 26.838 21.508 26.608 22.366 26.273 C 23.254 25.926 24.006 25.463 24.754 24.712 C 25.503 23.96 25.963 23.206 26.306 22.317 C 26.639 21.459 26.865 20.477 26.927 19.041 C 26.99 17.6 27.005 17.14 26.998 13.474 C 26.991 9.809 26.975 9.349 26.906 7.91 C 26.838 6.472 26.608 5.492 26.273 4.634 C 25.926 3.747 25.463 2.995 24.711 2.246 C 23.96 1.497 23.206 1.037 22.317 0.694 C 21.458 0.362 20.477 0.135 19.04 0.073 C 17.6 0.009 17.14 -0.005 13.474 0.002 C 9.809 0.009 9.349 0.024 7.909 0.093 M 8.067 24.498 C 6.75 24.441 6.036 24.222 5.559 24.039 C 4.929 23.795 4.478 23.502 4.005 23.032 C 3.532 22.56 3.238 22.111 2.992 21.482 C 2.807 21.006 2.584 20.292 2.523 18.976 C 2.456 17.553 2.441 17.126 2.434 13.521 C 2.427 9.917 2.44 9.49 2.502 8.066 C 2.559 6.751 2.779 6.035 2.962 5.56 C 3.206 4.928 3.497 4.479 3.968 4.005 C 4.44 3.531 4.889 3.239 5.519 2.992 C 5.995 2.806 6.709 2.586 8.024 2.523 C 9.448 2.456 9.875 2.441 13.478 2.434 C 17.083 2.427 17.51 2.44 18.934 2.503 C 20.249 2.56 20.965 2.778 21.44 2.962 C 22.072 3.206 22.522 3.497 22.995 3.969 C 23.468 4.441 23.762 4.889 24.008 5.52 C 24.194 5.995 24.415 6.709 24.477 8.024 C 24.545 9.448 24.56 9.875 24.567 13.479 C 24.574 17.084 24.561 17.511 24.498 18.934 C 24.441 20.25 24.223 20.965 24.039 21.442 C 23.795 22.072 23.503 22.522 23.032 22.996 C 22.56 23.468 22.111 23.762 21.481 24.008 C 21.006 24.194 20.291 24.415 18.976 24.478 C 17.553 24.545 17.126 24.56 13.521 24.567 C 9.917 24.574 9.491 24.56 8.067 24.498 M 19.072 6.284 C 19.073 7.178 19.8 7.902 20.694 7.9 C 21.589 7.898 22.313 7.172 22.311 6.278 C 22.31 5.384 21.583 4.659 20.688 4.661 C 19.794 4.662 19.07 5.389 19.071 6.283 M 6.568 13.513 C 6.576 17.342 9.685 20.439 13.513 20.431 C 17.341 20.424 20.44 17.315 20.432 13.487 C 20.425 9.659 17.315 6.561 13.486 6.568 C 9.658 6.576 6.561 9.685 6.568 13.513 Z M 9 13.508 C 8.996 11.024 11.007 9.005 13.491 9 C 15.976 8.996 17.995 11.006 18 13.491 C 18.005 15.977 15.993 17.995 13.508 18 C 11.024 18.005 9.005 15.994 9 13.509",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 201,
      top: 4,
      width: 109,
      height: 94,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 16,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "94px",
      letterSpacing: "0.160em",
      color: "rgb(249,249,249)"
    }
  }, props.text4 ?? "FOLLOW US"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 21,
      top: 4,
      width: 92,
      height: 94,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 16,
      textAlign: "center",
      whiteSpace: "nowrap",
      lineHeight: "94px",
      letterSpacing: "0.160em",
      color: "rgb(249,249,249)"
    }
  }, "Instagram"))), /*#__PURE__*/React.createElement("svg", {
    width: 390,
    height: 1,
    viewBox: "0 -0.500 390 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(-1,0,0,-1,390,159)",
      transformOrigin: "0 0",
      width: 390,
      height: 1,
      color: "rgb(227,226,222)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 390 0 L 390 -0.5 L 390 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

// figma node: 271:29431 12SP_contract
function SPContract12(_p = {}) {
  const props = _p;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 390,
      height: 3455,
      overflow: "hidden",
      position: "relative",
      color: "rgb(129,136,148)",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement(Footer7, {
    style: {
      position: "absolute",
      left: 0,
      top: 2801,
      width: 390,
      height: 654
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 48,
      width: 390,
      height: 2753,
      overflow: "hidden",
      backgroundColor: "rgb(227,226,222)"
    }
  }, /*#__PURE__*/React.createElement(Under4, {
    style: {
      position: "absolute",
      left: 0,
      top: 2435,
      width: 390,
      height: 318,
      color: "rgb(249,249,249)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 45,
      width: 390,
      height: 205
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 205,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 205,
      backgroundColor: "rgb(227,226,222)"
    }
  })), /*#__PURE__*/React.createElement(Frame554, {
    style: {
      position: "absolute",
      left: 21,
      top: 114,
      width: 174,
      height: 65
    },
    text1: "CONTRACT",
    text2: "特定商取引法"
  })), /*#__PURE__*/React.createElement(Header6, {
    style: {
      position: "absolute",
      left: 0,
      top: 45,
      width: 390,
      height: 60
    },
    prop: "デフォルト"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 45
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 45,
      backgroundColor: "rgb(42,43,45)"
    }
  }), /*#__PURE__*/React.createElement(Component25_, {
    style: {
      position: "absolute",
      left: 24,
      top: 13,
      width: 366,
      height: 18
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 20,
      top: 307,
      width: 350,
      display: "flex",
      flexDirection: "column",
      gap: 24,
      alignItems: "flex-start",
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u696D\u8005\u306E\u540D\u79F0")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u682A\u5F0F\u4F1A\u793EKEiKA1"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u8CAC\u4EFB\u8005\u540D")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u5C3E\u5CF6\u6842\u9999"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u696D\u8005\u306E\u4F4F\u6240")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "30px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u6771\u4EAC\u90FD\u6E0B\u8C37\u533A\u4EE3\u5B98\u5C71\u753A13-8-513"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      display: "flex",
      flexDirection: "column",
      gap: 10,
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u696D\u8005\u306E\u9023\u7D61\u5148")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      whiteSpace: "pre-wrap"
    }
  }, "メールアドレス：contact@keika1.com\n電話番号：09086467996"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      width: 350,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u5546\u54C1\u4EE3\u91D1\u4EE5\u5916\u306E\u5FC5\u8981\u6599\u91D1\u30FB\u9280\u884C\u632F\u308A\u8FBC\u307F\u3067\u3054\u8CFC\u5165\u306E\u969B\u306E\u632F\u308A\u8FBC\u307F\u624B\u6570\u6599")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "\u30FB\u4EE3\u91D1\u5F15\u63DB\u3067\u3054\u8CFC\u5165\u306E\u969B\u306E\u4EE3\u5F15\u304D\u624B\u6570\u6599\u2028\u30FB\u5404\u7A2E\u6C7A\u6E08\u65B9\u6CD5\u3067\u767A\u751F\u3059\u308B\u624B\u6570\u6599"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: 197,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u7533\u3057\u8FBC\u307F\u6709\u52B9\u671F\u9650")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "\u539F\u5247\u3001\u53D7\u6CE8\u78BA\u8A8D\uFF08\u53D7\u6CE8\u78BA\u8A8D\u306E\u70BA\u306E\u81EA\u52D5\u9001\u4FE1\u30E1\u30FC\u30EB\u767A\u4FE1\uFF09\u5F8C\u30015\u65E5\u9593\u3068\u3057\u307E\u3059\u3002"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u4E0D\u826F\u54C1")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "\u5546\u54C1\u5230\u7740\u5F8C24\u6642\u9593\u4EE5\u5185\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002\u2028\u5546\u54C1\u306B\u554F\u984C\u304C\u3042\u308B\u5834\u5408\u306F\u3001\u901F\u3084\u304B\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002\u2028\u5546\u54C1\u306B\u6B20\u9665\u304C\u3042\u308B\u5834\u5408\u3092\u9664\u304D\u3001\u8FD4\u54C1\u306B\u306F\u5FDC\u3058\u304B\u306D\u307E\u3059\u306E\u3067\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8CA9\u58F2\u6570\u91CF\u3000")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "\u5404\u5546\u54C1\u30DA\u30FC\u30B8\u306B\u3066\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u5F15\u304D\u6E21\u3057\u6642\u671F")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "\u5728\u5EAB\u304C\u3042\u308B\u5834\u5408 \u30FB\u767A\u9001\u306F\u3054\u6CE8\u6587\u3092\u53D7\u3051\u3066\u304B\u30893\u55B6\u696D\u65E5\u4EE5\u5185\u306B\u767A\u9001\u3044\u305F\u3057\u307E\u3059\u3002\uFF08\u65E5\u795D\u9664\u304F\uFF09\u2028\u30FB\u4E88\u7D04\u8CA9\u58F2\u306E\u5834\u5408\u3001\u4E88\u7D04\u8CA9\u58F2\u65E5\u3088\u308A\u3054\u6CE8\u6587\u3092\u53D7\u3051\u3066\u304B\u30893\u55B6\u696D\u65E5\u4EE5\u5185\u306B\u767A\u9001\u3044\u305F\u3057\u307E\u3059\u3002\uFF08\u65E5\u795D\u9664\u304F\uFF09"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u304A\u652F\u6255\u3044")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "\u65B9\u6CD5\u9280\u884C\u632F\u8FBC\u30FB\u5404\u7A2E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      height: 282,
      display: "flex",
      flexDirection: "column",
      gap: 8,
      justifyContent: "center",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u304A\u652F\u6255\u3044\u306B\u3064\u3044\u3066")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      whiteSpace: "nowrap",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "\u30FB\u9280\u884C\u632F\u8FBC\u306E\u5834\u5408\u2028\u3054\u6CE8\u6587\u65E5\u3088\u308A5\u65E5\u4EE5\u5185\u306B\u5F53\u5E97\u6307\u5B9A\u306E\u53E3\u5EA7\u3078\u304A\u632F\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002\u20285\u65E5\u3092\u8D85\u3048\u305F\u5834\u5408\u306F\u4E00\u65E6\u30AD\u30E3\u30F3\u30BB\u30EB\u6271\u3044\u3068\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002\u2028\u518D\u5EA6\u3001\u5FA1\u6CE8\u6587\u3044\u305F\u3060\u304D\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u3057\u307E\u3059\u3002\u2028\u2028\u30FB\u4EE3\u91D1\u5F15\u63DB\u306E\u5834\u5408\u2028\u5546\u54C1\u306E\u304A\u5C4A\u3051\u6642\u306B\u3001\u914D\u9054\u54E1\u306B\u4EE3\u91D1\u306E\u304A\u652F\u6255\u3044\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      height: 151,
      display: "flex",
      flexDirection: "column",
      gap: 8,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8FD4\u54C1\u306B\u3064\u3044\u3066")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch",
      whiteSpace: "pre-wrap"
    }
  }, "以下の場合を除き、ご注文後の返品・変更・キャンセルはお受けできません。 \n商品がご注文と異なった場合や商品に欠陥がある場合、ご到着後24時間以内にご連絡いただき返送は５日以内とさせていただきます。"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 30,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      alignItems: "flex-start",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center",
      flexWrap: "nowrap",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0
    }
  }, "\u8FD4\u54C1\u9001\u6599\u3000")), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, "\u5546\u54C1\u304C\u3054\u6CE8\u6587\u3068\u7570\u306A\u3063\u305F\u5834\u5408\u3084\u5546\u54C1\u306B\u6B20\u9665\u304C\u3042\u308B\u5834\u5408\u306F\u5F53\u5E97\u8CA0\u62C5\u3068\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002"))), /*#__PURE__*/React.createElement("svg", {
    height: 1,
    viewBox: "0 -0.500 350 1",
    fill: "none",
    style: {
      position: "relative",
      height: 1,
      flexShrink: 0,
      alignSelf: "stretch"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 350 0 L 350 -0.5 L 350 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "fig-asset-aa013d03bc95047c",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 392,
      height: 47
    }
  }));
}

// Globals for scripts loaded after this file.
window.Component22__ = Component22__;
window.BASE14 = BASE14;
window.BASEBG14 = BASEBG14;
window.Component32_ = Component32_;
window.BASE13 = BASE13;
window.BASEBG15 = BASEBG15;
window.Component33_ = Component33_;
window.Footer8 = Footer8;
window.Header24 = Header24;
window.PCContract12 = PCContract12;
window.Component25_ = Component25_;
window.Footer7 = Footer7;
window.Frame554 = Frame554;
window.Header6 = Header6;
window.Under4 = Under4;
window.SPContract12 = SPContract12;